import * as ys from "react";
import ln, { createContext as nr, useContext as rr, useState as V, useCallback as Ft, useEffect as _e, useRef as bt, useMemo as dn, Fragment as _c } from "react";
import He from "@mui/material/Box";
import Ic from "@mui/material/Avatar";
import kc from "@mui/material/Menu";
import Vn from "@mui/material/MenuItem";
import Hs from "@mui/material/ListItemIcon";
import Pc from "@mui/material/Divider";
import ja from "@mui/material/IconButton";
import Mr from "@mui/material/Tooltip";
import jc from "@mui/icons-material/Person";
import Ac from "@mui/material/AppBar";
import Uc from "@mui/material/Toolbar";
import { Box as fe, CircularProgress as sr, Typography as Ze, Button as rt, Breadcrumbs as Lc, CardActionArea as Nc, Card as Br, CardContent as $r, Stack as gn, Chip as Aa, IconButton as zr, TextField as bn, FormControlLabel as Ua, Checkbox as La, Link as Zi, Alert as Gn, List as Dc, ListItemButton as Fc, ListItemText as Mc, MenuItem as Bc, Table as $c, TableHead as zc, TableRow as Ki, TableCell as $t, TableBody as qc, Divider as Hc, Dialog as xr, DialogTitle as ws, DialogContent as Cr, DialogActions as Js, Snackbar as Jc, Tooltip as Vc } from "@mui/material";
import { colors as qr, Logo as Gc } from "brand";
import { AuthProvider as Wc, useAuth as nn } from "react-oidc-context";
import { Delete as Zc, ArrowBack as Kc, Add as Yc, People as Xc, Edit as Qc } from "@mui/icons-material";
import Hr from "@mui/material/Skeleton";
import Jr from "@mui/material/Stack";
import { ThemeProvider as el, styled as cs, useColorScheme as Na } from "@mui/material/styles";
import tl from "@mui/material/CssBaseline";
import nl from "@mui/material/List";
import rl from "@mui/material/ListItem";
import sl from "@mui/material/ListItemText";
import Da from "@mui/icons-material/Home";
import Fa from "@mui/icons-material/Settings";
import il from "@mui/icons-material/ChevronLeft";
import ol from "@mui/icons-material/ChevronRight";
import { Navigate as Ma, useLocation as al } from "react-router-dom";
import Wn from "@mui/material/Typography";
import Ba from "@mui/material/Select";
import ul from "@mui/material/Switch";
import cl from "@mui/material/FormControlLabel";
import ll from "@mui/icons-material/Event";
import Vs from "@mui/material/Chip";
import dl from "@mui/icons-material/Business";
import Yi from "@mui/icons-material/AdminPanelSettings";
import { useTranslation as hl } from "i18n-fe";
import $a from "@mui/icons-material/Brightness4";
import za from "@mui/icons-material/Brightness7";
import qa from "@mui/icons-material/Logout";
import fl from "@mui/icons-material/DeleteOutline";
import pl from "@mui/icons-material/Lock";
import vl from "axios";
var Gs = { exports: {} }, kn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xi;
function ml() {
  if (Xi) return kn;
  Xi = 1;
  var e = ln, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, u, c) {
    var l, d = {}, h = null, f = null;
    c !== void 0 && (h = "" + c), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (f = u.ref);
    for (l in u) s.call(u, l) && !i.hasOwnProperty(l) && (d[l] = u[l]);
    if (a && a.defaultProps) for (l in u = a.defaultProps, u) d[l] === void 0 && (d[l] = u[l]);
    return { $$typeof: t, type: a, key: h, ref: f, props: d, _owner: r.current };
  }
  return kn.Fragment = n, kn.jsx = o, kn.jsxs = o, kn;
}
var Pn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qi;
function gl() {
  return Qi || (Qi = 1, process.env.NODE_ENV !== "production" && function() {
    var e = ln, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), w = Symbol.iterator, v = "@@iterator";
    function E(y) {
      if (y === null || typeof y != "object")
        return null;
      var U = w && y[w] || y[v];
      return typeof U == "function" ? U : null;
    }
    var B = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function N(y) {
      {
        for (var U = arguments.length, F = new Array(U > 1 ? U - 1 : 0), Y = 1; Y < U; Y++)
          F[Y - 1] = arguments[Y];
        M("error", y, F);
      }
    }
    function M(y, U, F) {
      {
        var Y = B.ReactDebugCurrentFrame, ge = Y.getStackAddendum();
        ge !== "" && (U += "%s", F = F.concat([ge]));
        var Ce = F.map(function(ce) {
          return String(ce);
        });
        Ce.unshift("Warning: " + U), Function.prototype.apply.call(console[y], console, Ce);
      }
    }
    var G = !1, Ee = !1, de = !1, Z = !1, ue = !1, je;
    je = Symbol.for("react.module.reference");
    function Je(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === s || y === i || ue || y === r || y === c || y === l || Z || y === f || G || Ee || de || typeof y == "object" && y !== null && (y.$$typeof === h || y.$$typeof === d || y.$$typeof === o || y.$$typeof === a || y.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === je || y.getModuleId !== void 0));
    }
    function $e(y, U, F) {
      var Y = y.displayName;
      if (Y)
        return Y;
      var ge = U.displayName || U.name || "";
      return ge !== "" ? F + "(" + ge + ")" : F;
    }
    function Ae(y) {
      return y.displayName || "Context";
    }
    function pe(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && N("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case s:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case r:
          return "StrictMode";
        case c:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case a:
            var U = y;
            return Ae(U) + ".Consumer";
          case o:
            var F = y;
            return Ae(F._context) + ".Provider";
          case u:
            return $e(y, y.render, "ForwardRef");
          case d:
            var Y = y.displayName || null;
            return Y !== null ? Y : pe(y.type) || "Memo";
          case h: {
            var ge = y, Ce = ge._payload, ce = ge._init;
            try {
              return pe(ce(Ce));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var xe = Object.assign, K = 0, pt, Ie, wt, Bt, ke, Oe, Ve;
    function te() {
    }
    te.__reactDisabledLog = !0;
    function vt() {
      {
        if (K === 0) {
          pt = console.log, Ie = console.info, wt = console.warn, Bt = console.error, ke = console.group, Oe = console.groupCollapsed, Ve = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: te,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        K++;
      }
    }
    function ar() {
      {
        if (K--, K === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: xe({}, y, {
              value: pt
            }),
            info: xe({}, y, {
              value: Ie
            }),
            warn: xe({}, y, {
              value: wt
            }),
            error: xe({}, y, {
              value: Bt
            }),
            group: xe({}, y, {
              value: ke
            }),
            groupCollapsed: xe({}, y, {
              value: Oe
            }),
            groupEnd: xe({}, y, {
              value: Ve
            })
          });
        }
        K < 0 && N("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ue = B.ReactCurrentDispatcher, ze;
    function mt(y, U, F) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (ge) {
            var Y = ge.stack.trim().match(/\n( *(at )?)/);
            ze = Y && Y[1] || "";
          }
        return `
` + ze + y;
      }
    }
    var jt = !1, Vt;
    {
      var At = typeof WeakMap == "function" ? WeakMap : Map;
      Vt = new At();
    }
    function Gt(y, U) {
      if (!y || jt)
        return "";
      {
        var F = Vt.get(y);
        if (F !== void 0)
          return F;
      }
      var Y;
      jt = !0;
      var ge = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ce;
      Ce = Ue.current, Ue.current = null, vt();
      try {
        if (U) {
          var ce = function() {
            throw Error();
          };
          if (Object.defineProperty(ce.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ce, []);
            } catch (lt) {
              Y = lt;
            }
            Reflect.construct(y, [], ce);
          } else {
            try {
              ce.call();
            } catch (lt) {
              Y = lt;
            }
            y.call(ce.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (lt) {
            Y = lt;
          }
          y();
        }
      } catch (lt) {
        if (lt && Y && typeof lt.stack == "string") {
          for (var ie = lt.stack.split(`
`), ot = Y.stack.split(`
`), Le = ie.length - 1, Ne = ot.length - 1; Le >= 1 && Ne >= 0 && ie[Le] !== ot[Ne]; )
            Ne--;
          for (; Le >= 1 && Ne >= 0; Le--, Ne--)
            if (ie[Le] !== ot[Ne]) {
              if (Le !== 1 || Ne !== 1)
                do
                  if (Le--, Ne--, Ne < 0 || ie[Le] !== ot[Ne]) {
                    var gt = `
` + ie[Le].replace(" at new ", " at ");
                    return y.displayName && gt.includes("<anonymous>") && (gt = gt.replace("<anonymous>", y.displayName)), typeof y == "function" && Vt.set(y, gt), gt;
                  }
                while (Le >= 1 && Ne >= 0);
              break;
            }
        }
      } finally {
        jt = !1, Ue.current = Ce, ar(), Error.prepareStackTrace = ge;
      }
      var sn = y ? y.displayName || y.name : "", Wt = sn ? mt(sn) : "";
      return typeof y == "function" && Vt.set(y, Wt), Wt;
    }
    function fs(y, U, F) {
      return Gt(y, !1);
    }
    function ic(y) {
      var U = y.prototype;
      return !!(U && U.isReactComponent);
    }
    function ur(y, U, F) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return Gt(y, ic(y));
      if (typeof y == "string")
        return mt(y);
      switch (y) {
        case c:
          return mt("Suspense");
        case l:
          return mt("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case u:
            return fs(y.render);
          case d:
            return ur(y.type, U, F);
          case h: {
            var Y = y, ge = Y._payload, Ce = Y._init;
            try {
              return ur(Ce(ge), U, F);
            } catch {
            }
          }
        }
      return "";
    }
    var In = Object.prototype.hasOwnProperty, Li = {}, Ni = B.ReactDebugCurrentFrame;
    function cr(y) {
      if (y) {
        var U = y._owner, F = ur(y.type, y._source, U ? U.type : null);
        Ni.setExtraStackFrame(F);
      } else
        Ni.setExtraStackFrame(null);
    }
    function oc(y, U, F, Y, ge) {
      {
        var Ce = Function.call.bind(In);
        for (var ce in y)
          if (Ce(y, ce)) {
            var ie = void 0;
            try {
              if (typeof y[ce] != "function") {
                var ot = Error((Y || "React class") + ": " + F + " type `" + ce + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[ce] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ot.name = "Invariant Violation", ot;
              }
              ie = y[ce](U, ce, Y, F, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Le) {
              ie = Le;
            }
            ie && !(ie instanceof Error) && (cr(ge), N("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Y || "React class", F, ce, typeof ie), cr(null)), ie instanceof Error && !(ie.message in Li) && (Li[ie.message] = !0, cr(ge), N("Failed %s type: %s", F, ie.message), cr(null));
          }
      }
    }
    var ac = Array.isArray;
    function ps(y) {
      return ac(y);
    }
    function uc(y) {
      {
        var U = typeof Symbol == "function" && Symbol.toStringTag, F = U && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return F;
      }
    }
    function cc(y) {
      try {
        return Di(y), !1;
      } catch {
        return !0;
      }
    }
    function Di(y) {
      return "" + y;
    }
    function Fi(y) {
      if (cc(y))
        return N("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", uc(y)), Di(y);
    }
    var Mi = B.ReactCurrentOwner, lc = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Bi, $i;
    function dc(y) {
      if (In.call(y, "ref")) {
        var U = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (U && U.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function hc(y) {
      if (In.call(y, "key")) {
        var U = Object.getOwnPropertyDescriptor(y, "key").get;
        if (U && U.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function fc(y, U) {
      typeof y.ref == "string" && Mi.current;
    }
    function pc(y, U) {
      {
        var F = function() {
          Bi || (Bi = !0, N("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", U));
        };
        F.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: F,
          configurable: !0
        });
      }
    }
    function vc(y, U) {
      {
        var F = function() {
          $i || ($i = !0, N("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", U));
        };
        F.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: F,
          configurable: !0
        });
      }
    }
    var mc = function(y, U, F, Y, ge, Ce, ce) {
      var ie = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: y,
        key: U,
        ref: F,
        props: ce,
        // Record the component responsible for creating this element.
        _owner: Ce
      };
      return ie._store = {}, Object.defineProperty(ie._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ie, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Y
      }), Object.defineProperty(ie, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ge
      }), Object.freeze && (Object.freeze(ie.props), Object.freeze(ie)), ie;
    };
    function gc(y, U, F, Y, ge) {
      {
        var Ce, ce = {}, ie = null, ot = null;
        F !== void 0 && (Fi(F), ie = "" + F), hc(U) && (Fi(U.key), ie = "" + U.key), dc(U) && (ot = U.ref, fc(U, ge));
        for (Ce in U)
          In.call(U, Ce) && !lc.hasOwnProperty(Ce) && (ce[Ce] = U[Ce]);
        if (y && y.defaultProps) {
          var Le = y.defaultProps;
          for (Ce in Le)
            ce[Ce] === void 0 && (ce[Ce] = Le[Ce]);
        }
        if (ie || ot) {
          var Ne = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          ie && pc(ce, Ne), ot && vc(ce, Ne);
        }
        return mc(y, ie, ot, ge, Y, Mi.current, ce);
      }
    }
    var vs = B.ReactCurrentOwner, zi = B.ReactDebugCurrentFrame;
    function rn(y) {
      if (y) {
        var U = y._owner, F = ur(y.type, y._source, U ? U.type : null);
        zi.setExtraStackFrame(F);
      } else
        zi.setExtraStackFrame(null);
    }
    var ms;
    ms = !1;
    function gs(y) {
      return typeof y == "object" && y !== null && y.$$typeof === t;
    }
    function qi() {
      {
        if (vs.current) {
          var y = pe(vs.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function bc(y) {
      return "";
    }
    var Hi = {};
    function yc(y) {
      {
        var U = qi();
        if (!U) {
          var F = typeof y == "string" ? y : y.displayName || y.name;
          F && (U = `

Check the top-level render call using <` + F + ">.");
        }
        return U;
      }
    }
    function Ji(y, U) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var F = yc(U);
        if (Hi[F])
          return;
        Hi[F] = !0;
        var Y = "";
        y && y._owner && y._owner !== vs.current && (Y = " It was passed a child from " + pe(y._owner.type) + "."), rn(y), N('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', F, Y), rn(null);
      }
    }
    function Vi(y, U) {
      {
        if (typeof y != "object")
          return;
        if (ps(y))
          for (var F = 0; F < y.length; F++) {
            var Y = y[F];
            gs(Y) && Ji(Y, U);
          }
        else if (gs(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var ge = E(y);
          if (typeof ge == "function" && ge !== y.entries)
            for (var Ce = ge.call(y), ce; !(ce = Ce.next()).done; )
              gs(ce.value) && Ji(ce.value, U);
        }
      }
    }
    function wc(y) {
      {
        var U = y.type;
        if (U == null || typeof U == "string")
          return;
        var F;
        if (typeof U == "function")
          F = U.propTypes;
        else if (typeof U == "object" && (U.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        U.$$typeof === d))
          F = U.propTypes;
        else
          return;
        if (F) {
          var Y = pe(U);
          oc(F, y.props, "prop", Y, y);
        } else if (U.PropTypes !== void 0 && !ms) {
          ms = !0;
          var ge = pe(U);
          N("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ge || "Unknown");
        }
        typeof U.getDefaultProps == "function" && !U.getDefaultProps.isReactClassApproved && N("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Sc(y) {
      {
        for (var U = Object.keys(y.props), F = 0; F < U.length; F++) {
          var Y = U[F];
          if (Y !== "children" && Y !== "key") {
            rn(y), N("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Y), rn(null);
            break;
          }
        }
        y.ref !== null && (rn(y), N("Invalid attribute `ref` supplied to `React.Fragment`."), rn(null));
      }
    }
    var Gi = {};
    function Wi(y, U, F, Y, ge, Ce) {
      {
        var ce = Je(y);
        if (!ce) {
          var ie = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (ie += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ot = bc();
          ot ? ie += ot : ie += qi();
          var Le;
          y === null ? Le = "null" : ps(y) ? Le = "array" : y !== void 0 && y.$$typeof === t ? (Le = "<" + (pe(y.type) || "Unknown") + " />", ie = " Did you accidentally export a JSX literal instead of a component?") : Le = typeof y, N("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Le, ie);
        }
        var Ne = gc(y, U, F, ge, Ce);
        if (Ne == null)
          return Ne;
        if (ce) {
          var gt = U.children;
          if (gt !== void 0)
            if (Y)
              if (ps(gt)) {
                for (var sn = 0; sn < gt.length; sn++)
                  Vi(gt[sn], y);
                Object.freeze && Object.freeze(gt);
              } else
                N("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Vi(gt, y);
        }
        if (In.call(U, "key")) {
          var Wt = pe(y), lt = Object.keys(U).filter(function(Tc) {
            return Tc !== "key";
          }), bs = lt.length > 0 ? "{key: someKey, " + lt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Gi[Wt + bs]) {
            var Oc = lt.length > 0 ? "{" + lt.join(": ..., ") + ": ...}" : "{}";
            N(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, bs, Wt, Oc, Wt), Gi[Wt + bs] = !0;
          }
        }
        return y === s ? Sc(Ne) : wc(Ne), Ne;
      }
    }
    function Rc(y, U, F) {
      return Wi(y, U, F, !0);
    }
    function xc(y, U, F) {
      return Wi(y, U, F, !1);
    }
    var Cc = xc, Ec = Rc;
    Pn.Fragment = s, Pn.jsx = Cc, Pn.jsxs = Ec;
  }()), Pn;
}
process.env.NODE_ENV === "production" ? Gs.exports = ml() : Gs.exports = gl();
var p = Gs.exports;
function bl({ menuItems: e }) {
  const [t, n] = ys.useState(null), s = !!t, r = (o) => {
    n(o.currentTarget);
  }, i = () => {
    n(null);
  };
  return /* @__PURE__ */ p.jsxs(ys.Fragment, { children: [
    /* @__PURE__ */ p.jsx(He, { sx: { display: "flex", alignItems: "center", textAlign: "center" }, children: /* @__PURE__ */ p.jsx(Mr, { title: "Account settings", children: /* @__PURE__ */ p.jsx(
      ja,
      {
        onClick: r,
        size: "small",
        sx: { ml: 2 },
        "aria-controls": s ? "account-menu" : void 0,
        "aria-haspopup": "true",
        "aria-expanded": s ? "true" : void 0,
        children: /* @__PURE__ */ p.jsx(Ic, { sx: { width: 32, height: 32 }, children: /* @__PURE__ */ p.jsx(jc, {}) })
      }
    ) }) }),
    /* @__PURE__ */ p.jsx(
      kc,
      {
        anchorEl: t,
        id: "account-menu",
        open: s,
        onClose: i,
        onClick: i,
        disableScrollLock: !0,
        slotProps: {
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0
              }
            }
          }
        },
        transformOrigin: { horizontal: "right", vertical: "top" },
        anchorOrigin: { horizontal: "right", vertical: "bottom" },
        children: e.map((o, a) => /* @__PURE__ */ p.jsxs(ys.Fragment, { children: [
          o.divider && /* @__PURE__ */ p.jsx(Pc, {}),
          o.href ? /* @__PURE__ */ p.jsxs(Vn, { component: "a", href: o.href, onClick: i, children: [
            o.icon && /* @__PURE__ */ p.jsx(Hs, { children: o.icon }),
            o.text
          ] }) : /* @__PURE__ */ p.jsxs(
            Vn,
            {
              onClick: () => {
                var u;
                (u = o.onClick) == null || u.call(o), i();
              },
              children: [
                o.icon && /* @__PURE__ */ p.jsx(Hs, { children: o.icon }),
                o.text
              ]
            }
          )
        ] }, a))
      }
    )
  ] });
}
const yl = 64, wl = ({ rightContent: e = null, brandLogo: t = null, sx: n = {} }) => /* @__PURE__ */ p.jsx(Ac, { sx: { ...n }, position: "fixed", elevation: 1, children: /* @__PURE__ */ p.jsxs(
  Uc,
  {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      pl: 0,
      minHeight: `${yl}px !important`
    },
    children: [
      t,
      /* @__PURE__ */ p.jsx(He, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: e })
    ]
  }
) }), Rv = ({ children: e, sx: t = {} }) => /* @__PURE__ */ p.jsx(
  He,
  {
    component: "footer",
    sx: {
      position: "fixed",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "56px",
      borderTop: 1,
      borderColor: "divider",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: (n) => n.zIndex.appBar,
      ...t
    },
    children: e
  }
), Sl = 64, Rl = ({ children: e }) => /* @__PURE__ */ p.jsx(
  He,
  {
    component: "main",
    sx: {
      p: "20px",
      pb: 0,
      flexGrow: 1,
      mb: "56px",
      // space for footer
      minHeight: `calc(100vh - ${Sl}px - 56px)`,
      overflow: "auto"
    },
    children: e || /* @__PURE__ */ p.jsx("div", { children: "MainContent (stub)" })
  }
), Ha = "common-fe.navRailExpanded", Ja = 72, xl = 200, Cl = () => {
  try {
    return window.localStorage.getItem(Ha) === "true";
  } catch {
    return !1;
  }
}, El = (e) => {
  try {
    window.localStorage.setItem(Ha, String(e));
  } catch {
  }
}, Va = nr({
  expanded: !1,
  width: Ja,
  toggleExpanded: () => {
  }
}), Ol = ({ children: e }) => {
  const [t, n] = V(Cl), s = Ft(() => {
    n((i) => {
      const o = !i;
      return El(o), o;
    });
  }, []), r = t ? xl : Ja;
  return /* @__PURE__ */ p.jsx(Va.Provider, { value: { expanded: t, width: r, toggleExpanded: s }, children: e });
}, Ga = () => rr(Va), Ss = 64, Tl = { xs: 2, sm: 4, md: 8 }, _l = ({ appFooterEnabled: e, children: t, appFooter: n, appBar: s, navRail: r }) => {
  const { width: i } = Ga();
  return /* @__PURE__ */ p.jsxs(He, { sx: { minHeight: "100vh", width: "100%" }, children: [
    /* @__PURE__ */ p.jsx(
      He,
      {
        sx: {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          zIndex: 1300
        },
        children: s
      }
    ),
    /* @__PURE__ */ p.jsxs(
      He,
      {
        sx: {
          display: "flex",
          flexDirection: "row",
          pt: `${Ss}px`
        },
        children: [
          r && /* @__PURE__ */ p.jsx(
            He,
            {
              sx: {
                width: i,
                flexShrink: 0,
                position: "fixed",
                height: `calc(100vh - ${Ss}px)`,
                top: Ss,
                left: 0,
                zIndex: 1200,
                transition: "width 0.15s ease"
              },
              children: r
            }
          ),
          /* @__PURE__ */ p.jsx(
            He,
            {
              sx: {
                flexGrow: 1,
                minWidth: 0,
                ml: r ? `${i}px` : 0,
                px: Tl,
                transition: "margin-left 0.15s ease"
              },
              children: /* @__PURE__ */ p.jsx(Rl, { children: t })
            }
          )
        ]
      }
    ),
    e && n
  ] });
}, xv = ({
  appFooterEnabled: e = !0,
  children: t,
  appFooter: n = null,
  appBar: s = null,
  navRail: r = null
}) => /* @__PURE__ */ p.jsx(Ol, { children: /* @__PURE__ */ p.jsx(
  _l,
  {
    appFooterEnabled: e,
    appFooter: n,
    appBar: s,
    navRail: r,
    children: t
  }
) });
function Ws({ message: e }) {
  return /* @__PURE__ */ p.jsxs(
    fe,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "background.default",
        zIndex: 13e3
        // higher than MUI modal
      },
      children: [
        /* @__PURE__ */ p.jsx(sr, { sx: { color: qr.foxOrange } }),
        e && /* @__PURE__ */ p.jsx(Ze, { variant: "h6", sx: { mt: 2 }, children: e })
      ]
    }
  );
}
function Wa(e = "") {
  return ["/", `${e}/callback`, `${e}/logout`, `${e}/logged-out`];
}
function Il(e, t = "") {
  return typeof e == "string" && e.startsWith("/") && !Wa(t).includes(e);
}
function kl(e = "") {
  return [`${e}/logout`, `${e}/logged-out`];
}
function Pl(e, t = "") {
  return kl(t).includes(e);
}
function Cv(e) {
  if (typeof e != "string" || e === "") return "";
  let t;
  try {
    t = new URL(e).pathname;
  } catch {
    return "";
  }
  const n = "/callback";
  return t.endsWith(n) ? t.slice(0, -n.length) : "";
}
function Ev({ navigateFunction: e, location: t, basename: n = "" }) {
  return _e(() => {
    const s = setTimeout(() => {
      const r = localStorage.getItem("redirect_url");
      localStorage.removeItem("redirect_url");
      const i = Il(r, n) ? r : "/";
      e(i, { replace: !0 });
    }, 500);
    return () => clearTimeout(s);
  }, [e, t, n]), /* @__PURE__ */ p.jsx(Ws, { message: "Signing you in..." });
}
let Za = !1;
function Ov() {
  Za = !0;
}
function eo() {
  return Za;
}
function jl() {
  return typeof window < "u" && !!window.Cypress;
}
async function Al({ navigate: e = () => window.location.replace("/") } = {}) {
  no(to(() => window.localStorage)), no(to(() => window.sessionStorage)), await Ll(), await Nl(), e();
}
function to(e) {
  try {
    return e();
  } catch {
    return null;
  }
}
const Ul = "oidc.";
function no(e) {
  if (e)
    try {
      const t = [];
      for (let n = 0; n < e.length; n++) {
        const s = e.key(n);
        s && s.startsWith(Ul) && t.push(s);
      }
      t.forEach((n) => e.removeItem(n));
    } catch {
    }
}
async function Ll() {
  var e, t;
  try {
    const n = await ((t = (e = navigator.serviceWorker) == null ? void 0 : e.getRegistrations) == null ? void 0 : t.call(e));
    if (!n) return;
    await Promise.all(n.map((s) => s.unregister()));
  } catch {
  }
}
async function Nl() {
  var e, t;
  try {
    const n = await ((t = (e = window.caches) == null ? void 0 : e.keys) == null ? void 0 : t.call(e));
    if (!n) return;
    await Promise.all(n.map((s) => window.caches.delete(s)));
  } catch {
  }
}
function Ka(e) {
  return e ?? (typeof __BUILD_ID__ < "u" ? __BUILD_ID__ : "dev");
}
function Dl({ error: e }) {
  const t = Ka();
  return /* @__PURE__ */ p.jsxs(
    fe,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 3,
        bgcolor: "background.default",
        zIndex: 13e3
        // higher than MUI modal, matches FullScreenLoader
      },
      children: [
        /* @__PURE__ */ p.jsx(Ze, { variant: "h6", sx: { mb: 1 }, children: "Encountering error..." }),
        /* @__PURE__ */ p.jsx(
          Ze,
          {
            "data-testid": "auth-error-message",
            variant: "body2",
            sx: { mb: 3, maxWidth: 480, fontFamily: "monospace", color: "text.secondary" },
            children: e == null ? void 0 : e.message
          }
        ),
        /* @__PURE__ */ p.jsx(
          rt,
          {
            "data-testid": "auth-error-start-over",
            variant: "contained",
            onClick: () => Al(),
            sx: { bgcolor: qr.foxOrange, "&:hover": { bgcolor: qr.foxOrange } },
            children: "Start over"
          }
        ),
        /* @__PURE__ */ p.jsxs(
          Ze,
          {
            "data-testid": "auth-error-build-id",
            variant: "caption",
            sx: { mt: 3, color: "text.secondary", fontFamily: "monospace" },
            children: [
              "Build ",
              t
            ]
          }
        )
      ]
    }
  );
}
function Fl({ children: e, basename: t = "" }) {
  var o;
  const n = nn(), s = Pl(window.location.pathname, t), r = bt(!1), i = ((o = n.error) == null ? void 0 : o.source) === "signinSilent" && !n.isAuthenticated;
  return _e(() => {
    const a = window.location.pathname;
    Wa(t).includes(a) || localStorage.setItem("redirect_url", a);
  }, [t]), _e(() => {
    var a;
    if (!n.isLoading && !n.isAuthenticated && (!n.error || i) && !eo() && !s) {
      if (!n.error && ((a = n.user) != null && a.refresh_token) && !r.current) {
        r.current = !0, n.signinSilent();
        return;
      }
      n.signinRedirect();
    }
  }, [
    n.isLoading,
    n.isAuthenticated,
    n.error,
    n,
    s,
    i
  ]), n.isLoading ? /* @__PURE__ */ p.jsx(Ws, { message: "Loading..." }) : n.error && !n.isAuthenticated && !eo() && !i ? /* @__PURE__ */ p.jsx(Dl, { error: n.error }) : !n.isAuthenticated && !s ? /* @__PURE__ */ p.jsx(Ws, { message: "Redirecting to login..." }) : e;
}
function Tv({ cognitoAuthConfig: e, basename: t = "", children: n }) {
  const s = jl() ? { ...e, automaticSilentRenew: !1, monitorSession: !1 } : e;
  return /* @__PURE__ */ p.jsx(Wc, { ...s, children: /* @__PURE__ */ p.jsx(Fl, { basename: t, children: n }) });
}
const _v = ({
  onConfirm: e,
  onCancel: t,
  confirmText: n = "Confirm",
  cancelText: s = "Cancel",
  buttonText: r = "Delete",
  buttonIcon: i = /* @__PURE__ */ p.jsx(Zc, {}),
  variant: o = "outlined",
  color: a = "error",
  size: u = "small",
  disabled: c = !1,
  "data-testid": l,
  confirmButtonTestId: d,
  cancelButtonTestId: h
}) => {
  const [f, w] = V(!1), v = () => {
    w(!0);
  }, E = () => {
    w(!1), e();
  }, B = () => {
    w(!1), t && t();
  };
  return f ? /* @__PURE__ */ p.jsxs(fe, { sx: { display: "flex", gap: 1 }, children: [
    /* @__PURE__ */ p.jsx(
      rt,
      {
        variant: "contained",
        color: a,
        size: u,
        onClick: E,
        "data-testid": d,
        children: n
      }
    ),
    /* @__PURE__ */ p.jsx(
      rt,
      {
        variant: "outlined",
        size: u,
        onClick: B,
        "data-testid": h,
        children: s
      }
    )
  ] }) : /* @__PURE__ */ p.jsx(
    rt,
    {
      variant: o,
      color: a,
      size: u,
      startIcon: i,
      onClick: v,
      disabled: c,
      "data-testid": l,
      children: r
    }
  );
};
function Iv({
  rows: e = 5,
  columns: t = 1,
  showHeader: n = !0,
  dense: s = !1,
  sx: r,
  ...i
}) {
  const o = s ? 28 : 40, a = s ? 0.75 : 1.25, u = Math.max(1, t), c = (l, d) => /* @__PURE__ */ p.jsx(Jr, { direction: "row", spacing: a, sx: { width: "100%" }, children: Array.from({ length: u }).map((h, f) => /* @__PURE__ */ p.jsx(
    Hr,
    {
      variant: "rounded",
      height: d,
      sx: { flex: 1, borderRadius: 1 }
    },
    f
  )) }, l);
  return /* @__PURE__ */ p.jsx(
    He,
    {
      role: "progressbar",
      "aria-busy": "true",
      "aria-label": "Loading",
      "data-testid": "table-skeleton",
      sx: { width: "100%", ...r },
      ...i,
      children: /* @__PURE__ */ p.jsxs(Jr, { spacing: a, children: [
        n && c("header", o * 0.7),
        Array.from({ length: Math.max(1, e) }).map(
          (l, d) => c(`row-${d}`, o)
        )
      ] })
    }
  );
}
function kv() {
  return /* @__PURE__ */ p.jsxs("div", { children: [
    "You have been logged out. ",
    /* @__PURE__ */ p.jsx("a", { href: "/", children: "Go to home" })
  ] });
}
function Pv({ navigateFunction: e }) {
  const t = nn();
  return _e(() => {
    let n = !0;
    async function s() {
      await t.removeUser(), n && e("/logged-out", { replace: !0 });
    }
    return s(), () => {
      n = !1;
    };
  }, [t, e]), /* @__PURE__ */ p.jsx("div", { children: "You have been logged out." });
}
function jv({ theme: e, children: t }) {
  return !e || typeof e != "object" ? (console.error("Invalid theme object provided to MuiThemeProvider"), t) : /* @__PURE__ */ p.jsxs(el, { theme: e, children: [
    /* @__PURE__ */ p.jsx(tl, {}),
    t
  ] });
}
const Ml = cs(He)(({ theme: e, backgroundColor: t, color: n, width: s }) => ({
  width: s,
  height: "100%",
  backgroundColor: t || e.palette.background.paper,
  color: n || e.palette.text.primary,
  borderRight: `1px solid ${e.palette.divider}`,
  display: "flex",
  flexDirection: "column",
  paddingTop: e.spacing(1),
  overflow: "hidden",
  transition: "width 0.15s ease"
})), Bl = cs(ja)(({ theme: e, backgroundColor: t, color: n }) => ({
  position: "absolute",
  top: e.spacing(1.5),
  right: 0,
  transform: "translateX(50%)",
  width: 20,
  height: 20,
  padding: 0,
  borderRadius: 4,
  backgroundColor: t || e.palette.background.paper,
  color: n || e.palette.text.primary,
  border: `1px solid ${e.palette.divider}`,
  zIndex: 1,
  "&:hover": {
    backgroundColor: t || e.palette.background.paper,
    opacity: 0.8
  }
})), Av = ({
  navItems: e,
  backgroundColor: t = "#1a1a1a",
  color: n = "inherit"
}) => {
  const { expanded: s, width: r, toggleExpanded: i } = Ga(), o = [
    {
      icon: /* @__PURE__ */ p.jsx(Da, {}),
      text: "Home",
      onClick: () => {
      }
    },
    {
      icon: /* @__PURE__ */ p.jsx(Fa, {}),
      text: "Settings",
      onClick: () => {
      }
    }
  ], a = e && e.length > 0 ? e : o;
  return /* @__PURE__ */ p.jsxs(He, { sx: { position: "relative", width: "100%", height: "100%" }, children: [
    /* @__PURE__ */ p.jsx(Ml, { backgroundColor: t, color: n, width: r, children: /* @__PURE__ */ p.jsx(nl, { sx: { width: "100%", p: 0 }, children: a.map((u, c) => {
      const l = /* @__PURE__ */ p.jsxs(
        rl,
        {
          onClick: u.onClick,
          sx: {
            flexDirection: s ? "row" : "column",
            justifyContent: s ? "flex-start" : "center",
            py: 1,
            px: s ? 2 : 0,
            gap: s ? 1.5 : 0,
            color: "inherit",
            // #582 — nav items are clickable; show the pointer (hand) cursor
            // on hover (ListItem alone doesn't imply a button cursor).
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "transparent",
              opacity: 0.8
            }
          },
          children: [
            /* @__PURE__ */ p.jsx(
              Hs,
              {
                sx: {
                  minWidth: "auto",
                  color: "inherit"
                },
                children: u.icon
              }
            ),
            s && /* @__PURE__ */ p.jsx(
              sl,
              {
                primary: u.text,
                primaryTypographyProps: {
                  variant: "caption",
                  align: "left",
                  sx: {
                    fontSize: "0.75rem",
                    color: "inherit",
                    whiteSpace: "nowrap"
                  }
                }
              }
            )
          ]
        },
        c
      );
      return s ? l : /* @__PURE__ */ p.jsx(Mr, { title: u.text, placement: "right", children: l }, c);
    }) }) }),
    /* @__PURE__ */ p.jsx(Mr, { title: s ? "Collapse navigation" : "Expand navigation", children: /* @__PURE__ */ p.jsx(
      Bl,
      {
        onClick: i,
        "aria-label": s ? "Collapse navigation" : "Expand navigation",
        backgroundColor: t,
        color: n,
        children: s ? /* @__PURE__ */ p.jsx(il, { sx: { fontSize: 14 } }) : /* @__PURE__ */ p.jsx(ol, { sx: { fontSize: 14 } })
      }
    ) })
  ] });
};
function Uv({ children: e }) {
  return nn().isAuthenticated ? e : /* @__PURE__ */ p.jsx(Ma, { to: "/callback", replace: !0 });
}
const Lv = ({
  children: e,
  maxWidth: t = 600,
  minWidth: n = 320,
  backTo: s,
  backLabel: r,
  breadcrumbs: i,
  onBack: o
}) => {
  const a = () => {
    o && o();
  };
  return /* @__PURE__ */ p.jsxs(
    fe,
    {
      maxWidth: t,
      minWidth: n,
      mt: 4,
      pb: 8,
      sx: {
        overflowX: "auto"
      },
      children: [
        /* @__PURE__ */ p.jsx(
          fe,
          {
            sx: {
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              mb: 3
            },
            children: /* @__PURE__ */ p.jsxs(fe, { sx: { display: "flex", alignItems: "center", gap: 2, flex: 1 }, children: [
              s && /* @__PURE__ */ p.jsx(
                rt,
                {
                  startIcon: /* @__PURE__ */ p.jsx(Kc, {}),
                  onClick: a,
                  variant: "outlined",
                  size: "small",
                  children: r || "Back"
                }
              ),
              i && /* @__PURE__ */ p.jsx(Lc, { separator: "", children: ln.Children.map(i, (u, c) => {
                const l = ln.Children.count(i);
                let d = "middle";
                return l === 1 ? d = "single" : c === 0 ? d = "first" : c === l - 1 && (d = "last"), ln.cloneElement(u, { position: d });
              }) })
            ] })
          }
        ),
        e
      ]
    }
  );
}, St = "12px", $l = cs(He, {
  shouldForwardProp: (e) => e !== "position"
})(({ theme: e, position: t }) => {
  const n = () => {
    switch (t) {
      case "first":
        return `polygon(0 0, 100% 0, calc(100% - ${St}) 100%, 0 100%)`;
      case "middle":
        return `polygon(${St} 0, 100% 0, calc(100% - ${St}) 100%, 0 100%)`;
      case "last":
        return `polygon(${St} 0, calc(100% - ${St}) 0, 100% 50%, calc(100% - ${St}) 100%, 0 100%)`;
      case "single":
      default:
        return `polygon(0 0, calc(100% - ${St}) 0, 100% 50%, calc(100% - ${St}) 100%, 0 100%)`;
    }
  };
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    height: "24px",
    backgroundColor: e.palette.mode === "dark" ? e.palette.grey[800] : e.palette.grey[200],
    color: e.palette.getContrastText(
      e.palette.mode === "dark" ? e.palette.grey[800] : e.palette.grey[200]
    ),
    cursor: "pointer",
    textDecoration: "none",
    clipPath: n(),
    // Nudge the items together to overlap
    marginLeft: t === "middle" || t === "last" ? `-${St}` : 0,
    // Adjust padding to make space for the clipped areas
    paddingLeft: t === "middle" || t === "last" ? `calc(${St} + ${e.spacing(1)})` : e.spacing(2),
    paddingRight: `calc(${St} + ${e.spacing(1)})`,
    "&:hover, &:focus-within": {
      backgroundColor: e.palette.mode === "dark" ? e.palette.grey[700] : e.palette.grey[300]
    }
  };
}), zl = cs(Wn)({
  whiteSpace: "nowrap",
  fontSize: "0.8125rem",
  fontWeight: 400,
  color: "inherit"
}), Nv = ({ label: e, component: t = "a", ...n }) => /* @__PURE__ */ p.jsx($l, { component: t, ...n, children: /* @__PURE__ */ p.jsx(zl, { children: e }) }), Dv = ({ onClick: e, label: t, "data-testid": n }) => /* @__PURE__ */ p.jsx(
  Nc,
  {
    onClick: e,
    sx: {
      height: "100%",
      minHeight: 140,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: (s) => s.palette.mode === "dark" ? s.palette.grey[800] : s.palette.grey[200],
      borderRadius: (s) => s.shape.borderRadius,
      padding: 2,
      "&:hover": {
        backgroundColor: (s) => s.palette.mode === "dark" ? s.palette.grey[700] : s.palette.grey[300]
      }
    },
    "data-testid": n || "new-item-card-button",
    children: /* @__PURE__ */ p.jsxs(
      fe,
      {
        sx: {
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          border: "3px dashed",
          borderColor: "grey.500",
          borderRadius: "10px",
          padding: "20px",
          color: "grey.500"
        },
        children: [
          /* @__PURE__ */ p.jsx(
            fe,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                borderRadius: "50%",
                border: "3px solid",
                borderColor: "inherit",
                mb: 1
              },
              children: /* @__PURE__ */ p.jsx(Yc, { sx: { fontSize: 32 } })
            }
          ),
          /* @__PURE__ */ p.jsx(Ze, { variant: "button", component: "span", children: t })
        ]
      }
    )
  }
), Fv = ({ title: e, icon: t, tags: n = [], onEdit: s, showEdit: r, onMembers: i, showMembers: o, "data-testid": a, editButtonTestId: u, membersButtonTestId: c }) => /* @__PURE__ */ p.jsxs(
  Br,
  {
    sx: {
      position: "relative",
      minHeight: 120,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      borderRadius: 0,
      backgroundColor: (l) => l.palette.mode === "dark" ? l.palette.grey[900] : l.palette.background.paper
    },
    "data-testid": a,
    elevation: 1,
    children: [
      /* @__PURE__ */ p.jsx($r, { sx: { pb: 1 }, children: /* @__PURE__ */ p.jsxs(fe, { sx: { display: "flex", alignItems: "center", mb: 2 }, children: [
        t && ln.cloneElement(t, { sx: { mr: 1.5, color: "text.secondary" } }),
        /* @__PURE__ */ p.jsx(Ze, { variant: "h6", component: "div", noWrap: !0, children: e })
      ] }) }),
      /* @__PURE__ */ p.jsx($r, { sx: { pt: 0, flexGrow: 1 }, children: /* @__PURE__ */ p.jsx(gn, { direction: "row", spacing: 1, children: n.map((l, d) => /* @__PURE__ */ p.jsx(
        Aa,
        {
          label: l.label,
          color: l.color || "default",
          size: l.size || "small",
          variant: "outlined"
        },
        d
      )) }) }),
      /* @__PURE__ */ p.jsxs(fe, { sx: { position: "absolute", top: 8, right: 8, display: "flex", gap: 0.5 }, children: [
        o && /* @__PURE__ */ p.jsx(
          zr,
          {
            "aria-label": `manage members for ${e}`,
            onClick: i,
            sx: {
              color: "text.secondary"
            },
            "data-testid": c,
            children: /* @__PURE__ */ p.jsx(Xc, {})
          }
        ),
        r && /* @__PURE__ */ p.jsx(
          zr,
          {
            "aria-label": `edit ${e}`,
            onClick: s,
            sx: {
              color: "text.secondary"
            },
            "data-testid": u,
            children: /* @__PURE__ */ p.jsx(Qc, {})
          }
        )
      ] })
    ]
  }
);
class Bn extends Error {
}
Bn.prototype.name = "InvalidTokenError";
function ql(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (t, n) => {
    let s = n.charCodeAt(0).toString(16).toUpperCase();
    return s.length < 2 && (s = "0" + s), "%" + s;
  }));
}
function Hl(e) {
  let t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return ql(t);
  } catch {
    return atob(t);
  }
}
function Ya(e, t) {
  if (typeof e != "string")
    throw new Bn("Invalid token specified: must be a string");
  t || (t = {});
  const n = t.header === !0 ? 0 : 1, s = e.split(".")[n];
  if (typeof s != "string")
    throw new Bn(`Invalid token specified: missing part #${n + 1}`);
  let r;
  try {
    r = Hl(s);
  } catch (i) {
    throw new Bn(`Invalid token specified: invalid base64 for part #${n + 1} (${i.message})`);
  }
  try {
    return JSON.parse(r);
  } catch (i) {
    throw new Bn(`Invalid token specified: invalid json for part #${n + 1} (${i.message})`);
  }
}
const Zs = "common-fe.activeOrgId", Jl = "426e8750-5b55-59f4-90c7-835b46d6a990", Vl = (e) => {
  const t = e.filter((n) => n.id !== Jl);
  return t.length ? t : e;
}, Gl = (e) => {
  if (!e) return !1;
  try {
    const t = Ya(e), n = t["custom:super"] ?? t.super;
    return n === "true" || n === !0;
  } catch {
    return !1;
  }
}, Xa = nr({
  orgs: [],
  activeOrgId: null,
  setActiveOrgId: () => {
  },
  loading: !1,
  error: null,
  isSuper: !1,
  orgResolved: !1
}), Wl = () => {
  try {
    return window.localStorage.getItem(Zs) || null;
  } catch {
    return null;
  }
}, Zl = (e) => {
  try {
    e ? window.localStorage.setItem(Zs, e) : window.localStorage.removeItem(Zs);
  } catch {
  }
}, Mv = ({ listOrgs: e, children: t }) => {
  var v;
  const s = (v = nn().user) == null ? void 0 : v.access_token, r = Gl(s), [i, o] = V([]), [a, u] = V(!0), [c, l] = V(null), [d, h] = V(() => Wl()), f = Ft((E) => {
    h(E), Zl(E);
  }, []);
  _e(() => {
    if (!e) {
      u(!1);
      return;
    }
    let E = !1;
    return (async () => {
      try {
        u(!0), l(null);
        const B = await e(r);
        if (E) return;
        o(Vl(Array.isArray(B) ? B : []));
      } catch (B) {
        if (E) return;
        console.error("Failed to load orgs for switcher:", B), l(B), o([]);
      } finally {
        E || u(!1);
      }
    })(), () => {
      E = !0;
    };
  }, [e, r]), _e(() => {
    if (!i.length) return;
    i.some((B) => B.id === d) || f(i[0].id);
  }, [i, d, f]);
  const w = d != null || !a;
  return /* @__PURE__ */ p.jsx(
    Xa.Provider,
    {
      value: { orgs: i, activeOrgId: d, setActiveOrgId: f, loading: a, error: c, isSuper: r, orgResolved: w },
      children: t
    }
  );
}, wi = () => rr(Xa), qt = "America/Los_Angeles", Kl = /^(?:GMT|UTC)?\s*([+-])\s*(\d{1,2})(?::?(\d{2}))?$/i, Yl = -14, Xl = 12, Rs = /* @__PURE__ */ new Map();
function Ql(e) {
  if (Rs.has(e)) return Rs.get(e);
  let t = !0;
  try {
    new Intl.DateTimeFormat("en-CA", { timeZone: e });
  } catch {
    t = !1;
  }
  return Rs.set(e, t), t;
}
function Qa(e) {
  if (typeof e != "string") return qt;
  const t = e.trim();
  if (!t) return qt;
  if (/^(?:GMT|UTC)$/i.test(t)) return "Etc/GMT";
  const n = Kl.exec(t);
  if (n) {
    const [, s, r, i] = n;
    if (i && Number(i) !== 0) return qt;
    const o = Number(r) * (s === "-" ? -1 : 1);
    return o < Yl || o > Xl ? qt : o === 0 ? "Etc/GMT" : `Etc/GMT${o < 0 ? "+" : "-"}${Math.abs(o)}`;
  }
  return Ql(t) ? t : qt;
}
function eu(e) {
  if (e instanceof Date) return Number.isNaN(e.getTime()) ? null : e;
  if (e == null) return null;
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? null : t;
}
function Bv(e, { timeZone: t = qt, seconds: n = !1 } = {}) {
  const s = eu(e);
  return s ? s.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    ...n ? { second: "2-digit" } : {},
    timeZone: Qa(t)
  }) : "";
}
function ed(e, t = qt) {
  const n = eu(e);
  return n ? new Intl.DateTimeFormat("en-CA", {
    timeZone: Qa(t),
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).format(n) : null;
}
const Ks = "common-fe.activeShowId", td = Symbol("active-show-never-loaded"), tu = nr({
  shows: [],
  allShows: [],
  activeShowId: null,
  activeShow: null,
  setActiveShowId: () => {
  },
  loading: !1,
  error: null,
  filterActive: !1,
  showAllShows: !1,
  setShowAllShows: () => {
  }
}), ro = 3, so = 24 * 60 * 60 * 1e3, xs = (e) => {
  if (typeof e != "string" || !e) return null;
  const t = /* @__PURE__ */ new Date(`${e}T00:00:00.000Z`);
  return Number.isNaN(t.getTime()) ? null : t;
}, nd = (e, { todayKey: t = ed(/* @__PURE__ */ new Date(), qt) } = {}) => {
  const n = xs(e == null ? void 0 : e.startDate), s = xs(e == null ? void 0 : e.endDate);
  if (!n || !s) return !0;
  const r = xs(t);
  if (!r) return !0;
  const i = n.getTime() - ro * so, o = s.getTime() + ro * so;
  return r.getTime() >= i && r.getTime() <= o;
}, rd = () => {
  try {
    return window.localStorage.getItem(Ks) || null;
  } catch {
    return null;
  }
}, sd = (e) => {
  try {
    e ? window.localStorage.setItem(Ks, e) : window.localStorage.removeItem(Ks);
  } catch {
  }
}, id = (e) => [...e].sort((t, n) => {
  const s = t != null && t.startDate ? new Date(t.startDate).getTime() : NaN, r = n != null && n.startDate ? new Date(n.startDate).getTime() : NaN, i = Number.isFinite(s), o = Number.isFinite(r);
  return i && o ? r - s : i ? -1 : o ? 1 : 0;
}), $v = ({
  listShows: e,
  orgId: t,
  filterActive: n = !1,
  children: s
}) => {
  const [r, i] = V([]), [o, a] = V(!0), [u, c] = V(null), [l, d] = V(() => rd()), h = bt(td), f = Ft((M) => {
    d(M), sd(M);
  }, []);
  _e(() => {
    if (!e) {
      a(!1);
      return;
    }
    let M = !1;
    return (async () => {
      try {
        a(!0);
        const G = await e();
        if (M) return;
        h.current = t, c(null), i(Array.isArray(G) ? id(G) : []);
      } catch (G) {
        if (M) return;
        console.error("Failed to load shows for switcher:", G), h.current !== t && (c(G), i([]));
      } finally {
        M || a(!1);
      }
    })(), () => {
      M = !0;
    };
  }, [e, t]);
  const [w, v] = V(!1), E = dn(() => !n || w ? r : r.filter((M) => nd(M)), [r, n, w]);
  _e(() => {
    if (!r.length || r.some((Ee) => Ee.id === l)) return;
    const G = E[0] || r[0];
    f(G.id);
  }, [r, E, l, f]);
  const B = dn(
    () => r.find((M) => M.id === l) || null,
    [r, l]
  ), N = dn(
    () => ({
      shows: E,
      allShows: r,
      activeShowId: l,
      activeShow: B,
      setActiveShowId: f,
      loading: o,
      error: u,
      filterActive: n,
      showAllShows: w,
      setShowAllShows: v
    }),
    [
      E,
      r,
      l,
      B,
      f,
      o,
      u,
      n,
      w
    ]
  );
  return /* @__PURE__ */ p.jsx(tu.Provider, { value: N, children: s });
}, od = () => rr(tu);
function nu(e, { max: t = 28, tail: n = 12 } = {}) {
  if (!e || e.length <= t) return e;
  const s = Math.max(0, t - n - 1);
  return `${e.slice(0, s)}…${e.slice(-n)}`;
}
const zv = ({ onShowChange: e }) => {
  const {
    shows: t,
    allShows: n,
    activeShowId: s,
    activeShow: r,
    setActiveShowId: i,
    loading: o,
    filterActive: a,
    showAllShows: u,
    setShowAllShows: c
  } = od();
  if (o && !n.length)
    return /* @__PURE__ */ p.jsx(
      Hr,
      {
        "data-testid": "show-switcher-loading",
        variant: "rounded",
        width: 140,
        height: 24,
        sx: { bgcolor: "rgba(255,255,255,0.18)" }
      }
    );
  if (!n || n.length === 0) return null;
  const l = (d) => {
    const h = d.target.value;
    i(h), e && e(h);
  };
  return /* @__PURE__ */ p.jsxs(
    He,
    {
      "data-testid": "show-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        /* @__PURE__ */ p.jsx(ll, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ p.jsxs(
          Ba,
          {
            value: s || "",
            onChange: l,
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Show switcher" },
            renderValue: () => {
              const d = r ? r.name || r.id : "";
              return /* @__PURE__ */ p.jsx(
                "span",
                {
                  title: d,
                  style: {
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  },
                  children: nu(d)
                }
              );
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              maxWidth: 240,
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: [
              r && !t.some((d) => d.id === r.id) && /* @__PURE__ */ p.jsx(
                Vn,
                {
                  value: r.id,
                  style: { display: "none" },
                  children: r.name || r.id
                },
                r.id
              ),
              t.map((d) => /* @__PURE__ */ p.jsx(Vn, { value: d.id, children: d.name || d.id }, d.id))
            ]
          }
        ),
        a && /* @__PURE__ */ p.jsx(
          cl,
          {
            "data-testid": "show-all-shows-toggle",
            control: /* @__PURE__ */ p.jsx(
              ul,
              {
                size: "small",
                checked: u,
                onChange: (d) => c(d.target.checked),
                inputProps: { "aria-label": "Show all past shows" },
                sx: {
                  "& .MuiSwitch-switchBase": { color: "rgba(255,255,255,0.75)" },
                  "& .MuiSwitch-switchBase.Mui-checked": { color: "#fff" },
                  "& .MuiSwitch-track": {
                    backgroundColor: "rgba(255,255,255,0.5)"
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "rgba(255,255,255,0.9)"
                  }
                }
              }
            ),
            label: "Show all past shows",
            sx: {
              color: "inherit",
              ml: 0.5,
              mr: 0,
              "& .MuiFormControlLabel-label": { fontSize: "0.75rem" }
            }
          }
        )
      ]
    }
  );
}, ru = nr({
  appNamespace: null,
  isSuper: !1,
  permissions: /* @__PURE__ */ new Set()
}), ad = (e, t) => typeof t == "string" && t.includes(":") ? t : `${e}:${t}`, ud = (e) => {
  if (!e) return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  try {
    const t = Ya(e), n = t["custom:super"] ?? t.super, s = n === "true" || n === !0, r = new Set(
      Array.isArray(t.permissions) ? t.permissions : []
    );
    return { isSuper: s, permissions: r };
  } catch {
    return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  }
}, qv = ({ appNamespace: e, children: t }) => {
  var i;
  const s = (i = nn().user) == null ? void 0 : i.access_token, r = dn(() => {
    const { isSuper: o, permissions: a } = ud(s);
    return { appNamespace: e, isSuper: o, permissions: a };
  }, [e, s]);
  return /* @__PURE__ */ p.jsx(ru.Provider, { value: r, children: t });
}, Hv = (e) => {
  const { appNamespace: t, isSuper: n, permissions: s } = rr(ru);
  return n ? !0 : s.has(ad(t, e));
}, Zn = (e) => typeof e == "string" ? e.trim() : "", su = (e) => Zn(e == null ? void 0 : e.firstName) || Zn(e == null ? void 0 : e.given_name), cd = (e) => Zn(e == null ? void 0 : e.lastName) || Zn(e == null ? void 0 : e.family_name), iu = (e) => Zn(e == null ? void 0 : e.email);
function ld(e) {
  return e ? [su(e), cd(e)].filter(Boolean).join(" ") || iu(e) : "";
}
function Jv(e) {
  return e ? su(e) || iu(e) : "";
}
const dd = (e, t) => e.length > t ? `${e.slice(0, Math.max(0, t - 1))}…` : e;
function hd({ maxEmailChars: e = 28 }) {
  var a;
  const n = ((a = nn().user) == null ? void 0 : a.profile) || {}, s = (n.given_name || "").trim(), r = ld(n), i = (n.email || "").trim(), o = s || (i ? dd(i, e) : "");
  return o ? /* @__PURE__ */ p.jsx(Mr, { title: r || i, children: /* @__PURE__ */ p.jsx(
    Wn,
    {
      variant: "body2",
      noWrap: !0,
      "data-testid": "nav-user-name",
      sx: { color: "inherit", maxWidth: 220 },
      children: o
    }
  ) }) : null;
}
const fd = ({ accountOrgsUrl: e } = {}) => {
  const { orgs: t, activeOrgId: n, setActiveOrgId: s, isSuper: r } = wi(), { t: i } = hl("common");
  return r && (!t || t.length === 0) ? /* @__PURE__ */ p.jsx(
    He,
    {
      "data-testid": "org-switcher-empty",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: /* @__PURE__ */ p.jsx(
        Vs,
        {
          ...e ? { component: "a", href: e, clickable: !0 } : {},
          size: "small",
          icon: /* @__PURE__ */ p.jsx(
            Yi,
            {
              fontSize: "small",
              sx: { color: "inherit !important" }
            }
          ),
          label: e ? i(
            "orgSwitcher.noOrgsEnabledLink",
            "No orgs enabled for switching — manage in Account"
          ) : i("orgSwitcher.noOrgsEnabled", "No orgs enabled for switching"),
          sx: {
            color: "inherit",
            bgcolor: "rgba(255, 255, 255, 0.18)",
            fontWeight: 600,
            ...e && {
              textDecoration: "underline",
              "&:hover": { bgcolor: "rgba(255, 255, 255, 0.28)" }
            }
          }
        }
      )
    }
  ) : !t || t.length <= 1 ? null : /* @__PURE__ */ p.jsxs(
    He,
    {
      "data-testid": "org-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        r && /* @__PURE__ */ p.jsx(
          Vs,
          {
            size: "small",
            "data-testid": "super-badge",
            icon: /* @__PURE__ */ p.jsx(
              Yi,
              {
                fontSize: "small",
                sx: { color: "inherit !important" }
              }
            ),
            label: "All orgs",
            sx: {
              color: "inherit",
              bgcolor: "rgba(255, 255, 255, 0.18)",
              fontWeight: 600
            }
          }
        ),
        /* @__PURE__ */ p.jsx(dl, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ p.jsx(
          Ba,
          {
            value: n || "",
            onChange: (o) => s(o.target.value),
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Organization switcher" },
            renderValue: (o) => {
              const a = t.find((c) => c.id === o), u = a ? a.name : "";
              return /* @__PURE__ */ p.jsx(
                "span",
                {
                  title: u,
                  style: {
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  },
                  children: nu(u)
                }
              );
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              maxWidth: 220,
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: t.map((o) => /* @__PURE__ */ p.jsx(Vn, { value: o.id, children: o.name }, o.id))
          }
        )
      ]
    }
  );
};
function Vv({ onLogout: e, brandLogo: t = null, accountOrgsUrl: n }) {
  var c;
  const { mode: s, setMode: r } = Na(), { orgs: i, activeOrgId: o } = wi(), a = ((c = i.find((l) => l.id === o)) == null ? void 0 : c.name) || null, u = [
    {
      icon: s === "dark" ? /* @__PURE__ */ p.jsx(za, {}) : /* @__PURE__ */ p.jsx($a, {}),
      text: s === "dark" ? "Light mode" : "Dark mode",
      onClick: () => r(s === "dark" ? "light" : "dark")
    },
    {
      icon: /* @__PURE__ */ p.jsx(qa, {}),
      text: "Sign out",
      onClick: e
    }
  ];
  return /* @__PURE__ */ p.jsx(
    wl,
    {
      sx: { backgroundColor: qr.darkGrey, color: "#fff" },
      brandLogo: t,
      rightContent: /* @__PURE__ */ p.jsxs(
        He,
        {
          "data-testid": "gate-header",
          sx: { display: "flex", alignItems: "center", gap: 1.5 },
          children: [
            /* @__PURE__ */ p.jsx(fd, { accountOrgsUrl: n }),
            a && /* @__PURE__ */ p.jsx(
              Wn,
              {
                "data-testid": "gate-active-org-name",
                variant: "body2",
                sx: { color: "inherit", opacity: 0.9, whiteSpace: "nowrap" },
                children: a
              }
            ),
            /* @__PURE__ */ p.jsx(hd, {}),
            /* @__PURE__ */ p.jsx(bl, { menuItems: u })
          ]
        }
      )
    }
  );
}
const ou = "common-fe.mockAuth", au = nr(null), pd = {
  email: "jaybill@foxvillage.com",
  displayName: "Jaybill"
};
function vd() {
  try {
    const e = localStorage.getItem(ou);
    return e ? JSON.parse(e) : { signedIn: !1, user: null };
  } catch {
    return { signedIn: !1, user: null };
  }
}
function md(e) {
  try {
    localStorage.setItem(ou, JSON.stringify(e));
  } catch {
  }
}
function Gv({ children: e, defaultUser: t = pd }) {
  const [n, s] = V(vd);
  _e(() => {
    md(n);
  }, [n]);
  const r = Ft(
    (a) => {
      s({ signedIn: !0, user: a ?? t });
    },
    [t]
  ), i = Ft(() => {
    s({ signedIn: !1, user: null });
  }, []), o = dn(
    () => ({
      isAuthenticated: n.signedIn,
      user: n.user,
      signIn: r,
      signOut: i
    }),
    [n, r, i]
  );
  return /* @__PURE__ */ p.jsx(au.Provider, { value: o, children: e });
}
function uu() {
  const e = rr(au);
  if (!e)
    throw new Error("useMockAuth must be used within a MockAuthProvider");
  return e;
}
function Wv({ children: e, loginPath: t = "/login" }) {
  const { isAuthenticated: n } = uu(), s = al();
  return n ? e : /* @__PURE__ */ p.jsx(Ma, { to: t, replace: !0, state: { from: s.pathname } });
}
const gd = "jaybill@foxvillage.com", bd = "demo-password", yd = {
  heading: "Sign in",
  subheading: "Sign in to your account.",
  emailLabel: "Email address",
  passwordLabel: "Password",
  showPassword: "Show password",
  forgotPassword: "Forgot your password?",
  submit: "Sign in",
  newUserPrompt: "New user?",
  createAccount: "Create an account"
};
function Zv({
  onSignIn: e,
  brandLogo: t,
  labels: n = {}
}) {
  const { signIn: s } = uu(), [r, i] = V(gd), [o, a] = V(bd), [u, c] = V(!1), l = { ...yd, ...n }, d = (f) => {
    f.preventDefault();
    const w = { email: r, displayName: r.split("@")[0] };
    e ? e(w) : s(w);
  }, h = t ?? Gc;
  return /* @__PURE__ */ p.jsx(
    fe,
    {
      sx: {
        minHeight: "100vh",
        width: "100%",
        bgcolor: (f) => f.palette.mode === "dark" ? "#2a2a2a" : "grey.100",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2
      },
      children: /* @__PURE__ */ p.jsxs(
        Br,
        {
          elevation: 6,
          sx: {
            width: "100%",
            maxWidth: 480,
            p: { xs: 3, sm: 5 },
            bgcolor: (f) => f.palette.mode === "dark" ? "#000" : "background.paper",
            color: (f) => f.palette.mode === "dark" ? "#fff" : "text.primary",
            borderRadius: 3
          },
          children: [
            /* @__PURE__ */ p.jsx(
              fe,
              {
                sx: {
                  display: "flex",
                  justifyContent: "center",
                  mb: 4,
                  color: "inherit"
                },
                children: /* @__PURE__ */ p.jsx(h, { style: { width: 240, height: "auto" } })
              }
            ),
            /* @__PURE__ */ p.jsx(Ze, { variant: "h4", component: "h1", fontWeight: 700, gutterBottom: !0, children: l.heading }),
            /* @__PURE__ */ p.jsx(
              Ze,
              {
                variant: "body1",
                sx: { opacity: 0.7, mb: 4 },
                children: l.subheading
              }
            ),
            /* @__PURE__ */ p.jsx(fe, { component: "form", onSubmit: d, children: /* @__PURE__ */ p.jsxs(gn, { spacing: 3, children: [
              /* @__PURE__ */ p.jsx(
                bn,
                {
                  label: l.emailLabel,
                  type: "email",
                  fullWidth: !0,
                  value: r,
                  onChange: (f) => i(f.target.value),
                  InputLabelProps: {
                    sx: { fontWeight: 600 }
                  }
                }
              ),
              /* @__PURE__ */ p.jsxs(fe, { children: [
                /* @__PURE__ */ p.jsx(
                  bn,
                  {
                    label: l.passwordLabel,
                    type: u ? "text" : "password",
                    fullWidth: !0,
                    value: o,
                    onChange: (f) => a(f.target.value),
                    InputLabelProps: {
                      sx: { fontWeight: 600 }
                    }
                  }
                ),
                /* @__PURE__ */ p.jsxs(
                  gn,
                  {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    sx: { mt: 1 },
                    children: [
                      /* @__PURE__ */ p.jsx(
                        Ua,
                        {
                          control: /* @__PURE__ */ p.jsx(
                            La,
                            {
                              size: "small",
                              checked: u,
                              onChange: (f) => c(f.target.checked),
                              sx: { color: "inherit" }
                            }
                          ),
                          label: l.showPassword
                        }
                      ),
                      /* @__PURE__ */ p.jsx(
                        Zi,
                        {
                          component: "button",
                          type: "button",
                          underline: "hover",
                          onClick: () => {
                          },
                          sx: { color: "primary.light" },
                          children: l.forgotPassword
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ p.jsx(
                rt,
                {
                  type: "submit",
                  variant: "contained",
                  fullWidth: !0,
                  size: "large",
                  sx: { py: 1.5, fontWeight: 600 },
                  children: l.submit
                }
              ),
              /* @__PURE__ */ p.jsxs(
                Ze,
                {
                  variant: "body2",
                  align: "center",
                  sx: { opacity: 0.8 },
                  children: [
                    l.newUserPrompt,
                    " ",
                    /* @__PURE__ */ p.jsx(
                      Zi,
                      {
                        component: "button",
                        type: "button",
                        underline: "hover",
                        onClick: () => {
                        },
                        sx: { color: "primary.light" },
                        children: l.createAccount
                      }
                    )
                  ]
                }
              )
            ] }) })
          ]
        }
      )
    }
  );
}
var Vr = { d: (e, t) => {
  for (var n in t) Vr.o(t, n) && !Vr.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
}, o: (e, t) => Object.prototype.hasOwnProperty.call(e, t), r: (e) => {
  typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
} }, Ys = {};
function cu(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
Vr.r(Ys), Vr.d(Ys, { hasBrowserEnv: () => Ri, hasStandardBrowserEnv: () => Md, hasStandardBrowserWebWorkerEnv: () => Bd, navigator: () => Xs, origin: () => $d });
const { toString: wd } = Object.prototype, { getPrototypeOf: Si } = Object, { iterator: Er, toStringTag: lu } = Symbol, Gr = (Cs = /* @__PURE__ */ Object.create(null), (e) => {
  const t = wd.call(e);
  return Cs[t] || (Cs[t] = t.slice(8, -1).toLowerCase());
});
var Cs;
const Et = (e) => (e = e.toLowerCase(), (t) => Gr(t) === e), ls = (e) => (t) => typeof t === e, { isArray: on } = Array, hn = ls("undefined");
function qn(e) {
  return e !== null && !hn(e) && e.constructor !== null && !hn(e.constructor) && ht(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const io = Et("ArrayBuffer"), Sd = ls("string"), ht = ls("function"), oo = ls("number"), jn = (e) => e !== null && typeof e == "object", lr = (e) => {
  if (Gr(e) !== "object") return !1;
  const t = Si(e);
  return !(t !== null && t !== Object.prototype && Object.getPrototypeOf(t) !== null || lu in e || Er in e);
}, Rd = Et("Date"), xd = Et("File"), Cd = Et("Blob"), Ed = Et("FileList"), Od = Et("URLSearchParams"), [Td, _d, Id, kd] = ["ReadableStream", "Request", "Response", "Headers"].map(Et);
function $n(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e == null) return;
  let s, r;
  if (typeof e != "object" && (e = [e]), on(e)) for (s = 0, r = e.length; s < r; s++) t.call(null, e[s], s, e);
  else {
    if (qn(e)) return;
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let a;
    for (s = 0; s < o; s++) a = i[s], t.call(null, e[a], a, e);
  }
}
function ao(e, t) {
  if (qn(e)) return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let s, r = n.length;
  for (; r-- > 0; ) if (s = n[r], t === s.toLowerCase()) return s;
  return null;
}
const Yt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, uo = (e) => !hn(e) && e !== Yt, Pd = (Es = typeof Uint8Array < "u" && Si(Uint8Array), (e) => Es && e instanceof Es);
var Es;
const jd = Et("HTMLFormElement"), co = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Ad = Et("RegExp"), lo = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), s = {};
  $n(n, (r, i) => {
    let o;
    (o = t(r, i, e)) !== !1 && (s[i] = o || r);
  }), Object.defineProperties(e, s);
}, Ud = Et("AsyncFunction"), du = (ho = typeof setImmediate == "function", fo = ht(Yt.postMessage), ho ? setImmediate : fo ? (Os = `axios@${Math.random()}`, dr = [], Yt.addEventListener("message", ({ source: e, data: t }) => {
  e === Yt && t === Os && dr.length && dr.shift()();
}, !1), (e) => {
  dr.push(e), Yt.postMessage(Os, "*");
}) : (e) => setTimeout(e));
var ho, fo, Os, dr;
const Ld = typeof queueMicrotask < "u" ? queueMicrotask.bind(Yt) : typeof process < "u" && process.nextTick || du, S = { isArray: on, isArrayBuffer: io, isBuffer: qn, isFormData: (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || ht(e.append) && ((t = Gr(e)) === "formdata" || t === "object" && ht(e.toString) && e.toString() === "[object FormData]"));
}, isArrayBufferView: function(e) {
  let t;
  return t = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && io(e.buffer), t;
}, isString: Sd, isNumber: oo, isBoolean: (e) => e === !0 || e === !1, isObject: jn, isPlainObject: lr, isEmptyObject: (e) => {
  if (!jn(e) || qn(e)) return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, isReadableStream: Td, isRequest: _d, isResponse: Id, isHeaders: kd, isUndefined: hn, isDate: Rd, isFile: xd, isBlob: Cd, isRegExp: Ad, isFunction: ht, isStream: (e) => jn(e) && ht(e.pipe), isURLSearchParams: Od, isTypedArray: Pd, isFileList: Ed, forEach: $n, merge: function e() {
  const { caseless: t, skipUndefined: n } = uo(this) && this || {}, s = {}, r = (i, o) => {
    const a = t && ao(s, o) || o;
    lr(s[a]) && lr(i) ? s[a] = e(s[a], i) : lr(i) ? s[a] = e({}, i) : on(i) ? s[a] = i.slice() : n && hn(i) || (s[a] = i);
  };
  for (let i = 0, o = arguments.length; i < o; i++) arguments[i] && $n(arguments[i], r);
  return s;
}, extend: (e, t, n, { allOwnKeys: s } = {}) => ($n(t, (r, i) => {
  n && ht(r) ? e[i] = cu(r, n) : e[i] = r;
}, { allOwnKeys: s }), e), trim: (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), stripBOM: (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), inherits: (e, t, n, s) => {
  e.prototype = Object.create(t.prototype, s), e.prototype.constructor = e, Object.defineProperty(e, "super", { value: t.prototype }), n && Object.assign(e.prototype, n);
}, toFlatObject: (e, t, n, s) => {
  let r, i, o;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (r = Object.getOwnPropertyNames(e), i = r.length; i-- > 0; ) o = r[i], s && !s(o, e, t) || a[o] || (t[o] = e[o], a[o] = !0);
    e = n !== !1 && Si(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, kindOf: Gr, kindOfTest: Et, endsWith: (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const s = e.indexOf(t, n);
  return s !== -1 && s === n;
}, toArray: (e) => {
  if (!e) return null;
  if (on(e)) return e;
  let t = e.length;
  if (!oo(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; ) n[t] = e[t];
  return n;
}, forEachEntry: (e, t) => {
  const n = (e && e[Er]).call(e);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const r = s.value;
    t.call(e, r[0], r[1]);
  }
}, matchAll: (e, t) => {
  let n;
  const s = [];
  for (; (n = e.exec(t)) !== null; ) s.push(n);
  return s;
}, isHTMLForm: jd, hasOwnProperty: co, hasOwnProp: co, reduceDescriptors: lo, freezeMethods: (e) => {
  lo(e, (t, n) => {
    if (ht(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1) return !1;
    const s = e[n];
    ht(s) && (t.enumerable = !1, "writable" in t ? t.writable = !1 : t.set || (t.set = () => {
      throw Error("Can not rewrite read-only method '" + n + "'");
    }));
  });
}, toObjectSet: (e, t) => {
  const n = {}, s = (r) => {
    r.forEach((i) => {
      n[i] = !0;
    });
  };
  return on(e) ? s(e) : s(String(e).split(t)), n;
}, toCamelCase: (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, n, s) {
  return n.toUpperCase() + s;
}), noop: () => {
}, toFiniteNumber: (e, t) => e != null && Number.isFinite(e = +e) ? e : t, findKey: ao, global: Yt, isContextDefined: uo, isSpecCompliantForm: function(e) {
  return !!(e && ht(e.append) && e[lu] === "FormData" && e[Er]);
}, toJSONObject: (e) => {
  const t = new Array(10), n = (s, r) => {
    if (jn(s)) {
      if (t.indexOf(s) >= 0) return;
      if (qn(s)) return s;
      if (!("toJSON" in s)) {
        t[r] = s;
        const i = on(s) ? [] : {};
        return $n(s, (o, a) => {
          const u = n(o, r + 1);
          !hn(u) && (i[a] = u);
        }), t[r] = void 0, i;
      }
    }
    return s;
  };
  return n(e, 0);
}, isAsyncFn: Ud, isThenable: (e) => e && (jn(e) || ht(e)) && ht(e.then) && ht(e.catch), setImmediate: du, asap: Ld, isIterable: (e) => e != null && ht(e[Er]) };
function fn(e, t, n, s, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), s && (this.request = s), r && (this.response = r, this.status = r.status ? r.status : null);
}
S.inherits(fn, Error, { toJSON: function() {
  return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: S.toJSONObject(this.config), code: this.code, status: this.status };
} });
const po = fn.prototype, vo = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((e) => {
  vo[e] = { value: e };
}), Object.defineProperties(fn, vo), Object.defineProperty(po, "isAxiosError", { value: !0 }), fn.from = (e, t, n, s, r, i) => {
  const o = Object.create(po);
  S.toFlatObject(e, o, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const a = e && e.message ? e.message : "Error", u = t == null && e ? e.code : t;
  return fn.call(o, a, u, n, s, r), e && o.cause == null && Object.defineProperty(o, "cause", { value: e, configurable: !0 }), o.name = e && e.name || "Error", i && Object.assign(o, i), o;
};
const re = fn;
function Ts(e) {
  return S.isPlainObject(e) || S.isArray(e);
}
function hu(e) {
  return S.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function mo(e, t, n) {
  return e ? e.concat(t).map(function(s, r) {
    return s = hu(s), !n && r ? "[" + s + "]" : s;
  }).join(n ? "." : "") : t;
}
const Nd = S.toFlatObject(S, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
}), Wr = function(e, t, n) {
  if (!S.isObject(e)) throw new TypeError("target must be an object");
  t = t || new FormData();
  const s = (n = S.toFlatObject(n, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(h, f) {
    return !S.isUndefined(f[h]);
  })).metaTokens, r = n.visitor || c, i = n.dots, o = n.indexes, a = (n.Blob || typeof Blob < "u" && Blob) && S.isSpecCompliantForm(t);
  if (!S.isFunction(r)) throw new TypeError("visitor must be a function");
  function u(h) {
    if (h === null) return "";
    if (S.isDate(h)) return h.toISOString();
    if (S.isBoolean(h)) return h.toString();
    if (!a && S.isBlob(h)) throw new re("Blob is not supported. Use a Buffer instead.");
    return S.isArrayBuffer(h) || S.isTypedArray(h) ? a && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function c(h, f, w) {
    let v = h;
    if (h && !w && typeof h == "object") {
      if (S.endsWith(f, "{}")) f = s ? f : f.slice(0, -2), h = JSON.stringify(h);
      else if (S.isArray(h) && function(E) {
        return S.isArray(E) && !E.some(Ts);
      }(h) || (S.isFileList(h) || S.endsWith(f, "[]")) && (v = S.toArray(h))) return f = hu(f), v.forEach(function(E, B) {
        !S.isUndefined(E) && E !== null && t.append(o === !0 ? mo([f], B, i) : o === null ? f : f + "[]", u(E));
      }), !1;
    }
    return !!Ts(h) || (t.append(mo(w, f, i), u(h)), !1);
  }
  const l = [], d = Object.assign(Nd, { defaultVisitor: c, convertValue: u, isVisitable: Ts });
  if (!S.isObject(e)) throw new TypeError("data must be an object");
  return function h(f, w) {
    if (!S.isUndefined(f)) {
      if (l.indexOf(f) !== -1) throw Error("Circular reference detected in " + w.join("."));
      l.push(f), S.forEach(f, function(v, E) {
        (!(S.isUndefined(v) || v === null) && r.call(t, v, S.isString(E) ? E.trim() : E, w, d)) === !0 && h(v, w ? w.concat(E) : [E]);
      }), l.pop();
    }
  }(e), t;
};
function go(e) {
  const t = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function fu(e, t) {
  this._pairs = [], e && Wr(e, this, t);
}
const bo = fu.prototype;
bo.append = function(e, t) {
  this._pairs.push([e, t]);
}, bo.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, go);
  } : go;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
const pu = fu;
function Dd(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function vu(e, t, n) {
  if (!t) return e;
  const s = n && n.encode || Dd;
  S.isFunction(n) && (n = { serialize: n });
  const r = n && n.serialize;
  let i;
  if (i = r ? r(t, n) : S.isURLSearchParams(t) ? t.toString() : new pu(t, n).toString(s), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
const yo = class {
  constructor() {
    this.handlers = [];
  }
  use(e, t, n) {
    return this.handlers.push({ fulfilled: e, rejected: t, synchronous: !!n && n.synchronous, runWhen: n ? n.runWhen : null }), this.handlers.length - 1;
  }
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(e) {
    S.forEach(this.handlers, function(t) {
      t !== null && e(t);
    });
  }
}, mu = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, Fd = { isBrowser: !0, classes: { URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : pu, FormData: typeof FormData < "u" ? FormData : null, Blob: typeof Blob < "u" ? Blob : null }, protocols: ["http", "https", "file", "blob", "url", "data"] }, Ri = typeof window < "u" && typeof document < "u", Xs = typeof navigator == "object" && navigator || void 0, Md = Ri && (!Xs || ["ReactNative", "NativeScript", "NS"].indexOf(Xs.product) < 0), Bd = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", $d = Ri && window.location.href || "http://localhost", st = { ...Ys, ...Fd }, gu = function(e) {
  function t(n, s, r, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), u = i >= n.length;
    return o = !o && S.isArray(r) ? r.length : o, u ? (S.hasOwnProp(r, o) ? r[o] = [r[o], s] : r[o] = s, !a) : (r[o] && S.isObject(r[o]) || (r[o] = []), t(n, s, r[o], i) && S.isArray(r[o]) && (r[o] = function(c) {
      const l = {}, d = Object.keys(c);
      let h;
      const f = d.length;
      let w;
      for (h = 0; h < f; h++) w = d[h], l[w] = c[w];
      return l;
    }(r[o])), !a);
  }
  if (S.isFormData(e) && S.isFunction(e.entries)) {
    const n = {};
    return S.forEachEntry(e, (s, r) => {
      t(function(i) {
        return S.matchAll(/\w+|\[(\w*)]/g, i).map((o) => o[0] === "[]" ? "" : o[1] || o[0]);
      }(s), r, n, 0);
    }), n;
  }
  return null;
}, xi = { transitional: mu, adapter: ["xhr", "http", "fetch"], transformRequest: [function(e, t) {
  const n = t.getContentType() || "", s = n.indexOf("application/json") > -1, r = S.isObject(e);
  if (r && S.isHTMLForm(e) && (e = new FormData(e)), S.isFormData(e)) return s ? JSON.stringify(gu(e)) : e;
  if (S.isArrayBuffer(e) || S.isBuffer(e) || S.isStream(e) || S.isFile(e) || S.isBlob(e) || S.isReadableStream(e)) return e;
  if (S.isArrayBufferView(e)) return e.buffer;
  if (S.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
  let i;
  if (r) {
    if (n.indexOf("application/x-www-form-urlencoded") > -1) return function(o, a) {
      return Wr(o, new st.classes.URLSearchParams(), { visitor: function(u, c, l, d) {
        return st.isNode && S.isBuffer(u) ? (this.append(c, u.toString("base64")), !1) : d.defaultVisitor.apply(this, arguments);
      }, ...a });
    }(e, this.formSerializer).toString();
    if ((i = S.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
      const o = this.env && this.env.FormData;
      return Wr(i ? { "files[]": e } : e, o && new o(), this.formSerializer);
    }
  }
  return r || s ? (t.setContentType("application/json", !1), function(o) {
    if (S.isString(o)) try {
      return (0, JSON.parse)(o), S.trim(o);
    } catch (a) {
      if (a.name !== "SyntaxError") throw a;
    }
    return (0, JSON.stringify)(o);
  }(e)) : e;
}], transformResponse: [function(e) {
  const t = this.transitional || xi.transitional, n = t && t.forcedJSONParsing, s = this.responseType === "json";
  if (S.isResponse(e) || S.isReadableStream(e)) return e;
  if (e && S.isString(e) && (n && !this.responseType || s)) {
    const r = !(t && t.silentJSONParsing) && s;
    try {
      return JSON.parse(e, this.parseReviver);
    } catch (i) {
      if (r)
        throw i.name === "SyntaxError" ? re.from(i, re.ERR_BAD_RESPONSE, this, null, this.response) : i;
    }
  }
  return e;
}], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: st.classes.FormData, Blob: st.classes.Blob }, validateStatus: function(e) {
  return e >= 200 && e < 300;
}, headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } } };
S.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  xi.headers[e] = {};
});
const Ci = xi, zd = S.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), wo = Symbol("internals");
function An(e) {
  return e && String(e).trim().toLowerCase();
}
function Or(e) {
  return e === !1 || e == null ? e : S.isArray(e) ? e.map(Or) : String(e);
}
function _s(e, t, n, s, r) {
  return S.isFunction(s) ? s.call(this, t, n) : (r && (t = n), S.isString(t) ? S.isString(s) ? t.indexOf(s) !== -1 : S.isRegExp(s) ? s.test(t) : void 0 : void 0);
}
let Tr = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, s) {
    const r = this;
    function i(a, u, c) {
      const l = An(u);
      if (!l) throw new Error("header name must be a non-empty string");
      const d = S.findKey(r, l);
      (!d || r[d] === void 0 || c === !0 || c === void 0 && r[d] !== !1) && (r[d || u] = Or(a));
    }
    const o = (a, u) => S.forEach(a, (c, l) => i(c, l, u));
    if (S.isPlainObject(t) || t instanceof this.constructor) o(t, n);
    else if (S.isString(t) && (t = t.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim())) o(((a) => {
      const u = {};
      let c, l, d;
      return a && a.split(`
`).forEach(function(h) {
        d = h.indexOf(":"), c = h.substring(0, d).trim().toLowerCase(), l = h.substring(d + 1).trim(), !c || u[c] && zd[c] || (c === "set-cookie" ? u[c] ? u[c].push(l) : u[c] = [l] : u[c] = u[c] ? u[c] + ", " + l : l);
      }), u;
    })(t), n);
    else if (S.isObject(t) && S.isIterable(t)) {
      let a, u, c = {};
      for (const l of t) {
        if (!S.isArray(l)) throw TypeError("Object iterator must return a key-value pair");
        c[u = l[0]] = (a = c[u]) ? S.isArray(a) ? [...a, l[1]] : [a, l[1]] : l[1];
      }
      o(c, n);
    } else t != null && i(n, t, s);
    return this;
  }
  get(t, n) {
    if (t = An(t)) {
      const s = S.findKey(this, t);
      if (s) {
        const r = this[s];
        if (!n) return r;
        if (n === !0) return function(i) {
          const o = /* @__PURE__ */ Object.create(null), a = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
          let u;
          for (; u = a.exec(i); ) o[u[1]] = u[2];
          return o;
        }(r);
        if (S.isFunction(n)) return n.call(this, r, s);
        if (S.isRegExp(n)) return n.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = An(t)) {
      const s = S.findKey(this, t);
      return !(!s || this[s] === void 0 || n && !_s(0, this[s], s, n));
    }
    return !1;
  }
  delete(t, n) {
    const s = this;
    let r = !1;
    function i(o) {
      if (o = An(o)) {
        const a = S.findKey(s, o);
        !a || n && !_s(0, s[a], a, n) || (delete s[a], r = !0);
      }
    }
    return S.isArray(t) ? t.forEach(i) : i(t), r;
  }
  clear(t) {
    const n = Object.keys(this);
    let s = n.length, r = !1;
    for (; s--; ) {
      const i = n[s];
      t && !_s(0, this[i], i, t, !0) || (delete this[i], r = !0);
    }
    return r;
  }
  normalize(t) {
    const n = this, s = {};
    return S.forEach(this, (r, i) => {
      const o = S.findKey(s, i);
      if (o) return n[o] = Or(r), void delete n[i];
      const a = t ? function(u) {
        return u.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (c, l, d) => l.toUpperCase() + d);
      }(i) : String(i).trim();
      a !== i && delete n[i], n[a] = Or(r), s[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return S.forEach(this, (s, r) => {
      s != null && s !== !1 && (n[r] = t && S.isArray(s) ? s.join(", ") : s);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const s = new this(t);
    return n.forEach((r) => s.set(r)), s;
  }
  static accessor(t) {
    const n = (this[wo] = this[wo] = { accessors: {} }).accessors, s = this.prototype;
    function r(i) {
      const o = An(i);
      n[o] || (function(a, u) {
        const c = S.toCamelCase(" " + u);
        ["get", "set", "has"].forEach((l) => {
          Object.defineProperty(a, l + c, { value: function(d, h, f) {
            return this[l].call(this, u, d, h, f);
          }, configurable: !0 });
        });
      }(s, i), n[o] = !0);
    }
    return S.isArray(t) ? t.forEach(r) : r(t), this;
  }
};
Tr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), S.reduceDescriptors(Tr.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return { get: () => e, set(s) {
    this[n] = s;
  } };
}), S.freezeMethods(Tr);
const xt = Tr;
function Is(e, t) {
  const n = this || Ci, s = t || n, r = xt.from(s.headers);
  let i = s.data;
  return S.forEach(e, function(o) {
    i = o.call(n, i, r.normalize(), t ? t.status : void 0);
  }), r.normalize(), i;
}
function bu(e) {
  return !(!e || !e.__CANCEL__);
}
function yu(e, t, n) {
  re.call(this, e ?? "canceled", re.ERR_CANCELED, t, n), this.name = "CanceledError";
}
S.inherits(yu, re, { __CANCEL__: !0 });
const ir = yu;
function wu(e, t, n) {
  const s = n.config.validateStatus;
  n.status && s && !s(n.status) ? t(new re("Request failed with status code " + n.status, [re.ERR_BAD_REQUEST, re.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : e(n);
}
const Zr = (e, t, n = 3) => {
  let s = 0;
  const r = function(i, o) {
    i = i || 10;
    const a = new Array(i), u = new Array(i);
    let c, l = 0, d = 0;
    return o = o !== void 0 ? o : 1e3, function(h) {
      const f = Date.now(), w = u[d];
      c || (c = f), a[l] = h, u[l] = f;
      let v = d, E = 0;
      for (; v !== l; ) E += a[v++], v %= i;
      if (l = (l + 1) % i, l === d && (d = (d + 1) % i), f - c < o) return;
      const B = w && f - w;
      return B ? Math.round(1e3 * E / B) : void 0;
    };
  }(50, 250);
  return function(i, o) {
    let a, u, c = 0, l = 1e3 / o;
    const d = (h, f = Date.now()) => {
      c = f, a = null, u && (clearTimeout(u), u = null), i(...h);
    };
    return [(...h) => {
      const f = Date.now(), w = f - c;
      w >= l ? d(h, f) : (a = h, u || (u = setTimeout(() => {
        u = null, d(a);
      }, l - w)));
    }, () => a && d(a)];
  }((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, u = o - s, c = r(u);
    s = o, e({ loaded: o, total: a, progress: a ? o / a : void 0, bytes: u, rate: c || void 0, estimated: c && a && o <= a ? (a - o) / c : void 0, event: i, lengthComputable: a != null, [t ? "download" : "upload"]: !0 });
  }, n);
}, So = (e, t) => {
  const n = e != null;
  return [(s) => t[0]({ lengthComputable: n, total: e, loaded: s }), t[1]];
}, Ro = (e) => (...t) => S.asap(() => e(...t)), qd = st.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, st.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(new URL(st.origin), st.navigator && /(msie|trident)/i.test(st.navigator.userAgent)) : () => !0, Hd = st.hasStandardBrowserEnv ? { write(e, t, n, s, r, i, o) {
  if (typeof document > "u") return;
  const a = [`${e}=${encodeURIComponent(t)}`];
  S.isNumber(n) && a.push(`expires=${new Date(n).toUTCString()}`), S.isString(s) && a.push(`path=${s}`), S.isString(r) && a.push(`domain=${r}`), i === !0 && a.push("secure"), S.isString(o) && a.push(`SameSite=${o}`), document.cookie = a.join("; ");
}, read(e) {
  if (typeof document > "u") return null;
  const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
  return t ? decodeURIComponent(t[1]) : null;
}, remove(e) {
  this.write(e, "", Date.now() - 864e5, "/");
} } : { write() {
}, read: () => null, remove() {
} };
function Su(e, t, n) {
  let s = !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
  return e && (s || n == 0) ? function(r, i) {
    return i ? r.replace(/\/?\/$/, "") + "/" + i.replace(/^\/+/, "") : r;
  }(e, t) : t;
}
const xo = (e) => e instanceof xt ? { ...e } : e;
function Qt(e, t) {
  t = t || {};
  const n = {};
  function s(c, l, d, h) {
    return S.isPlainObject(c) && S.isPlainObject(l) ? S.merge.call({ caseless: h }, c, l) : S.isPlainObject(l) ? S.merge({}, l) : S.isArray(l) ? l.slice() : l;
  }
  function r(c, l, d, h) {
    return S.isUndefined(l) ? S.isUndefined(c) ? void 0 : s(void 0, c, 0, h) : s(c, l, 0, h);
  }
  function i(c, l) {
    if (!S.isUndefined(l)) return s(void 0, l);
  }
  function o(c, l) {
    return S.isUndefined(l) ? S.isUndefined(c) ? void 0 : s(void 0, c) : s(void 0, l);
  }
  function a(c, l, d) {
    return d in t ? s(c, l) : d in e ? s(void 0, c) : void 0;
  }
  const u = { url: i, method: i, data: i, baseURL: o, transformRequest: o, transformResponse: o, paramsSerializer: o, timeout: o, timeoutMessage: o, withCredentials: o, withXSRFToken: o, adapter: o, responseType: o, xsrfCookieName: o, xsrfHeaderName: o, onUploadProgress: o, onDownloadProgress: o, decompress: o, maxContentLength: o, maxBodyLength: o, beforeRedirect: o, transport: o, httpAgent: o, httpsAgent: o, cancelToken: o, socketPath: o, responseEncoding: o, validateStatus: a, headers: (c, l, d) => r(xo(c), xo(l), 0, !0) };
  return S.forEach(Object.keys({ ...e, ...t }), function(c) {
    const l = u[c] || r, d = l(e[c], t[c], c);
    S.isUndefined(d) && l !== a || (n[c] = d);
  }), n;
}
const Ru = (e) => {
  const t = Qt({}, e);
  let { data: n, withXSRFToken: s, xsrfHeaderName: r, xsrfCookieName: i, headers: o, auth: a } = t;
  if (t.headers = o = xt.from(o), t.url = vu(Su(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), a && o.set("Authorization", "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))), S.isFormData(n)) {
    if (st.hasStandardBrowserEnv || st.hasStandardBrowserWebWorkerEnv) o.setContentType(void 0);
    else if (S.isFunction(n.getHeaders)) {
      const u = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(u).forEach(([l, d]) => {
        c.includes(l.toLowerCase()) && o.set(l, d);
      });
    }
  }
  if (st.hasStandardBrowserEnv && (s && S.isFunction(s) && (s = s(t)), s || s !== !1 && qd(t.url))) {
    const u = r && i && Hd.read(i);
    u && o.set(r, u);
  }
  return t;
}, Jd = typeof XMLHttpRequest < "u" && function(e) {
  return new Promise(function(t, n) {
    const s = Ru(e);
    let r = s.data;
    const i = xt.from(s.headers).normalize();
    let o, a, u, c, l, { responseType: d, onUploadProgress: h, onDownloadProgress: f } = s;
    function w() {
      c && c(), l && l(), s.cancelToken && s.cancelToken.unsubscribe(o), s.signal && s.signal.removeEventListener("abort", o);
    }
    let v = new XMLHttpRequest();
    function E() {
      if (!v) return;
      const N = xt.from("getAllResponseHeaders" in v && v.getAllResponseHeaders());
      wu(function(M) {
        t(M), w();
      }, function(M) {
        n(M), w();
      }, { data: d && d !== "text" && d !== "json" ? v.response : v.responseText, status: v.status, statusText: v.statusText, headers: N, config: e, request: v }), v = null;
    }
    v.open(s.method.toUpperCase(), s.url, !0), v.timeout = s.timeout, "onloadend" in v ? v.onloadend = E : v.onreadystatechange = function() {
      v && v.readyState === 4 && (v.status !== 0 || v.responseURL && v.responseURL.indexOf("file:") === 0) && setTimeout(E);
    }, v.onabort = function() {
      v && (n(new re("Request aborted", re.ECONNABORTED, e, v)), v = null);
    }, v.onerror = function(N) {
      const M = N && N.message ? N.message : "Network Error", G = new re(M, re.ERR_NETWORK, e, v);
      G.event = N || null, n(G), v = null;
    }, v.ontimeout = function() {
      let N = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const M = s.transitional || mu;
      s.timeoutErrorMessage && (N = s.timeoutErrorMessage), n(new re(N, M.clarifyTimeoutError ? re.ETIMEDOUT : re.ECONNABORTED, e, v)), v = null;
    }, r === void 0 && i.setContentType(null), "setRequestHeader" in v && S.forEach(i.toJSON(), function(N, M) {
      v.setRequestHeader(M, N);
    }), S.isUndefined(s.withCredentials) || (v.withCredentials = !!s.withCredentials), d && d !== "json" && (v.responseType = s.responseType), f && ([u, l] = Zr(f, !0), v.addEventListener("progress", u)), h && v.upload && ([a, c] = Zr(h), v.upload.addEventListener("progress", a), v.upload.addEventListener("loadend", c)), (s.cancelToken || s.signal) && (o = (N) => {
      v && (n(!N || N.type ? new ir(null, e, v) : N), v.abort(), v = null);
    }, s.cancelToken && s.cancelToken.subscribe(o), s.signal && (s.signal.aborted ? o() : s.signal.addEventListener("abort", o)));
    const B = function(N) {
      const M = /^([-+\w]{1,25})(:?\/\/|:)/.exec(N);
      return M && M[1] || "";
    }(s.url);
    B && st.protocols.indexOf(B) === -1 ? n(new re("Unsupported protocol " + B + ":", re.ERR_BAD_REQUEST, e)) : v.send(r || null);
  });
}, Vd = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let s, r = new AbortController();
    const i = function(c) {
      if (!s) {
        s = !0, a();
        const l = c instanceof Error ? c : this.reason;
        r.abort(l instanceof re ? l : new ir(l instanceof Error ? l.message : l));
      }
    };
    let o = t && setTimeout(() => {
      o = null, i(new re(`timeout ${t} of ms exceeded`, re.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", i));
    const { signal: u } = r;
    return u.unsubscribe = () => S.asap(a), u;
  }
}, Gd = function* (e, t) {
  let n = e.byteLength;
  if (n < t) return void (yield e);
  let s, r = 0;
  for (; r < n; ) s = r + t, yield e.slice(r, s), r = s;
}, Co = (e, t, n, s) => {
  const r = async function* (u, c) {
    for await (const l of async function* (d) {
      if (d[Symbol.asyncIterator]) return void (yield* d);
      const h = d.getReader();
      try {
        for (; ; ) {
          const { done: f, value: w } = await h.read();
          if (f) break;
          yield w;
        }
      } finally {
        await h.cancel();
      }
    }(u)) yield* Gd(l, c);
  }(e, t);
  let i, o = 0, a = (u) => {
    i || (i = !0, s && s(u));
  };
  return new ReadableStream({ async pull(u) {
    try {
      const { done: c, value: l } = await r.next();
      if (c) return a(), void u.close();
      let d = l.byteLength;
      if (n) {
        let h = o += d;
        n(h);
      }
      u.enqueue(new Uint8Array(l));
    } catch (c) {
      throw a(c), c;
    }
  }, cancel: (u) => (a(u), r.return()) }, { highWaterMark: 2 });
}, { isFunction: hr } = S, Wd = (({ Request: e, Response: t }) => ({ Request: e, Response: t }))(S.global), { ReadableStream: Eo, TextEncoder: Oo } = S.global, To = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Zd = (e) => {
  e = S.merge.call({ skipUndefined: !0 }, Wd, e);
  const { fetch: t, Request: n, Response: s } = e, r = t ? hr(t) : typeof fetch == "function", i = hr(n), o = hr(s);
  if (!r) return !1;
  const a = r && hr(Eo), u = r && (typeof Oo == "function" ? (c = new Oo(), (f) => c.encode(f)) : async (f) => new Uint8Array(await new n(f).arrayBuffer()));
  var c;
  const l = i && a && To(() => {
    let f = !1;
    const w = new n(st.origin, { body: new Eo(), method: "POST", get duplex() {
      return f = !0, "half";
    } }).headers.has("Content-Type");
    return f && !w;
  }), d = o && a && To(() => S.isReadableStream(new s("").body)), h = { stream: d && ((f) => f.body) };
  return r && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((f) => {
    !h[f] && (h[f] = (w, v) => {
      let E = w && w[f];
      if (E) return E.call(w);
      throw new re(`Response type '${f}' is not supported`, re.ERR_NOT_SUPPORT, v);
    });
  }), async (f) => {
    let { url: w, method: v, data: E, signal: B, cancelToken: N, timeout: M, onDownloadProgress: G, onUploadProgress: Ee, responseType: de, headers: Z, withCredentials: ue = "same-origin", fetchOptions: je } = Ru(f), Je = t || fetch;
    de = de ? (de + "").toLowerCase() : "text";
    let $e = Vd([B, N && N.toAbortSignal()], M), Ae = null;
    const pe = $e && $e.unsubscribe && (() => {
      $e.unsubscribe();
    });
    let xe;
    try {
      if (Ee && l && v !== "get" && v !== "head" && (xe = await (async (ke, Oe) => {
        const Ve = S.toFiniteNumber(ke.getContentLength());
        return Ve ?? (async (te) => te == null ? 0 : S.isBlob(te) ? te.size : S.isSpecCompliantForm(te) ? (await new n(st.origin, { method: "POST", body: te }).arrayBuffer()).byteLength : S.isArrayBufferView(te) || S.isArrayBuffer(te) ? te.byteLength : (S.isURLSearchParams(te) && (te += ""), S.isString(te) ? (await u(te)).byteLength : void 0))(Oe);
      })(Z, E)) !== 0) {
        let ke, Oe = new n(w, { method: "POST", body: E, duplex: "half" });
        if (S.isFormData(E) && (ke = Oe.headers.get("content-type")) && Z.setContentType(ke), Oe.body) {
          const [Ve, te] = So(xe, Zr(Ro(Ee)));
          E = Co(Oe.body, 65536, Ve, te);
        }
      }
      S.isString(ue) || (ue = ue ? "include" : "omit");
      const K = i && "credentials" in n.prototype, pt = { ...je, signal: $e, method: v.toUpperCase(), headers: Z.normalize().toJSON(), body: E, duplex: "half", credentials: K ? ue : void 0 };
      Ae = i && new n(w, pt);
      let Ie = await (i ? Je(Ae, je) : Je(w, pt));
      const wt = d && (de === "stream" || de === "response");
      if (d && (G || wt && pe)) {
        const ke = {};
        ["status", "statusText", "headers"].forEach((vt) => {
          ke[vt] = Ie[vt];
        });
        const Oe = S.toFiniteNumber(Ie.headers.get("content-length")), [Ve, te] = G && So(Oe, Zr(Ro(G), !0)) || [];
        Ie = new s(Co(Ie.body, 65536, Ve, () => {
          te && te(), pe && pe();
        }), ke);
      }
      de = de || "text";
      let Bt = await h[S.findKey(h, de) || "text"](Ie, f);
      return !wt && pe && pe(), await new Promise((ke, Oe) => {
        wu(ke, Oe, { data: Bt, headers: xt.from(Ie.headers), status: Ie.status, statusText: Ie.statusText, config: f, request: Ae });
      });
    } catch (K) {
      throw pe && pe(), K && K.name === "TypeError" && /Load failed|fetch/i.test(K.message) ? Object.assign(new re("Network Error", re.ERR_NETWORK, f, Ae), { cause: K.cause || K }) : re.from(K, K && K.code, f, Ae);
    }
  };
}, Kd = /* @__PURE__ */ new Map(), _o = (e) => {
  let t = e && e.env || {};
  const { fetch: n, Request: s, Response: r } = t, i = [s, r, n];
  let o, a, u = i.length, c = Kd;
  for (; u--; ) o = i[u], a = c.get(o), a === void 0 && c.set(o, a = u ? /* @__PURE__ */ new Map() : Zd(t)), c = a;
  return a;
}, xu = (_o(), { http: null, xhr: Jd, fetch: { get: _o } });
S.forEach(xu, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Io = (e) => `- ${e}`, Yd = (e) => S.isFunction(e) || e === null || e === !1, Cu = function(e, t) {
  e = S.isArray(e) ? e : [e];
  const { length: n } = e;
  let s, r;
  const i = {};
  for (let o = 0; o < n; o++) {
    let a;
    if (s = e[o], r = s, !Yd(s) && (r = xu[(a = String(s)).toLowerCase()], r === void 0)) throw new re(`Unknown adapter '${a}'`);
    if (r && (S.isFunction(r) || (r = r.get(t)))) break;
    i[a || "#" + o] = r;
  }
  if (!r) {
    const o = Object.entries(i).map(([u, c]) => `adapter ${u} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build"));
    let a = n ? o.length > 1 ? `since :
` + o.map(Io).join(`
`) : " " + Io(o[0]) : "as no adapter specified";
    throw new re("There is no suitable adapter to dispatch the request " + a, "ERR_NOT_SUPPORT");
  }
  return r;
};
function ks(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new ir(null, e);
}
function ko(e) {
  return ks(e), e.headers = xt.from(e.headers), e.data = Is.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Cu(e.adapter || Ci.adapter, e)(e).then(function(t) {
    return ks(e), t.data = Is.call(e, e.transformResponse, t), t.headers = xt.from(t.headers), t;
  }, function(t) {
    return bu(t) || (ks(e), t && t.response && (t.response.data = Is.call(e, e.transformResponse, t.response), t.response.headers = xt.from(t.response.headers))), Promise.reject(t);
  });
}
const Eu = "1.13.2", Kr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Kr[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Po = {};
Kr.transitional = function(e, t, n) {
  function s(r, i) {
    return "[Axios v" + Eu + "] Transitional option '" + r + "'" + i + (n ? ". " + n : "");
  }
  return (r, i, o) => {
    if (e === !1) throw new re(s(i, " has been removed" + (t ? " in " + t : "")), re.ERR_DEPRECATED);
    return t && !Po[i] && (Po[i] = !0, console.warn(s(i, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(r, i, o);
  };
}, Kr.spelling = function(e) {
  return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
const _r = { assertOptions: function(e, t, n) {
  if (typeof e != "object") throw new re("options must be an object", re.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(e);
  let r = s.length;
  for (; r-- > 0; ) {
    const i = s[r], o = t[i];
    if (o) {
      const a = e[i], u = a === void 0 || o(a, i, e);
      if (u !== !0) throw new re("option " + i + " must be " + u, re.ERR_BAD_OPTION_VALUE);
    } else if (n !== !0) throw new re("Unknown option " + i, re.ERR_BAD_OPTION);
  }
}, validators: Kr }, Tt = _r.validators;
class Ir {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = { request: new yo(), response: new yo() };
  }
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (s) {
      if (s instanceof Error) {
        let r = {};
        Error.captureStackTrace ? Error.captureStackTrace(r) : r = new Error();
        const i = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        try {
          s.stack ? i && !String(s.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + i) : s.stack = i;
        } catch {
        }
      }
      throw s;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}).url = t : n = t || {}, n = Qt(this.defaults, n);
    const { transitional: s, paramsSerializer: r, headers: i } = n;
    s !== void 0 && _r.assertOptions(s, { silentJSONParsing: Tt.transitional(Tt.boolean), forcedJSONParsing: Tt.transitional(Tt.boolean), clarifyTimeoutError: Tt.transitional(Tt.boolean) }, !1), r != null && (S.isFunction(r) ? n.paramsSerializer = { serialize: r } : _r.assertOptions(r, { encode: Tt.function, serialize: Tt.function }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), _r.assertOptions(n, { baseUrl: Tt.spelling("baseURL"), withXsrfToken: Tt.spelling("withXSRFToken") }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && S.merge(i.common, i[n.method]);
    i && S.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (w) => {
      delete i[w];
    }), n.headers = xt.concat(o, i);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(w) {
      typeof w.runWhen == "function" && w.runWhen(n) === !1 || (u = u && w.synchronous, a.unshift(w.fulfilled, w.rejected));
    });
    const c = [];
    let l;
    this.interceptors.response.forEach(function(w) {
      c.push(w.fulfilled, w.rejected);
    });
    let d, h = 0;
    if (!u) {
      const w = [ko.bind(this), void 0];
      for (w.unshift(...a), w.push(...c), d = w.length, l = Promise.resolve(n); h < d; ) l = l.then(w[h++], w[h++]);
      return l;
    }
    d = a.length;
    let f = n;
    for (; h < d; ) {
      const w = a[h++], v = a[h++];
      try {
        f = w(f);
      } catch (E) {
        v.call(this, E);
        break;
      }
    }
    try {
      l = ko.call(this, f);
    } catch (w) {
      return Promise.reject(w);
    }
    for (h = 0, d = c.length; h < d; ) l = l.then(c[h++], c[h++]);
    return l;
  }
  getUri(t) {
    return vu(Su((t = Qt(this.defaults, t)).baseURL, t.url, t.allowAbsoluteUrls), t.params, t.paramsSerializer);
  }
}
S.forEach(["delete", "get", "head", "options"], function(e) {
  Ir.prototype[e] = function(t, n) {
    return this.request(Qt(n || {}, { method: e, url: t, data: (n || {}).data }));
  };
}), S.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(s, r, i) {
      return this.request(Qt(i || {}, { method: e, headers: n ? { "Content-Type": "multipart/form-data" } : {}, url: s, data: r }));
    };
  }
  Ir.prototype[e] = t(), Ir.prototype[e + "Form"] = t(!0);
});
const kr = Ir;
let Xd = class Ou {
  constructor(t) {
    if (typeof t != "function") throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(r) {
      n = r;
    });
    const s = this;
    this.promise.then((r) => {
      if (!s._listeners) return;
      let i = s._listeners.length;
      for (; i-- > 0; ) s._listeners[i](r);
      s._listeners = null;
    }), this.promise.then = (r) => {
      let i;
      const o = new Promise((a) => {
        s.subscribe(a), i = a;
      }).then(r);
      return o.cancel = function() {
        s.unsubscribe(i);
      }, o;
    }, t(function(r, i, o) {
      s.reason || (s.reason = new ir(r, i, o), n(s.reason));
    });
  }
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  subscribe(t) {
    this.reason ? t(this.reason) : this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  unsubscribe(t) {
    if (!this._listeners) return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (s) => {
      t.abort(s);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  static source() {
    let t;
    return { token: new Ou(function(n) {
      t = n;
    }), cancel: t };
  }
};
const Qd = Xd, Qs = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511, WebServerIsDown: 521, ConnectionTimedOut: 522, OriginIsUnreachable: 523, TimeoutOccurred: 524, SslHandshakeFailed: 525, InvalidSslCertificate: 526 };
Object.entries(Qs).forEach(([e, t]) => {
  Qs[t] = e;
});
const eh = Qs, Fe = function e(t) {
  const n = new kr(t), s = cu(kr.prototype.request, n);
  return S.extend(s, kr.prototype, n, { allOwnKeys: !0 }), S.extend(s, n, null, { allOwnKeys: !0 }), s.create = function(r) {
    return e(Qt(t, r));
  }, s;
}(Ci);
Fe.Axios = kr, Fe.CanceledError = ir, Fe.CancelToken = Qd, Fe.isCancel = bu, Fe.VERSION = Eu, Fe.toFormData = Wr, Fe.AxiosError = re, Fe.Cancel = Fe.CanceledError, Fe.all = function(e) {
  return Promise.all(e);
}, Fe.spread = function(e) {
  return function(t) {
    return e.apply(null, t);
  };
}, Fe.isAxiosError = function(e) {
  return S.isObject(e) && e.isAxiosError === !0;
}, Fe.mergeConfig = Qt, Fe.AxiosHeaders = xt, Fe.formToJSON = (e) => gu(S.isHTMLForm(e) ? new FormData(e) : e), Fe.getAdapter = Cu, Fe.HttpStatusCode = eh, Fe.default = Fe;
const ve = Fe;
function Tu(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function ei(e, t, n) {
  return ei = Ei() ? Reflect.construct : function(s, r, i) {
    var o = [null];
    o.push.apply(o, r);
    var a = new (Function.bind.apply(s, o))();
    return i && Yn(a, i.prototype), a;
  }, ei.apply(null, arguments);
}
function Pr(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Kn(e) {
  return Kn = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Kn(e);
}
function Yn(e, t) {
  return Yn = Object.setPrototypeOf || function(n, s) {
    return n.__proto__ = s, n;
  }, Yn(e, t);
}
function ti(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return ti = function(n) {
    if (n === null || (s = n, Function.toString.call(s).indexOf("[native code]") === -1)) return n;
    var s;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n)) return t.get(n);
      t.set(n, r);
    }
    function r() {
      return ei(n, arguments, Kn(this).constructor);
    }
    return r.prototype = Object.create(n.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }), Yn(r, n);
  }, ti(e);
}
function Ei() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ei = function() {
    return !!e;
  })();
}
var me = "http://localhost".replace(/\/+$/, ""), Cn = function e(t) {
  var n, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : me, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ve;
  Tu(this, e), Pr(this, "basePath", void 0), Pr(this, "axios", void 0), Pr(this, "configuration", void 0), this.basePath = s, this.axios = r, t && (this.configuration = t, this.basePath = (n = t.basePath) !== null && n !== void 0 ? n : s);
}, th = function() {
  function e(t, n) {
    var s;
    return Tu(this, e), Pr(s = function(r, i, o) {
      return i = Kn(i), function(a, u) {
        return !u || ((c = u) && typeof Symbol < "u" && c.constructor === Symbol ? "symbol" : typeof c) != "object" && typeof u != "function" ? function(l) {
          if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return l;
        }(a) : u;
        var c;
      }(r, Ei() ? Reflect.construct(i, o || [], Kn(r).constructor) : i.apply(r, o));
    }(this, e, [n]), "field", void 0), s.field = t, s.name = "RequiredError", s;
  }
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(n && n.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), n && Yn(t, n);
  }(e, ti(Error)), e;
}(), be = {};
function jo(e, t, n, s, r, i, o) {
  try {
    var a = e[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? t(u) : Promise.resolve(u).then(s, r);
}
function nh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var ye = "https://example.com", le = function(e, t, n) {
  if (n == null) throw new th(t, "Required parameter ".concat(t, " was null or undefined when calling ").concat(e, "."));
}, Te = function(e, t) {
  return (n = function() {
    var s, r;
    return function(i, o) {
      var a, u, c, l = { label: 0, sent: function() {
        if (1 & c[0]) throw c[1];
        return c[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = h(0), d.throw = h(1), d.return = h(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function h(f) {
        return function(w) {
          return function(v) {
            if (a) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, v[0] && (l = 0)), l; ) try {
              if (a = 1, u && (c = 2 & v[0] ? u.return : v[0] ? u.throw || ((c = u.return) && c.call(u), 0) : u.next) && !(c = c.call(u, v[1])).done) return c;
              switch (u = 0, c && (v = [2 & v[0], c.value]), v[0]) {
                case 0:
                case 1:
                  c = v;
                  break;
                case 4:
                  return l.label++, { value: v[1], done: !1 };
                case 5:
                  l.label++, u = v[1], v = [0];
                  continue;
                case 7:
                  v = l.ops.pop(), l.trys.pop();
                  continue;
                default:
                  if (!((c = (c = l.trys).length > 0 && c[c.length - 1]) || v[0] !== 6 && v[0] !== 2)) {
                    l = 0;
                    continue;
                  }
                  if (v[0] === 3 && (!c || v[1] > c[0] && v[1] < c[3])) {
                    l.label = v[1];
                    break;
                  }
                  if (v[0] === 6 && l.label < c[1]) {
                    l.label = c[1], c = v;
                    break;
                  }
                  if (c && l.label < c[2]) {
                    l.label = c[2], l.ops.push(v);
                    break;
                  }
                  c[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }
              v = o.call(i, l);
            } catch (E) {
              v = [6, E], u = 0;
            } finally {
              a = c = 0;
            }
            if (5 & v[0]) throw v[1];
            return { value: v[0] ? v[1] : void 0, done: !0 };
          }([f, w]);
        };
      }
    }(this, function(i) {
      switch (i.label) {
        case 0:
          return t && t.accessToken ? typeof t.accessToken != "function" ? [3, 2] : [4, t.accessToken()] : [3, 5];
        case 1:
          return r = i.sent(), [3, 4];
        case 2:
          return [4, t.accessToken];
        case 3:
          r = i.sent(), i.label = 4;
        case 4:
          s = r, e.Authorization = "Bearer " + s, i.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var s = this, r = arguments;
    return new Promise(function(i, o) {
      var a = n.apply(s, r);
      function u(l) {
        jo(a, i, o, u, c, "next", l);
      }
      function c(l) {
        jo(a, i, o, u, c, "throw", l);
      }
      u(void 0);
    });
  })();
  var n;
};
function ni(e, t) {
  var n, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  t != null && ((t === void 0 ? "undefined" : (n = t) && typeof Symbol < "u" && n.constructor === Symbol ? "symbol" : typeof n) == "object" ? Array.isArray(t) ? t.forEach(function(r) {
    return ni(e, r, s);
  }) : Object.keys(t).forEach(function(r) {
    return ni(e, t[r], "".concat(s).concat(s !== "" ? "." : "").concat(r));
  }) : e.has(s) ? e.append(s, t) : e.set(s, t));
}
var we = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) n[s - 1] = arguments[s];
  var r = new URLSearchParams(e.search);
  ni(r, n), e.search = r.toString();
}, Rt = function(e, t, n) {
  var s = typeof e != "string";
  return (s && n && n.isJsonMime ? n.isJsonMime(t.headers["Content-Type"]) : s) ? JSON.stringify(e !== void 0 ? e : {}) : e || "";
}, Se = function(e) {
  return e.pathname + e.search + e.hash;
}, Re = function(e, t, n, s) {
  return function() {
    var r, i, o, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : t, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n, c = (i = function(l) {
      for (var d = 1; d < arguments.length; d++) {
        var h = arguments[d] != null ? arguments[d] : {}, f = Object.keys(h);
        typeof Object.getOwnPropertySymbols == "function" && (f = f.concat(Object.getOwnPropertySymbols(h).filter(function(w) {
          return Object.getOwnPropertyDescriptor(h, w).enumerable;
        }))), f.forEach(function(w) {
          nh(l, w, h[w]);
        });
      }
      return l;
    }({}, e.options), o = (o = { url: (a.defaults.baseURL ? "" : (r = s == null ? void 0 : s.basePath) !== null && r !== void 0 ? r : u) + e.url }) != null ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : function(l) {
      var d = Object.keys(l);
      if (Object.getOwnPropertySymbols) {
        var h = Object.getOwnPropertySymbols(l);
        d.push.apply(d, h);
      }
      return d;
    }(Object(o)).forEach(function(l) {
      Object.defineProperty(i, l, Object.getOwnPropertyDescriptor(o, l));
    }), i);
    return a.request(c);
  };
};
function Ao(e, t, n, s, r, i, o) {
  try {
    var a = e[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? t(u) : Promise.resolve(u).then(s, r);
}
function H(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(s, r) {
      var i = e.apply(t, n);
      function o(u) {
        Ao(i, s, r, o, a, "next", u);
      }
      function a(u) {
        Ao(i, s, r, o, a, "throw", u);
      }
      o(void 0);
    });
  };
}
function En(e, t, n) {
  return t = Yr(t), function(s, r) {
    return !r || ((i = r) && typeof Symbol < "u" && i.constructor === Symbol ? "symbol" : typeof i) != "object" && typeof r != "function" ? function(o) {
      if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return o;
    }(s) : r;
    var i;
  }(e, _u() ? Reflect.construct(t, n || [], Yr(e).constructor) : t.apply(e, n));
}
function On(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function rh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var s = t[n];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
  }
}
function Tn(e, t, n) {
  return t && rh(e.prototype, t), e;
}
function sh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Yr(e) {
  return Yr = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Yr(e);
}
function _n(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && ri(e, t);
}
function z(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, s = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (s = s.concat(Object.getOwnPropertySymbols(n).filter(function(r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    }))), s.forEach(function(r) {
      sh(e, r, n[r]);
    });
  }
  return e;
}
function ri(e, t) {
  return ri = Object.setPrototypeOf || function(n, s) {
    return n.__proto__ = s, n;
  }, ri(e, t);
}
function _u() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_u = function() {
    return !!e;
  })();
}
function J(e, t) {
  var n, s, r, i = { label: 0, sent: function() {
    if (1 & r[0]) throw r[1];
    return r[1];
  }, trys: [], ops: [] }, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return function(l) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; o && (o = 0, l[0] && (i = 0)), i; ) try {
          if (n = 1, s && (r = 2 & l[0] ? s.return : l[0] ? s.throw || ((r = s.return) && r.call(s), 0) : s.next) && !(r = r.call(s, l[1])).done) return r;
          switch (s = 0, r && (l = [2 & l[0], r.value]), l[0]) {
            case 0:
            case 1:
              r = l;
              break;
            case 4:
              return i.label++, { value: l[1], done: !1 };
            case 5:
              i.label++, s = l[1], l = [0];
              continue;
            case 7:
              l = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (!((r = (r = i.trys).length > 0 && r[r.length - 1]) || l[0] !== 6 && l[0] !== 2)) {
                i = 0;
                continue;
              }
              if (l[0] === 3 && (!r || l[1] > r[0] && l[1] < r[3])) {
                i.label = l[1];
                break;
              }
              if (l[0] === 6 && i.label < r[1]) {
                i.label = r[1], r = l;
                break;
              }
              if (r && i.label < r[2]) {
                i.label = r[2], i.ops.push(l);
                break;
              }
              r[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          l = t.call(e, i);
        } catch (d) {
          l = [6, d], s = 0;
        } finally {
          n = r = 0;
        }
        if (5 & l[0]) throw l[1];
        return { value: l[0] ? l[1] : void 0, done: !0 };
      }([u, c]);
    };
  }
}
var ih = function(e) {
  return { publicScoreSheetsConfigGet: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return H(function() {
      var n, s, r, i, o;
      return J(this, function(a) {
        return n = new URL("/public/score-sheets/config", ye), e && (s = e.baseOptions), r = z({ method: "GET" }, s, t), i = {}, we(n, {}), o = s && s.headers ? s.headers : {}, r.headers = z({}, i, o, t.headers), [2, { url: Se(n), options: r }];
      });
    })();
  }, publicScoreSheetsRequestPost: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u;
      return J(this, function(c) {
        return le("publicScoreSheetsRequestPost", "publicScoreSheetsRequestPostRequest", t), s = new URL("/public/score-sheets/request", ye), e && (r = e.baseOptions), i = z({ method: "POST" }, r, n), a = {}, (o = {})["Content-Type"] = "application/json", we(s, a), u = r && r.headers ? r.headers : {}, i.headers = z({}, o, u, n.headers), i.data = Rt(t, i, e), [2, { url: Se(s), options: i }];
      });
    })();
  }, publicScoreSheetsTokenGet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u;
      return J(this, function(c) {
        return le("publicScoreSheetsTokenGet", "token", t), s = "/public/score-sheets/{token}".replace("{token}", encodeURIComponent(String(t))), r = new URL(s, ye), e && (i = e.baseOptions), o = z({ method: "GET" }, i, n), a = {}, we(r, {}), u = i && i.headers ? i.headers : {}, o.headers = z({}, a, u, n.headers), [2, { url: Se(r), options: o }];
      });
    })();
  }, publicSheetsRequestIdRideIdVariantUrlGet: function(t, n, s) {
    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return H(function() {
      var i, o, a, u, c, l;
      return J(this, function(d) {
        return le("publicSheetsRequestIdRideIdVariantUrlGet", "requestId", t), le("publicSheetsRequestIdRideIdVariantUrlGet", "rideId", n), le("publicSheetsRequestIdRideIdVariantUrlGet", "variant", s), i = "/public/sheets/{requestId}/{rideId}/{variant}/url".replace("{requestId}", encodeURIComponent(String(t))).replace("{rideId}", encodeURIComponent(String(n))).replace("{variant}", encodeURIComponent(String(s))), o = new URL(i, ye), e && (a = e.baseOptions), u = z({ method: "GET" }, a, r), c = {}, we(o, {}), l = a && a.headers ? a.headers : {}, u.headers = z({}, c, l, r.headers), [2, { url: Se(o), options: u }];
      });
    })();
  } };
}, fr = function(e) {
  var t = ih(e);
  return { publicScoreSheetsConfigGet: function(n) {
    return H(function() {
      var s, r, i, o, a, u;
      return J(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, t.publicScoreSheetsConfigGet(n)];
          case 1:
            return i = c.sent(), a = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, u = (r = be["DefaultApi.publicScoreSheetsConfigGet"]) === null || r === void 0 || (s = r[a]) === null || s === void 0 ? void 0 : s.url, [2, function(l, d) {
              return Re(i, ve, me, e)(l, u || d);
            }];
        }
      });
    })();
  }, publicScoreSheetsRequestPost: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.publicScoreSheetsRequestPost(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["DefaultApi.publicScoreSheetsRequestPost"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  }, publicScoreSheetsTokenGet: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.publicScoreSheetsTokenGet(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["DefaultApi.publicScoreSheetsTokenGet"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  }, publicSheetsRequestIdRideIdVariantUrlGet: function(n, s, r, i) {
    return H(function() {
      var o, a, u, c, l, d;
      return J(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, t.publicSheetsRequestIdRideIdVariantUrlGet(n, s, r, i)];
          case 1:
            return u = h.sent(), l = (c = e == null ? void 0 : e.serverIndex) !== null && c !== void 0 ? c : 0, d = (a = be["DefaultApi.publicSheetsRequestIdRideIdVariantUrlGet"]) === null || a === void 0 || (o = a[l]) === null || o === void 0 ? void 0 : o.url, [2, function(f, w) {
              return Re(u, ve, me, e)(f, d || w);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return On(this, t), En(this, t, arguments);
  }
  return _n(t, e), Tn(t, [{ key: "publicScoreSheetsConfigGet", value: function(n) {
    var s = this;
    return fr(this.configuration).publicScoreSheetsConfigGet(n).then(function(r) {
      return r(s.axios, s.basePath);
    });
  } }, { key: "publicScoreSheetsRequestPost", value: function(n, s) {
    var r = this;
    return fr(this.configuration).publicScoreSheetsRequestPost(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "publicScoreSheetsTokenGet", value: function(n, s) {
    var r = this;
    return fr(this.configuration).publicScoreSheetsTokenGet(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "publicSheetsRequestIdRideIdVariantUrlGet", value: function(n, s, r, i) {
    var o = this;
    return fr(this.configuration).publicSheetsRequestIdRideIdVariantUrlGet(n, s, r, i).then(function(a) {
      return a(o.axios, o.basePath);
    });
  } }]), t;
})(Cn);
var oh = function(e) {
  return { correctUsefClass: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return H(function() {
      var r, i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return le("correctUsefClass", "classId", t), le("correctUsefClass", "uploadUsefClassRequest", n), r = "/federation/usef/classes/{classId}/correct".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, ye), e && (o = e.baseOptions), a = z({ method: "POST" }, o, s), c = {}, [4, Te(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", we(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, s.headers), a.data = Rt(n, a, e), [2, { url: Se(i), options: a }];
        }
      });
    })();
  }, deleteUsefClass: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return H(function() {
      var r, i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return le("deleteUsefClass", "classId", t), le("deleteUsefClass", "deleteUsefClassRequest", n), r = "/federation/usef/classes/{classId}/delete".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, ye), e && (o = e.baseOptions), a = z({ method: "POST" }, o, s), c = {}, [4, Te(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", we(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, s.headers), a.data = Rt(n, a, e), [2, { url: Se(i), options: a }];
        }
      });
    })();
  }, finalizeUsefClass: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return H(function() {
      var r, i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return le("finalizeUsefClass", "classId", t), le("finalizeUsefClass", "deleteUsefClassRequest", n), r = "/federation/usef/classes/{classId}/finalize".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, ye), e && (o = e.baseOptions), a = z({ method: "POST" }, o, s), c = {}, [4, Te(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", we(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, s.headers), a.data = Rt(n, a, e), [2, { url: Se(i), options: a }];
        }
      });
    })();
  }, getFederationClassAudit: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return le("getFederationClassAudit", "classId", t), s = "/federation/classes/{classId}/audit".replace("{classId}", encodeURIComponent(String(t))), r = new URL(s, ye), e && (i = e.baseOptions), o = z({ method: "GET" }, i, n), u = {}, [4, Te(a = {}, e)];
          case 1:
            return l.sent(), we(r, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(r), options: o }];
        }
      });
    })();
  }, getFederationShowAudit: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return le("getFederationShowAudit", "showId", t), s = "/federation/shows/{showId}/audit".replace("{showId}", encodeURIComponent(String(t))), r = new URL(s, ye), e && (i = e.baseOptions), o = z({ method: "GET" }, i, n), u = {}, [4, Te(a = {}, e)];
          case 1:
            return l.sent(), we(r, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(r), options: o }];
        }
      });
    })();
  }, getFederationShowState: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return le("getFederationShowState", "showId", t), s = "/federation/shows/{showId}/state".replace("{showId}", encodeURIComponent(String(t))), r = new URL(s, ye), e && (i = e.baseOptions), o = z({ method: "GET" }, i, n), u = {}, [4, Te(a = {}, e)];
          case 1:
            return l.sent(), we(r, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(r), options: o }];
        }
      });
    })();
  }, getUsefDeadlineStatus: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return le("getUsefDeadlineStatus", "competitionEndDate", t), r = new URL("/federation/usef/deadline", ye), e && (i = e.baseOptions), o = z({ method: "GET" }, i, s), u = {}, [4, Te(a = {}, e)];
          case 1:
            return l.sent(), t !== void 0 && (u.competitionEndDate = t), n !== void 0 && (u.showId = n), we(r, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, s.headers), [2, { url: Se(r), options: o }];
        }
      });
    })();
  }, listUsefDressageSections: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u;
      return J(this, function(c) {
        switch (c.label) {
          case 0:
            return le("listUsefDressageSections", "compYear", t), s = new URL("/federation/usef/sections", ye), e && (r = e.baseOptions), i = z({ method: "GET" }, r, n), a = {}, [4, Te(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.compYear = t), we(s, a), u = r && r.headers ? r.headers : {}, i.headers = z({}, o, u, n.headers), [2, { url: Se(s), options: i }];
        }
      });
    })();
  }, listUsefDressageTests: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u;
      return J(this, function(c) {
        switch (c.label) {
          case 0:
            return le("listUsefDressageTests", "testYear", t), s = new URL("/federation/usef/tests", ye), e && (r = e.baseOptions), i = z({ method: "GET" }, r, n), a = {}, [4, Te(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.testYear = t), we(s, a), u = r && r.headers ? r.headers : {}, i.headers = z({}, o, u, n.headers), [2, { url: Se(s), options: i }];
        }
      });
    })();
  }, markClassForRepublish: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return H(function() {
      var r, i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return le("markClassForRepublish", "classId", t), le("markClassForRepublish", "markClassForRepublishRequest", n), r = "/federation/usef/classes/{classId}/mark-for-republish".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, ye), e && (o = e.baseOptions), a = z({ method: "POST" }, o, s), c = {}, [4, Te(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", we(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, s.headers), a.data = Rt(n, a, e), [2, { url: Se(i), options: a }];
        }
      });
    })();
  }, previewClassResult: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return le("previewClassResult", "classId", t), s = "/federation/classes/{classId}/preview".replace("{classId}", encodeURIComponent(String(t))), r = new URL(s, ye), e && (i = e.baseOptions), o = z({ method: "GET" }, i, n), u = {}, [4, Te(a = {}, e)];
          case 1:
            return l.sent(), we(r, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(r), options: o }];
        }
      });
    })();
  }, previewShowResults: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return le("previewShowResults", "showId", t), s = "/federation/shows/{showId}/preview".replace("{showId}", encodeURIComponent(String(t))), r = new URL(s, ye), e && (i = e.baseOptions), o = z({ method: "GET" }, i, n), u = {}, [4, Te(a = {}, e)];
          case 1:
            return l.sent(), we(r, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(r), options: o }];
        }
      });
    })();
  }, publishUsdfShow: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return H(function() {
      var r, i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return le("publishUsdfShow", "showId", t), r = "/federation/usdf/shows/{showId}/publish".replace("{showId}", encodeURIComponent(String(t))), i = new URL(r, ye), e && (o = e.baseOptions), a = z({ method: "POST" }, o, s), c = {}, [4, Te(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", we(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, s.headers), a.data = Rt(n, a, e), [2, { url: Se(i), options: a }];
        }
      });
    })();
  }, publishUsefShow: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return H(function() {
      var r, i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return le("publishUsefShow", "showId", t), le("publishUsefShow", "publishUsefShowRequest", n), r = "/federation/usef/shows/{showId}/publish".replace("{showId}", encodeURIComponent(String(t))), i = new URL(r, ye), e && (o = e.baseOptions), a = z({ method: "POST" }, o, s), c = {}, [4, Te(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", we(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, s.headers), a.data = Rt(n, a, e), [2, { url: Se(i), options: a }];
        }
      });
    })();
  }, submitUsefShow: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return H(function() {
      var r, i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return le("submitUsefShow", "showId", t), le("submitUsefShow", "submitUsefShowRequest", n), r = "/federation/usef/shows/{showId}/submit".replace("{showId}", encodeURIComponent(String(t))), i = new URL(r, ye), e && (o = e.baseOptions), a = z({ method: "POST" }, o, s), c = {}, [4, Te(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", we(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, s.headers), a.data = Rt(n, a, e), [2, { url: Se(i), options: a }];
        }
      });
    })();
  }, uploadUsefClass: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return H(function() {
      var r, i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return le("uploadUsefClass", "classId", t), le("uploadUsefClass", "uploadUsefClassRequest", n), r = "/federation/usef/classes/{classId}/upload".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, ye), e && (o = e.baseOptions), a = z({ method: "POST" }, o, s), c = {}, [4, Te(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", we(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, s.headers), a.data = Rt(n, a, e), [2, { url: Se(i), options: a }];
        }
      });
    })();
  } };
}, tt = function(e) {
  var t = oh(e);
  return { correctUsefClass: function(n, s, r) {
    return H(function() {
      var i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.correctUsefClass(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.correctUsefClass"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return Re(a, ve, me, e)(h, l || f);
            }];
        }
      });
    })();
  }, deleteUsefClass: function(n, s, r) {
    return H(function() {
      var i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.deleteUsefClass(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.deleteUsefClass"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return Re(a, ve, me, e)(h, l || f);
            }];
        }
      });
    })();
  }, finalizeUsefClass: function(n, s, r) {
    return H(function() {
      var i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.finalizeUsefClass(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.finalizeUsefClass"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return Re(a, ve, me, e)(h, l || f);
            }];
        }
      });
    })();
  }, getFederationClassAudit: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getFederationClassAudit(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["FederationApi.getFederationClassAudit"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  }, getFederationShowAudit: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getFederationShowAudit(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["FederationApi.getFederationShowAudit"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  }, getFederationShowState: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getFederationShowState(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["FederationApi.getFederationShowState"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  }, getUsefDeadlineStatus: function(n, s, r) {
    return H(function() {
      var i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.getUsefDeadlineStatus(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.getUsefDeadlineStatus"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return Re(a, ve, me, e)(h, l || f);
            }];
        }
      });
    })();
  }, listUsefDressageSections: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listUsefDressageSections(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["FederationApi.listUsefDressageSections"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  }, listUsefDressageTests: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listUsefDressageTests(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["FederationApi.listUsefDressageTests"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  }, markClassForRepublish: function(n, s, r) {
    return H(function() {
      var i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.markClassForRepublish(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.markClassForRepublish"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return Re(a, ve, me, e)(h, l || f);
            }];
        }
      });
    })();
  }, previewClassResult: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.previewClassResult(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["FederationApi.previewClassResult"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  }, previewShowResults: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.previewShowResults(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["FederationApi.previewShowResults"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  }, publishUsdfShow: function(n, s, r) {
    return H(function() {
      var i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.publishUsdfShow(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.publishUsdfShow"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return Re(a, ve, me, e)(h, l || f);
            }];
        }
      });
    })();
  }, publishUsefShow: function(n, s, r) {
    return H(function() {
      var i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.publishUsefShow(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.publishUsefShow"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return Re(a, ve, me, e)(h, l || f);
            }];
        }
      });
    })();
  }, submitUsefShow: function(n, s, r) {
    return H(function() {
      var i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.submitUsefShow(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.submitUsefShow"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return Re(a, ve, me, e)(h, l || f);
            }];
        }
      });
    })();
  }, uploadUsefClass: function(n, s, r) {
    return H(function() {
      var i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.uploadUsefClass(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.uploadUsefClass"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return Re(a, ve, me, e)(h, l || f);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return On(this, t), En(this, t, arguments);
  }
  return _n(t, e), Tn(t, [{ key: "correctUsefClass", value: function(n, s, r) {
    var i = this;
    return tt(this.configuration).correctUsefClass(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "deleteUsefClass", value: function(n, s, r) {
    var i = this;
    return tt(this.configuration).deleteUsefClass(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "finalizeUsefClass", value: function(n, s, r) {
    var i = this;
    return tt(this.configuration).finalizeUsefClass(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "getFederationClassAudit", value: function(n, s) {
    var r = this;
    return tt(this.configuration).getFederationClassAudit(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getFederationShowAudit", value: function(n, s) {
    var r = this;
    return tt(this.configuration).getFederationShowAudit(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getFederationShowState", value: function(n, s) {
    var r = this;
    return tt(this.configuration).getFederationShowState(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getUsefDeadlineStatus", value: function(n, s, r) {
    var i = this;
    return tt(this.configuration).getUsefDeadlineStatus(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "listUsefDressageSections", value: function(n, s) {
    var r = this;
    return tt(this.configuration).listUsefDressageSections(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "listUsefDressageTests", value: function(n, s) {
    var r = this;
    return tt(this.configuration).listUsefDressageTests(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "markClassForRepublish", value: function(n, s, r) {
    var i = this;
    return tt(this.configuration).markClassForRepublish(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "previewClassResult", value: function(n, s) {
    var r = this;
    return tt(this.configuration).previewClassResult(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "previewShowResults", value: function(n, s) {
    var r = this;
    return tt(this.configuration).previewShowResults(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "publishUsdfShow", value: function(n, s, r) {
    var i = this;
    return tt(this.configuration).publishUsdfShow(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "publishUsefShow", value: function(n, s, r) {
    var i = this;
    return tt(this.configuration).publishUsefShow(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "submitUsefShow", value: function(n, s, r) {
    var i = this;
    return tt(this.configuration).submitUsefShow(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "uploadUsefClass", value: function(n, s, r) {
    var i = this;
    return tt(this.configuration).uploadUsefClass(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Cn);
var ah = function(e) {
  return { getHealth: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return H(function() {
      var n, s, r, i, o;
      return J(this, function(a) {
        return n = new URL("/health", ye), e && (s = e.baseOptions), r = z({ method: "GET" }, s, t), i = {}, we(n, {}), o = s && s.headers ? s.headers : {}, r.headers = z({}, i, o, t.headers), [2, { url: Se(n), options: r }];
      });
    })();
  } };
}, uh = function(e) {
  var t = ah(e);
  return { getHealth: function(n) {
    return H(function() {
      var s, r, i, o, a, u;
      return J(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, t.getHealth(n)];
          case 1:
            return i = c.sent(), a = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, u = (r = be["HealthApi.getHealth"]) === null || r === void 0 || (s = r[a]) === null || s === void 0 ? void 0 : s.url, [2, function(l, d) {
              return Re(i, ve, me, e)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return On(this, t), En(this, t, arguments);
  }
  return _n(t, e), Tn(t, [{ key: "getHealth", value: function(n) {
    var s = this;
    return uh(this.configuration).getHealth(n).then(function(r) {
      return r(s.axios, s.basePath);
    });
  } }]), t;
})(Cn);
var ch = function(e) {
  return { createReportRun: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return H(function() {
      var r, i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return le("createReportRun", "id", t), r = "/reports/{id}/runs".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, ye), e && (o = e.baseOptions), a = z({ method: "POST" }, o, s), c = {}, [4, Te(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", we(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, s.headers), a.data = Rt(n, a, e), [2, { url: Se(i), options: a }];
        }
      });
    })();
  }, listReports: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u;
      return J(this, function(c) {
        switch (c.label) {
          case 0:
            return s = new URL("/reports", ye), e && (r = e.baseOptions), i = z({ method: "GET" }, r, n), a = {}, [4, Te(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.domain = t), we(s, a), u = r && r.headers ? r.headers : {}, i.headers = z({}, o, u, n.headers), [2, { url: Se(s), options: i }];
        }
      });
    })();
  } };
}, Uo = function(e) {
  var t = ch(e);
  return { createReportRun: function(n, s, r) {
    return H(function() {
      var i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.createReportRun(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["ReportsApi.createReportRun"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return Re(a, ve, me, e)(h, l || f);
            }];
        }
      });
    })();
  }, listReports: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listReports(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["ReportsApi.listReports"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  } };
}, lh = function(e) {
  function t() {
    return On(this, t), En(this, t, arguments);
  }
  return _n(t, e), Tn(t, [{ key: "createReportRun", value: function(n, s, r) {
    var i = this;
    return Uo(this.configuration).createReportRun(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "listReports", value: function(n, s) {
    var r = this;
    return Uo(this.configuration).listReports(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }]), t;
}(Cn), dh = function(e) {
  return { getScorePageLink: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return le("getScorePageLink", "rideId", t), s = "/score-sheets/rides/{rideId}/link".replace("{rideId}", encodeURIComponent(String(t))), r = new URL(s, ye), e && (i = e.baseOptions), o = z({ method: "GET" }, i, n), u = {}, [4, Te(a = {}, e)];
          case 1:
            return l.sent(), we(r, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(r), options: o }];
        }
      });
    })();
  }, getScoreSheetStatus: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return le("getScoreSheetStatus", "rideId", t), s = "/score-sheets/rides/{rideId}/status".replace("{rideId}", encodeURIComponent(String(t))), r = new URL(s, ye), e && (i = e.baseOptions), o = z({ method: "GET" }, i, n), u = {}, [4, Te(a = {}, e)];
          case 1:
            return l.sent(), we(r, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(r), options: o }];
        }
      });
    })();
  }, resendScoreSheet: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return H(function() {
      var r, i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return le("resendScoreSheet", "rideId", t), r = "/score-sheets/rides/{rideId}/resend".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(r, ye), e && (o = e.baseOptions), a = z({ method: "POST" }, o, s), c = {}, [4, Te(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", we(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, s.headers), a.data = Rt(n, a, e), [2, { url: Se(i), options: a }];
        }
      });
    })();
  } };
}, Ps = function(e) {
  var t = dh(e);
  return { getScorePageLink: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getScorePageLink(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["RiderSheetsApi.getScorePageLink"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  }, getScoreSheetStatus: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getScoreSheetStatus(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["RiderSheetsApi.getScoreSheetStatus"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  }, resendScoreSheet: function(n, s, r) {
    return H(function() {
      var i, o, a, u, c, l;
      return J(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.resendScoreSheet(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["RiderSheetsApi.resendScoreSheet"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return Re(a, ve, me, e)(h, l || f);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return On(this, t), En(this, t, arguments);
  }
  return _n(t, e), Tn(t, [{ key: "getScorePageLink", value: function(n, s) {
    var r = this;
    return Ps(this.configuration).getScorePageLink(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getScoreSheetStatus", value: function(n, s) {
    var r = this;
    return Ps(this.configuration).getScoreSheetStatus(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "resendScoreSheet", value: function(n, s, r) {
    var i = this;
    return Ps(this.configuration).resendScoreSheet(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Cn);
var hh = function(e) {
  return { clearRuns: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u;
      return J(this, function(c) {
        switch (c.label) {
          case 0:
            return s = new URL("/runs", ye), e && (r = e.baseOptions), i = z({ method: "DELETE" }, r, n), a = {}, [4, Te(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.reportId = t), we(s, a), u = r && r.headers ? r.headers : {}, i.headers = z({}, o, u, n.headers), [2, { url: Se(s), options: i }];
        }
      });
    })();
  }, deleteRun: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return le("deleteRun", "id", t), s = "/runs/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, ye), e && (i = e.baseOptions), o = z({ method: "DELETE" }, i, n), u = {}, [4, Te(a = {}, e)];
          case 1:
            return l.sent(), we(r, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(r), options: o }];
        }
      });
    })();
  }, getRun: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return le("getRun", "id", t), s = "/runs/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, ye), e && (i = e.baseOptions), o = z({ method: "GET" }, i, n), u = {}, [4, Te(a = {}, e)];
          case 1:
            return l.sent(), we(r, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(r), options: o }];
        }
      });
    })();
  }, listRuns: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return H(function() {
      var s, r, i, o, a, u;
      return J(this, function(c) {
        switch (c.label) {
          case 0:
            return s = new URL("/runs", ye), e && (r = e.baseOptions), i = z({ method: "GET" }, r, n), a = {}, [4, Te(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.reportId = t), we(s, a), u = r && r.headers ? r.headers : {}, i.headers = z({}, o, u, n.headers), [2, { url: Se(s), options: i }];
        }
      });
    })();
  } };
}, pr = function(e) {
  var t = hh(e);
  return { clearRuns: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.clearRuns(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["RunsApi.clearRuns"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  }, deleteRun: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.deleteRun(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["RunsApi.deleteRun"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  }, getRun: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getRun(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["RunsApi.getRun"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  }, listRuns: function(n, s) {
    return H(function() {
      var r, i, o, a, u, c;
      return J(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listRuns(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["RunsApi.listRuns"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return Re(o, ve, me, e)(d, c || h);
            }];
        }
      });
    })();
  } };
}, fh = function(e) {
  function t() {
    return On(this, t), En(this, t, arguments);
  }
  return _n(t, e), Tn(t, [{ key: "clearRuns", value: function(n, s) {
    var r = this;
    return pr(this.configuration).clearRuns(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "deleteRun", value: function(n, s) {
    var r = this;
    return pr(this.configuration).deleteRun(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getRun", value: function(n, s) {
    var r = this;
    return pr(this.configuration).getRun(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "listRuns", value: function(n, s) {
    var r = this;
    return pr(this.configuration).listRuns(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }]), t;
}(Cn);
function ph(e, t) {
  for (var n = 0; n < t.length; n++) {
    var s = t[n];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
  }
}
function Lt(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Lo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, s = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (s = s.concat(Object.getOwnPropertySymbols(n).filter(function(r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    }))), s.forEach(function(r) {
      Lt(e, r, n[r]);
    });
  }
  return e;
}
var vh = function() {
  function e() {
    var s, r, i, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(a, u) {
      if (!(a instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, e), Lt(this, "apiKey", void 0), Lt(this, "username", void 0), Lt(this, "password", void 0), Lt(this, "accessToken", void 0), Lt(this, "basePath", void 0), Lt(this, "serverIndex", void 0), Lt(this, "baseOptions", void 0), Lt(this, "formDataCtor", void 0), this.apiKey = o.apiKey, this.username = o.username, this.password = o.password, this.accessToken = o.accessToken, this.basePath = o.basePath, this.serverIndex = o.serverIndex, this.baseOptions = (r = Lo({}, o.baseOptions), i = (i = { headers: Lo({}, (s = o.baseOptions) === null || s === void 0 ? void 0 : s.headers) }) != null ? i : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(i)) : function(a) {
      var u = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(a);
        u.push.apply(u, c);
      }
      return u;
    }(Object(i)).forEach(function(a) {
      Object.defineProperty(r, a, Object.getOwnPropertyDescriptor(i, a));
    }), r), this.formDataCtor = o.formDataCtor;
  }
  var t, n;
  return t = e, (n = [{ key: "isJsonMime", value: function(s) {
    var r = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return s !== null && (r.test(s) || s.toLowerCase() === "application/json-patch+json");
  } }]) && ph(t.prototype, n), e;
}();
function mh() {
  var s;
  const e = nn(), { activeOrgId: t } = wi(), n = (s = e.user) == null ? void 0 : s.access_token;
  return Ft(
    (r) => ({
      basePath: r,
      accessToken: n,
      baseOptions: t ? { headers: { "X-Org-Id": t } } : void 0
    }),
    [n, t]
  );
}
function gh(e) {
  const t = mh();
  return dn(() => {
    const n = new vh(t(e));
    return {
      reports: new lh(n),
      runs: new fh(n)
    };
  }, [t, e]);
}
function pn(e) {
  var n;
  const t = e == null ? void 0 : e.data;
  if (!t || t.status !== "success") {
    const s = ((n = t == null ? void 0 : t.data) == null ? void 0 : n.message) || (t == null ? void 0 : t.code) || "Request failed";
    throw new Error(s);
  }
  return t.data;
}
const bh = {
  empty: "No reports available.",
  error: "Failed to load reports"
}, yh = (e) => (e == null ? void 0 : e.name) ?? "";
function wh({
  api: e,
  domain: t,
  onSelect: n,
  selectedId: s,
  // #579 — when set, auto-select this def once (deep-link from another page).
  autoSelectId: r,
  labels: i = {},
  resolveReportName: o = yh
}) {
  const a = { ...bh, ...i }, [u, c] = V([]), [l, d] = V(!0), [h, f] = V(null), w = bt(!1);
  return _e(() => {
    if (w.current || !r || u.length === 0) return;
    const v = u.find((E) => E.id === r);
    v && (w.current = !0, n == null || n(v));
  }, [u, r, n]), _e(() => {
    let v = !1;
    return d(!0), f(null), e.reports.listReports(t).then((E) => {
      v || c(pn(E) || []);
    }).catch((E) => {
      v || f(E.message || a.error);
    }).finally(() => {
      v || d(!1);
    }), () => {
      v = !0;
    };
  }, [e, t, a.error]), l ? /* @__PURE__ */ p.jsx(fe, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ p.jsx(sr, { "data-testid": "report-list-loading" }) }) : h ? /* @__PURE__ */ p.jsx(Gn, { severity: "error", children: h }) : u.length === 0 ? /* @__PURE__ */ p.jsx(Ze, { color: "text.secondary", sx: { p: 2 }, children: a.empty }) : /* @__PURE__ */ p.jsx(Dc, { "data-testid": "report-list", children: u.map((v) => /* @__PURE__ */ p.jsx(
    Fc,
    {
      selected: v.id === s,
      onClick: () => n == null ? void 0 : n(v),
      children: /* @__PURE__ */ p.jsx(
        Mc,
        {
          primary: o(v),
          primaryTypographyProps: { color: "text.primary" }
        }
      )
    },
    v.id
  )) });
}
function Sh(e) {
  return e.default !== void 0 ? e.default : e.type === "boolean" ? !1 : "";
}
const Un = (e) => e !== "" && e !== void 0 && e !== null, Rh = {
  submit: "Run report",
  required: "Required"
}, xh = (e, t, n) => (n == null ? void 0 : n.title) || t;
function Ch({
  def: e,
  onSubmit: t,
  submitting: n = !1,
  labels: s = {},
  // #551 — `context` supplies values for fields the surface knows (e.g. showId
  // from the active show); those fields are auto-filled + hidden, not typed.
  // `fieldRenderers` overrides how a specific field renders (e.g. day/ring as
  // dropdowns, classId/rideId as a lookup) — keyed by the param name; each gets
  // { value, onChange, label, required, error, disabled }.
  context: r = {},
  fieldRenderers: i = {},
  resolveParamLabel: o = xh,
  // #1995 — when true AND every required param is already supplied by
  // `context` (a full deep-link, e.g. RideEditor's "Score Sheet Report"
  // button), submit automatically the first time that becomes true instead
  // of making the admin click "Run report" on a form with nothing left to
  // fill in. Guarded to fire at most once per mounted `def`.
  autoSubmit: a = !1
}) {
  var Ee, de;
  const u = { ...Rh, ...s }, c = ((Ee = e == null ? void 0 : e.paramsSchema) == null ? void 0 : Ee.properties) || {}, l = ((de = e == null ? void 0 : e.paramsSchema) == null ? void 0 : de.required) || [], d = Object.entries(c).filter(([Z]) => !Un(r[Z])), [h, f] = V(() => {
    const Z = {};
    for (const [ue, je] of Object.entries(c))
      Un(r[ue]) || (Z[ue] = Sh(je));
    return Z;
  }), [w, v] = V(!1), E = (Z, ue) => f((je) => ({ ...je, [Z]: ue })), B = l.filter((Z) => Un(r[Z]) ? !1 : !Un(h[Z])), N = () => {
    const Z = {};
    for (const [ue, je] of Object.entries(c)) {
      if (Un(r[ue])) {
        Z[ue] = r[ue];
        continue;
      }
      const Je = h[ue];
      Je === "" && !l.includes(ue) || (Z[ue] = je.type === "number" || je.type === "integer" ? Number(Je) : Je);
    }
    return Z;
  }, M = (Z) => {
    Z.preventDefault(), v(!0), !(B.length > 0) && t(N());
  }, G = bt(!1);
  return _e(() => {
    G.current = !1;
  }, [e == null ? void 0 : e.id]), _e(() => {
    !a || G.current || B.length > 0 || (G.current = !0, t(N()));
  }, [a, B.length]), /* @__PURE__ */ p.jsx(fe, { component: "form", onSubmit: M, noValidate: !0, children: /* @__PURE__ */ p.jsxs(gn, { spacing: 2, children: [
    d.map(([Z, ue]) => {
      const je = o(e, Z, ue), Je = l.includes(Z), $e = w && Je && B.includes(Z), Ae = i[Z];
      if (Ae)
        return /* @__PURE__ */ p.jsx(_c, { children: Ae({
          value: h[Z],
          onChange: (xe) => E(Z, xe),
          label: je,
          required: Je,
          error: $e,
          disabled: n
        }) }, Z);
      if (ue.type === "boolean")
        return /* @__PURE__ */ p.jsx(
          Ua,
          {
            control: /* @__PURE__ */ p.jsx(
              La,
              {
                color: "default",
                checked: !!h[Z],
                onChange: (xe) => E(Z, xe.target.checked)
              }
            ),
            label: je
          },
          Z
        );
      if (Array.isArray(ue.enum))
        return /* @__PURE__ */ p.jsx(
          bn,
          {
            select: !0,
            label: je,
            required: Je,
            error: $e,
            helperText: $e ? u.required : ue.description,
            value: h[Z] ?? "",
            onChange: (xe) => E(Z, xe.target.value),
            fullWidth: !0,
            children: ue.enum.map((xe) => /* @__PURE__ */ p.jsx(Bc, { value: xe, children: String(xe) }, String(xe)))
          },
          Z
        );
      const pe = ue.type === "number" || ue.type === "integer";
      return /* @__PURE__ */ p.jsx(
        bn,
        {
          label: je,
          type: pe ? "number" : "text",
          required: Je,
          error: $e,
          helperText: $e ? u.required : ue.description,
          value: h[Z] ?? "",
          onChange: (xe) => E(Z, xe.target.value),
          fullWidth: !0
        },
        Z
      );
    }),
    /* @__PURE__ */ p.jsx(fe, { children: /* @__PURE__ */ p.jsx(rt, { type: "submit", variant: "contained", loading: n, children: u.submit }) })
  ] }) });
}
const Eh = /* @__PURE__ */ new Set(["PENDING", "RUNNING"]), Oh = {
  COMPLETE: "success",
  FAILED: "error",
  RUNNING: "info",
  PENDING: "warning"
};
function Th(e) {
  if (!e) return "";
  const t = new Date(e);
  return isNaN(t.getTime()) ? e : t.toLocaleString();
}
const _h = {
  empty: "No runs yet.",
  error: "Failed to load runs",
  colReport: "Report",
  colRequested: "Requested",
  colStatus: "Status",
  colActions: "Actions",
  view: "View",
  delete: "Delete"
}, Ih = (e) => e;
function kh({
  api: e,
  onView: t,
  onDelete: n,
  refreshKey: s = 0,
  labels: r = {},
  resolveReportName: i = Ih
}) {
  const o = { ..._h, ...r }, [a, u] = V([]), [c, l] = V(!0), [d, h] = V(null), f = bt(null), w = Ft(async () => {
    try {
      const v = await e.runs.listRuns();
      u(pn(v) || []), h(null);
    } catch (v) {
      h(v.message || o.error);
    } finally {
      l(!1);
    }
  }, [e, o.error]);
  return _e(() => {
    w();
  }, [w, s]), _e(() => {
    if (!a.some((E) => Eh.has(E.status))) {
      f.current && clearInterval(f.current), f.current = null;
      return;
    }
    return f.current || (f.current = setInterval(w, 4e3)), () => {
      f.current && (clearInterval(f.current), f.current = null);
    };
  }, [a, w]), c ? /* @__PURE__ */ p.jsx(fe, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ p.jsx(sr, { "data-testid": "run-history-loading" }) }) : d ? /* @__PURE__ */ p.jsx(Gn, { severity: "error", children: d }) : a.length === 0 ? /* @__PURE__ */ p.jsx(Ze, { color: "text.secondary", sx: { p: 2 }, children: o.empty }) : /* @__PURE__ */ p.jsxs($c, { size: "small", "data-testid": "run-history", children: [
    /* @__PURE__ */ p.jsx(zc, { children: /* @__PURE__ */ p.jsxs(Ki, { children: [
      /* @__PURE__ */ p.jsx($t, { children: o.colReport }),
      /* @__PURE__ */ p.jsx($t, { children: o.colRequested }),
      /* @__PURE__ */ p.jsx($t, { children: o.colStatus }),
      /* @__PURE__ */ p.jsx($t, { align: "right", children: o.colActions })
    ] }) }),
    /* @__PURE__ */ p.jsx(qc, { children: a.map((v) => /* @__PURE__ */ p.jsxs(Ki, { "data-testid": `run-row-${v.id}`, children: [
      /* @__PURE__ */ p.jsx($t, { sx: { color: "text.primary" }, children: i(v.reportId) }),
      /* @__PURE__ */ p.jsx($t, { sx: { color: "text.primary" }, children: Th(v.createdAt) }),
      /* @__PURE__ */ p.jsx($t, { children: /* @__PURE__ */ p.jsx(
        Aa,
        {
          size: "small",
          label: v.status,
          color: Oh[v.status] || "default"
        }
      ) }),
      /* @__PURE__ */ p.jsxs($t, { align: "right", children: [
        /* @__PURE__ */ p.jsx(
          rt,
          {
            size: "small",
            variant: "outlined",
            color: "inherit",
            disabled: v.status !== "COMPLETE",
            onClick: () => t == null ? void 0 : t(v),
            children: o.view
          }
        ),
        n && /* @__PURE__ */ p.jsx(
          zr,
          {
            size: "small",
            color: "inherit",
            "aria-label": o.delete,
            title: o.delete,
            sx: { ml: 1 },
            onClick: () => n(v),
            children: /* @__PURE__ */ p.jsx(fl, { fontSize: "small" })
          }
        )
      ] })
    ] }, v.id)) })
  ] });
}
const Ph = {
  failed: "This run failed to render.",
  notReady: "Report is not ready yet.",
  error: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  preview: "Report preview"
};
function jh({ api: e, runId: t, height: n = 600, labels: s = {} }) {
  const r = { ...Ph, ...s }, [i, o] = V(null), [a, u] = V(!0), [c, l] = V(null);
  return _e(() => {
    if (!t) return;
    let d = !1;
    return u(!0), l(null), e.runs.getRun(t).then((h) => {
      if (d) return;
      const f = pn(h);
      if (f.status !== "COMPLETE" || !f.artifactUrls) {
        l(f.status === "FAILED" ? r.failed : r.notReady);
        return;
      }
      o(f.artifactUrls);
    }).catch((h) => {
      d || l(h.message || r.error);
    }).finally(() => {
      d || u(!1);
    }), () => {
      d = !0;
    };
  }, [e, t, r.error, r.failed, r.notReady]), t ? a ? /* @__PURE__ */ p.jsx(fe, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ p.jsx(sr, { "data-testid": "report-viewer-loading" }) }) : c ? /* @__PURE__ */ p.jsx(Gn, { severity: "error", children: c }) : i ? /* @__PURE__ */ p.jsxs(gn, { spacing: 1, "data-testid": "report-viewer", children: [
    /* @__PURE__ */ p.jsxs(gn, { direction: "row", spacing: 1, children: [
      i.pdf && /* @__PURE__ */ p.jsx(rt, { variant: "outlined", href: i.pdf, target: "_blank", rel: "noopener", children: r.openPdf }),
      i.html && /* @__PURE__ */ p.jsx(rt, { variant: "text", href: i.html, target: "_blank", rel: "noopener", children: r.openHtml })
    ] }),
    i.html && /* @__PURE__ */ p.jsx(
      fe,
      {
        component: "iframe",
        "data-testid": "report-viewer-frame",
        title: r.preview,
        src: i.html,
        sx: { width: "100%", height: n, border: 1, borderColor: "divider", borderRadius: 1, bgcolor: "#fff" }
      }
    )
  ] }) : null : null;
}
const Ah = {
  title: "Reports",
  availableReports: "Available reports",
  runHistory: "Run history",
  reportDialogTitle: "Report",
  reportStarted: "Report started — open Run history to view it when ready.",
  failedToStart: "Failed to start report",
  // #609 — run-progress modal
  runningTitle: "Running report…",
  runningMessage: "Your report is being generated. It will download automatically when it's ready — or close this and find it in Run history.",
  runningDoneTitle: "Report ready",
  runningDoneMessage: "Your report has downloaded. It's also in Run history.",
  runningFailedTitle: "Report failed",
  download: "Download",
  close: "Close",
  // #606 — clear old runs
  clearHistory: "Clear history",
  clearConfirm: "Delete all report runs for this organization? This removes the generated files too and can't be undone.",
  delete: "Delete",
  // ReportList
  noReports: "No reports available.",
  failedToLoadReports: "Failed to load reports",
  // ReportParamsForm
  runReport: "Run report",
  required: "Required",
  // RunHistory
  noRuns: "No runs yet.",
  failedToLoadRuns: "Failed to load runs",
  colReport: "Report",
  colRequested: "Requested",
  colStatus: "Status",
  colActions: "Actions",
  view: "View",
  // ReportViewer
  runFailed: "This run failed to render.",
  runNotReady: "Report is not ready yet.",
  failedToLoadReport: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  reportPreview: "Report preview"
}, Uh = (e) => (e == null ? void 0 : e.name) ?? (e == null ? void 0 : e.id) ?? "", Lh = (e, t, n) => (n == null ? void 0 : n.title) || t;
function No(e) {
  const t = document.createElement("a");
  t.href = e, t.target = "_blank", t.rel = "noopener", t.download = "", document.body.appendChild(t), t.click(), t.remove();
}
function Yv({
  basePath: e,
  domain: t,
  // Back-compat: an explicit `title` still wins; otherwise labels.title is used.
  title: n,
  // #602 — translated chrome strings from the mounting app (see DEFAULT_LABELS).
  labels: s = {},
  // #551 — a surface can supply context values (e.g. showId from the active
  // show) and custom field renderers (day/ring dropdowns, class/ride lookups)
  // forwarded to the params form. `paramsFieldRenderers` may be a plain map or
  // a function of the selected def (so renderers can depend on the def).
  paramsContext: r = {},
  paramsFieldRenderers: i = {},
  // #579 — a surface can deep-link to a specific report (e.g. from a ride page);
  // the matching def is auto-selected once the list loads.
  initialSelectedId: o,
  // #1995 — when true, a deep-linked def whose required params are already
  // fully supplied by `paramsContext` runs immediately (skipping the manual
  // "Run report" click) instead of just being pre-filled. See
  // ReportParamsForm's `autoSubmit` for the fire-once guard.
  autoRun: a = !1,
  // #649 — see defaultResolveReportName/defaultResolveParamLabel above.
  resolveReportName: u = Uh,
  resolveParamLabel: c = Lh
}) {
  var vt, ar;
  const l = { ...Ah, ...s }, d = gh(e), [h, f] = V(null), [w, v] = V(!1), [E, B] = V(null), [N, M] = V(0), [G, Ee] = V(""), [de, Z] = V(null), [ue, je] = V({});
  _e(() => {
    let Ue = !1;
    return d.reports.listReports(t).then((ze) => {
      if (Ue) return;
      const mt = {};
      for (const jt of pn(ze) || []) mt[jt.id] = jt;
      je(mt);
    }).catch(() => {
    }), () => {
      Ue = !0;
    };
  }, [d, t]);
  const Je = (Ue) => {
    var ze;
    return u({ id: Ue, name: (ze = ue[Ue]) == null ? void 0 : ze.name });
  }, [$e, Ae] = V(!1), [pe, xe] = V(null), [K, pt] = V(null), Ie = bt(!1), wt = bt(!1), Bt = async (Ue) => {
    if (h) {
      wt.current = !0, v(!0), B(null);
      try {
        const ze = pn(await d.reports.createReportRun(h.id, { params: Ue }));
        M((mt) => mt + 1), f(null), Ie.current = !1, pt(ze), xe(ze.id);
      } catch (ze) {
        B(ze.message || l.failedToStart);
      } finally {
        v(!1);
      }
    }
  };
  _e(() => {
    if (!pe) return;
    let Ue = !1, ze;
    const mt = async () => {
      var jt, Vt;
      try {
        const At = pn(await d.runs.getRun(pe));
        if (Ue) return;
        if (pt(At), At.status === "COMPLETE") {
          M((fs) => fs + 1);
          const Gt = ((jt = At.artifactUrls) == null ? void 0 : jt.pdf) || ((Vt = At.artifactUrls) == null ? void 0 : Vt.html);
          Gt && !Ie.current && (Ie.current = !0, No(Gt));
          return;
        }
        if (At.status === "FAILED") {
          M((Gt) => Gt + 1);
          return;
        }
        ze = setTimeout(mt, 3e3);
      } catch {
        Ue || pt((At) => ({ ...At || {}, status: "FAILED" }));
      }
    };
    return ze = setTimeout(mt, 1200), () => {
      Ue = !0, clearTimeout(ze);
    };
  }, [pe, d]);
  const [ke, Oe] = V(!1), Ve = async () => {
    if (!(typeof window < "u" && !window.confirm(l.clearConfirm))) {
      Oe(!0);
      try {
        await d.runs.clearRuns(), M((Ue) => Ue + 1);
      } finally {
        Oe(!1);
      }
    }
  }, te = async (Ue) => {
    await d.runs.deleteRun(Ue.id), M((ze) => ze + 1);
  };
  return /* @__PURE__ */ p.jsxs(fe, { children: [
    /* @__PURE__ */ p.jsx(Ze, { variant: "h5", sx: { mb: 2, color: "text.primary" }, children: n ?? l.title }),
    /* @__PURE__ */ p.jsxs(fe, { sx: { display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2, alignItems: "flex-start" }, children: [
      /* @__PURE__ */ p.jsx(fe, { sx: { width: { xs: "100%", md: 340 }, flexShrink: 0 }, children: /* @__PURE__ */ p.jsx(Br, { variant: "outlined", children: /* @__PURE__ */ p.jsxs($r, { children: [
        /* @__PURE__ */ p.jsx(Ze, { variant: "subtitle1", sx: { color: "text.primary" }, children: l.availableReports }),
        /* @__PURE__ */ p.jsx(
          wh,
          {
            api: d,
            domain: t,
            selectedId: h == null ? void 0 : h.id,
            autoSelectId: o,
            onSelect: f,
            labels: { empty: l.noReports, error: l.failedToLoadReports },
            resolveReportName: u
          }
        ),
        /* @__PURE__ */ p.jsx(
          rt,
          {
            fullWidth: !0,
            variant: "text",
            color: "inherit",
            sx: { mt: 1, justifyContent: "flex-start" },
            onClick: () => Ae(!0),
            children: l.runHistory
          }
        )
      ] }) }) }),
      /* @__PURE__ */ p.jsx(fe, { sx: { flex: 1, minWidth: 0, width: "100%" }, children: h && /* @__PURE__ */ p.jsx(Br, { variant: "outlined", sx: { mb: 2 }, children: /* @__PURE__ */ p.jsxs($r, { children: [
        /* @__PURE__ */ p.jsx(Ze, { variant: "subtitle1", sx: { color: "text.primary" }, children: u(h) }),
        /* @__PURE__ */ p.jsx(Hc, { sx: { my: 1 } }),
        E && /* @__PURE__ */ p.jsx(Gn, { severity: "error", sx: { mb: 2 }, children: E }),
        /* @__PURE__ */ p.jsx(
          Ch,
          {
            def: h,
            onSubmit: Bt,
            submitting: w,
            autoSubmit: a && !wt.current && (h == null ? void 0 : h.id) === o,
            labels: { submit: l.runReport, required: l.required },
            context: r,
            fieldRenderers: typeof i == "function" ? i(h) : i,
            resolveParamLabel: c
          }
        )
      ] }) }) })
    ] }),
    /* @__PURE__ */ p.jsxs(xr, { open: $e, onClose: () => Ae(!1), maxWidth: "md", fullWidth: !0, children: [
      /* @__PURE__ */ p.jsx(ws, { children: l.runHistory }),
      /* @__PURE__ */ p.jsx(Cr, { children: /* @__PURE__ */ p.jsx(
        kh,
        {
          api: d,
          refreshKey: N,
          onView: (Ue) => Z(Ue.id),
          onDelete: te,
          labels: {
            empty: l.noRuns,
            error: l.failedToLoadRuns,
            colReport: l.colReport,
            colRequested: l.colRequested,
            colStatus: l.colStatus,
            colActions: l.colActions,
            view: l.view,
            delete: l.delete
          },
          resolveReportName: Je
        }
      ) }),
      /* @__PURE__ */ p.jsxs(Js, { children: [
        /* @__PURE__ */ p.jsx(rt, { color: "error", onClick: Ve, disabled: ke, children: l.clearHistory }),
        /* @__PURE__ */ p.jsx(rt, { color: "inherit", onClick: () => Ae(!1), children: l.close })
      ] })
    ] }),
    /* @__PURE__ */ p.jsxs(xr, { open: !!de, onClose: () => Z(null), maxWidth: "lg", fullWidth: !0, children: [
      /* @__PURE__ */ p.jsx(ws, { children: l.reportDialogTitle }),
      /* @__PURE__ */ p.jsx(Cr, { children: /* @__PURE__ */ p.jsx(
        jh,
        {
          api: d,
          runId: de,
          labels: {
            failed: l.runFailed,
            notReady: l.runNotReady,
            error: l.failedToLoadReport,
            openPdf: l.openPdf,
            openHtml: l.openHtml,
            preview: l.reportPreview
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ p.jsxs(xr, { open: !!pe, onClose: () => xe(null), maxWidth: "xs", fullWidth: !0, children: [
      /* @__PURE__ */ p.jsx(ws, { children: (K == null ? void 0 : K.status) === "COMPLETE" ? l.runningDoneTitle : (K == null ? void 0 : K.status) === "FAILED" ? l.runningFailedTitle : l.runningTitle }),
      /* @__PURE__ */ p.jsx(Cr, { children: (K == null ? void 0 : K.status) === "FAILED" ? /* @__PURE__ */ p.jsx(Gn, { severity: "error", children: l.runFailed }) : (K == null ? void 0 : K.status) === "COMPLETE" ? /* @__PURE__ */ p.jsx(Ze, { sx: { color: "text.primary" }, children: l.runningDoneMessage }) : /* @__PURE__ */ p.jsxs(fe, { sx: { display: "flex", alignItems: "center", gap: 2, py: 1 }, children: [
        /* @__PURE__ */ p.jsx(sr, { size: 26, color: "inherit" }),
        /* @__PURE__ */ p.jsx(Ze, { sx: { color: "text.primary" }, children: l.runningMessage })
      ] }) }),
      /* @__PURE__ */ p.jsxs(Js, { children: [
        (K == null ? void 0 : K.status) === "COMPLETE" && (((vt = K.artifactUrls) == null ? void 0 : vt.pdf) || ((ar = K.artifactUrls) == null ? void 0 : ar.html)) && // #609 — brand primary is darkGrey (invisible as a text button on
        // dark); a contained button + inherit-colored Close stay legible
        // in both light and dark.
        /* @__PURE__ */ p.jsx(
          rt,
          {
            variant: "contained",
            onClick: () => No(K.artifactUrls.pdf || K.artifactUrls.html),
            children: l.download
          }
        ),
        /* @__PURE__ */ p.jsx(rt, { color: "inherit", onClick: () => xe(null), children: l.close })
      ] })
    ] }),
    /* @__PURE__ */ p.jsx(
      Jc,
      {
        open: !!G,
        autoHideDuration: 5e3,
        onClose: () => Ee(""),
        message: G
      }
    )
  ] });
}
var Xr = { d: (e, t) => {
  for (var n in t) Xr.o(t, n) && !Xr.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
}, o: (e, t) => Object.prototype.hasOwnProperty.call(e, t), r: (e) => {
  typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
} }, si = {};
function js(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
Xr.r(si), Xr.d(si, { hasBrowserEnv: () => ki, hasStandardBrowserEnv: () => Mf, hasStandardBrowserWebWorkerEnv: () => Bf, navigator: () => fi, origin: () => $f });
var Iu = ["C", "E", "M", "B", "H"], Ln = { PENDING: "PENDING", ENTERING_RING: "ENTERING_RING", IN_PROGRESS: "IN_PROGRESS", COMPLETED: "COMPLETED", SCRATCHED: "SCRATCHED" }, Nh = { SCRATCHED: "Scratched", EXCUSED: "Excused", ELIMINATED: "Eliminated", NO_SHOW: "No Show" }, Oi = { BLOOD: "BLOOD", LAMENESS: "LAMENESS", MEETING_REQUESTED: "MEETING_REQUESTED" }, Hn = { POINTS: "POINTS", PERCENT_SENIOR: "PERCENT_SENIOR", PERCENT_YOUTH: "PERCENT_YOUTH" }, Dh = 0, yn = 10, ds = 0.5, As = { RIDE_INTRO_DETAILED: "ride-intro-detailed", POST_RIDE_SCORE: "post-ride-score", END_OF_CLASS_RESULT: "end-of-class-result" }, vr;
js(vr = {}, As.RIDE_INTRO_DETAILED, ["classNumberName", "testName", "entryIdentity", "riderLocation", "horseBio", "ownerInfo"]), js(vr, As.POST_RIDE_SCORE, ["classNumberName", "testName", "entryIdentity", "scoreHero", "termReason", "currentRank", "divisionRank", "perJudgeBreakout", "qr"]), js(vr, As.END_OF_CLASS_RESULT, ["classNumberName", "judgesPositions", "rankedList", "resultLayout", "sponsor", "qr"]);
var Fh = "Withdrawn / retired", Do = { RULE: "rule", MANUAL: "manual" }, Mh = { CLASS_RIDE_MISMATCH: "CLASS_RIDE_MISMATCH", DSHB_NAME_MISMATCH: "DSHB_NAME_MISMATCH" };
function Us(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ku(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ds;
  if (typeof e != "number" || !Number.isFinite(e)) return null;
  var n = Math.round(e / t) * t, s = Math.round(1e3 * n) / 1e3;
  return s < 0 ? 0 : s > yn ? yn : s;
}
function Pu(e) {
  var t = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).suppressShorthand, n = t !== void 0 && t;
  if (e == null) return null;
  var s = String(e).trim();
  if (s === "") return null;
  var r = Number(s);
  return Number.isFinite(r) ? /\./.test(s) || r >= 0 && r <= yn ? r : !n && r > yn && r <= 100 ? r / 10 : r : null;
}
function Bh(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ds, n = Pu(e);
  return n === null ? null : ku(n, t);
}
var mr;
Us(mr = {}, Hn.POINTS, [{ points: 2 }, { points: 4 }, { eliminate: !0 }]), Us(mr, Hn.PERCENT_SENIOR, [{ percent: 2 }, { eliminate: !0 }]), Us(mr, Hn.PERCENT_YOUTH, [{ percent: 0.5 }, { percent: 1 }, { eliminate: !0 }]);
function at(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var nt, ut = { PERCENTAGE: "PERCENTAGE", COLLECTIVE_MARKS: "COLLECTIVE_MARKS", YOUNG_HORSE_AVERAGE: "YOUNG_HORSE_AVERAGE", YOUNG_HORSE_SUBMISSION: "YOUNG_HORSE_SUBMISSION", FEI_CHILDREN_TECHNICAL: "FEI_CHILDREN_TECHNICAL", FEI_CHILDREN_MEDIAN: "FEI_CHILDREN_MEDIAN", FREESTYLE_ARTISTIC: "FREESTYLE_ARTISTIC", FREESTYLE_HARMONY: "FREESTYLE_HARMONY", FREESTYLE_CHOREOGRAPHY: "FREESTYLE_CHOREOGRAPHY", MOVEMENT_TOTALS: "MOVEMENT_TOTALS", UNRESOLVED: "UNRESOLVED", JUDGE_ENTERED: "JUDGE_ENTERED", RIDE_OFF_REQUIRED: "RIDE_OFF_REQUIRED", DSHB_JUDGE_ENTERED: "DSHB_JUDGE_ENTERED", DSHB_UNRESOLVED: "DSHB_UNRESOLVED" };
at(nt = {}, ut.PERCENTAGE, "DR123.3"), at(nt, ut.COLLECTIVE_MARKS, "DR123.3"), at(nt, ut.YOUNG_HORSE_AVERAGE, "DR123.3 (Young Horse exception)"), at(nt, ut.YOUNG_HORSE_SUBMISSION, "DR123.3 (Young Horse exception)"), at(nt, ut.FEI_CHILDREN_TECHNICAL, "DR123.3 (FEI Children exception)"), at(nt, ut.FEI_CHILDREN_MEDIAN, "DR123.3 (FEI Children exception)"), at(nt, ut.FREESTYLE_ARTISTIC, "DR129.5"), at(nt, ut.FREESTYLE_HARMONY, "DR129.5"), at(nt, ut.FREESTYLE_CHOREOGRAPHY, "DR129.5"), at(nt, ut.MOVEMENT_TOTALS, "DR211.4"), at(nt, ut.UNRESOLVED, "DR123.3"), at(nt, ut.JUDGE_ENTERED, "DR133.1.k / DR133.2.g.4"), at(nt, ut.RIDE_OFF_REQUIRED, "DR133.2.g.5"), at(nt, ut.DSHB_JUDGE_ENTERED, "DR210.5 / DR204.2.c"), at(nt, ut.DSHB_UNRESOLVED, "DR211.4");
var Zt = { PENDING: Ln.PENDING, ENTERING_RING: Ln.ENTERING_RING, IN_PROGRESS: Ln.IN_PROGRESS, CONFIRMED: "CONFIRMED", COMPLETED: Ln.COMPLETED, FINAL: "FINAL", SCRATCHED: Ln.SCRATCHED }, $h = [Fh, "Withdrawal", "Withdrawn", "Withdraw"];
new Set($h.map(zh));
function zh(e) {
  return typeof e == "string" ? e.trim().toLowerCase().replace(/[^a-z0-9]/g, "") : "";
}
var he, Fo;
(function(e) {
  e.assertEqual = (t) => {
  }, e.assertIs = function(t) {
  }, e.assertNever = function(t) {
    throw new Error();
  }, e.arrayToEnum = (t) => {
    const n = {};
    for (const s of t) n[s] = s;
    return n;
  }, e.getValidEnumValues = (t) => {
    const n = e.objectKeys(t).filter((r) => typeof t[t[r]] != "number"), s = {};
    for (const r of n) s[r] = t[r];
    return e.objectValues(s);
  }, e.objectValues = (t) => e.objectKeys(t).map(function(n) {
    return t[n];
  }), e.objectKeys = typeof Object.keys == "function" ? (t) => Object.keys(t) : (t) => {
    const n = [];
    for (const s in t) Object.prototype.hasOwnProperty.call(t, s) && n.push(s);
    return n;
  }, e.find = (t, n) => {
    for (const s of t) if (n(s)) return s;
  }, e.isInteger = typeof Number.isInteger == "function" ? (t) => Number.isInteger(t) : (t) => typeof t == "number" && Number.isFinite(t) && Math.floor(t) === t, e.joinValues = function(t, n = " | ") {
    return t.map((s) => typeof s == "string" ? `'${s}'` : s).join(n);
  }, e.jsonStringifyReplacer = (t, n) => typeof n == "bigint" ? n.toString() : n;
})(he || (he = {})), function(e) {
  e.mergeShapes = (t, n) => ({ ...t, ...n });
}(Fo || (Fo = {}));
const $ = he.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]), zt = (e) => {
  switch (typeof e) {
    case "undefined":
      return $.undefined;
    case "string":
      return $.string;
    case "number":
      return Number.isNaN(e) ? $.nan : $.number;
    case "boolean":
      return $.boolean;
    case "function":
      return $.function;
    case "bigint":
      return $.bigint;
    case "symbol":
      return $.symbol;
    case "object":
      return Array.isArray(e) ? $.array : e === null ? $.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? $.promise : typeof Map < "u" && e instanceof Map ? $.map : typeof Set < "u" && e instanceof Set ? $.set : typeof Date < "u" && e instanceof Date ? $.date : $.object;
    default:
      return $.unknown;
  }
}, L = he.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of", "not_finite"]);
class Mt extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (s) => {
      this.issues = [...this.issues, s];
    }, this.addIssues = (s = []) => {
      this.issues = [...this.issues, ...s];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const n = t || function(i) {
      return i.message;
    }, s = { _errors: [] }, r = (i) => {
      for (const o of i.issues) if (o.code === "invalid_union") o.unionErrors.map(r);
      else if (o.code === "invalid_return_type") r(o.returnTypeError);
      else if (o.code === "invalid_arguments") r(o.argumentsError);
      else if (o.path.length === 0) s._errors.push(n(o));
      else {
        let a = s, u = 0;
        for (; u < o.path.length; ) {
          const c = o.path[u];
          u === o.path.length - 1 ? (a[c] = a[c] || { _errors: [] }, a[c]._errors.push(n(o))) : a[c] = a[c] || { _errors: [] }, a = a[c], u++;
        }
      }
    };
    return r(this), s;
  }
  static assert(t) {
    if (!(t instanceof Mt)) throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, he.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, s = [];
    for (const r of this.issues) if (r.path.length > 0) {
      const i = r.path[0];
      n[i] = n[i] || [], n[i].push(t(r));
    } else s.push(t(r));
    return { formErrors: s, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Mt.create = (e) => new Mt(e);
const ii = (e, t) => {
  let n;
  switch (e.code) {
    case L.invalid_type:
      n = e.received === $.undefined ? "Required" : `Expected ${e.expected}, received ${e.received}`;
      break;
    case L.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, he.jsonStringifyReplacer)}`;
      break;
    case L.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${he.joinValues(e.keys, ", ")}`;
      break;
    case L.invalid_union:
      n = "Invalid input";
      break;
    case L.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${he.joinValues(e.options)}`;
      break;
    case L.invalid_enum_value:
      n = `Invalid enum value. Expected ${he.joinValues(e.options)}, received '${e.received}'`;
      break;
    case L.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case L.invalid_return_type:
      n = "Invalid function return type";
      break;
    case L.invalid_date:
      n = "Invalid date";
      break;
    case L.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : he.assertNever(e.validation) : n = e.validation !== "regex" ? `Invalid ${e.validation}` : "Invalid";
      break;
    case L.too_small:
      n = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" || e.type === "bigint" ? `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : "Invalid input";
      break;
    case L.too_big:
      n = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : "Invalid input";
      break;
    case L.custom:
      n = "Invalid input";
      break;
    case L.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case L.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case L.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, he.assertNever(e);
  }
  return { message: n };
};
let qh = ii;
var q;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(q || (q = {}));
function D(e, t) {
  const n = qh, s = ((r) => {
    const { data: i, path: o, errorMaps: a, issueData: u } = r, c = [...o, ...u.path || []], l = { ...u, path: c };
    if (u.message !== void 0) return { ...u, path: c, message: u.message };
    let d = "";
    const h = a.filter((f) => !!f).slice().reverse();
    for (const f of h) d = f(l, { data: i, defaultError: d }).message;
    return { ...u, path: c, message: d };
  })({ issueData: t, data: e.data, path: e.path, errorMaps: [e.common.contextualErrorMap, e.schemaErrorMap, n, n === ii ? void 0 : ii].filter((r) => !!r) });
  e.common.issues.push(s);
}
class ct {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const s = [];
    for (const r of n) {
      if (r.status === "aborted") return Q;
      r.status === "dirty" && t.dirty(), s.push(r.value);
    }
    return { status: t.value, value: s };
  }
  static async mergeObjectAsync(t, n) {
    const s = [];
    for (const r of n) {
      const i = await r.key, o = await r.value;
      s.push({ key: i, value: o });
    }
    return ct.mergeObjectSync(t, s);
  }
  static mergeObjectSync(t, n) {
    const s = {};
    for (const r of n) {
      const { key: i, value: o } = r;
      if (i.status === "aborted" || o.status === "aborted") return Q;
      i.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), i.value === "__proto__" || o.value === void 0 && !r.alwaysSet || (s[i.value] = o.value);
    }
    return { status: t.value, value: s };
  }
}
const Q = Object.freeze({ status: "aborted" }), oi = (e) => ({ status: "dirty", value: e }), yt = (e) => ({ status: "valid", value: e }), Mo = (e) => e.status === "aborted", Bo = (e) => e.status === "dirty", wn = (e) => e.status === "valid", Qr = (e) => typeof Promise < "u" && e instanceof Promise;
class Pt {
  constructor(t, n, s, r) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = s, this._key = r;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const $o = (e, t) => {
  if (wn(t)) return { success: !0, data: t.value };
  if (!e.common.issues.length) throw new Error("Validation failed but no issues detected.");
  return { success: !1, get error() {
    if (this._error) return this._error;
    const n = new Mt(e.common.issues);
    return this._error = n, this._error;
  } };
};
function ne(e) {
  if (!e) return {};
  const { errorMap: t, invalid_type_error: n, required_error: s, description: r } = e;
  if (t && (n || s)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: r } : { errorMap: (i, o) => {
    const { message: a } = e;
    return i.code === "invalid_enum_value" ? { message: a ?? o.defaultError } : o.data === void 0 ? { message: a ?? s ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: a ?? n ?? o.defaultError };
  }, description: r };
}
class ae {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return zt(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || { common: t.parent.common, data: t.data, parsedType: zt(t.data), schemaErrorMap: this._def.errorMap, path: t.path, parent: t.parent };
  }
  _processInputParams(t) {
    return { status: new ct(), ctx: { common: t.parent.common, data: t.data, parsedType: zt(t.data), schemaErrorMap: this._def.errorMap, path: t.path, parent: t.parent } };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (Qr(n)) throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const s = this.safeParse(t, n);
    if (s.success) return s.data;
    throw s.error;
  }
  safeParse(t, n) {
    const s = { common: { issues: [], async: (n == null ? void 0 : n.async) ?? !1, contextualErrorMap: n == null ? void 0 : n.errorMap }, path: (n == null ? void 0 : n.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: t, parsedType: zt(t) }, r = this._parseSync({ data: t, path: s.path, parent: s });
    return $o(s, r);
  }
  "~validate"(t) {
    var s, r;
    const n = { common: { issues: [], async: !!this["~standard"].async }, path: [], schemaErrorMap: this._def.errorMap, parent: null, data: t, parsedType: zt(t) };
    if (!this["~standard"].async) try {
      const i = this._parseSync({ data: t, path: [], parent: n });
      return wn(i) ? { value: i.value } : { issues: n.common.issues };
    } catch (i) {
      (r = (s = i == null ? void 0 : i.message) == null ? void 0 : s.toLowerCase()) != null && r.includes("encountered") && (this["~standard"].async = !0), n.common = { issues: [], async: !0 };
    }
    return this._parseAsync({ data: t, path: [], parent: n }).then((i) => wn(i) ? { value: i.value } : { issues: n.common.issues });
  }
  async parseAsync(t, n) {
    const s = await this.safeParseAsync(t, n);
    if (s.success) return s.data;
    throw s.error;
  }
  async safeParseAsync(t, n) {
    const s = { common: { issues: [], contextualErrorMap: n == null ? void 0 : n.errorMap, async: !0 }, path: (n == null ? void 0 : n.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: t, parsedType: zt(t) }, r = this._parse({ data: t, path: s.path, parent: s }), i = await (Qr(r) ? r : Promise.resolve(r));
    return $o(s, i);
  }
  refine(t, n) {
    const s = (r) => typeof n == "string" || n === void 0 ? { message: n } : typeof n == "function" ? n(r) : n;
    return this._refinement((r, i) => {
      const o = t(r), a = () => i.addIssue({ code: L.custom, ...s(r) });
      return typeof Promise < "u" && o instanceof Promise ? o.then((u) => !!u || (a(), !1)) : !!o || (a(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((s, r) => !!t(s) || (r.addIssue(typeof n == "function" ? n(s, r) : n), !1));
  }
  _refinement(t) {
    return new cn({ schema: this, typeName: X.ZodEffects, effect: { type: "refinement", refinement: t } });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = { version: 1, vendor: "zod", validate: (n) => this["~validate"](n) };
  }
  optional() {
    return Jt.create(this, this._def);
  }
  nullable() {
    return xn.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return It.create(this);
  }
  promise() {
    return rs.create(this, this._def);
  }
  or(t) {
    return ts.create([this, t], this._def);
  }
  and(t) {
    return ns.create(this, t, this._def);
  }
  transform(t) {
    return new cn({ ...ne(this._def), schema: this, typeName: X.ZodEffects, effect: { type: "transform", transform: t } });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new li({ ...ne(this._def), innerType: this, defaultValue: n, typeName: X.ZodDefault });
  }
  brand() {
    return new lf({ typeName: X.ZodBranded, type: this, ...ne(this._def) });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new di({ ...ne(this._def), innerType: this, catchValue: n, typeName: X.ZodCatch });
  }
  describe(t) {
    return new this.constructor({ ...this._def, description: t });
  }
  pipe(t) {
    return _i.create(this, t);
  }
  readonly() {
    return hi.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Hh = /^c[^\s-]{8,}$/i, Jh = /^[0-9a-z]+$/, Vh = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Gh = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Wh = /^[a-z0-9_-]{21}$/i, Zh = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Kh = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Yh = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
let Ls;
const Xh = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Qh = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, ef = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, tf = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, nf = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, rf = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, ju = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", sf = new RegExp(`^${ju}$`);
function Au(e) {
  let t = "[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), `([01]\\d|2[0-3]):[0-5]\\d(:${t})${e.precision ? "+" : "?"}`;
}
function of(e) {
  let t = `${ju}T${Au(e)}`;
  const n = [];
  return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, new RegExp(`^${t}$`);
}
function af(e, t) {
  if (!Zh.test(e)) return !1;
  try {
    const [n] = e.split(".");
    if (!n) return !1;
    const s = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), r = JSON.parse(atob(s));
    return !(typeof r != "object" || r === null || "typ" in r && (r == null ? void 0 : r.typ) !== "JWT" || !r.alg || t && r.alg !== t);
  } catch {
    return !1;
  }
}
function uf(e, t) {
  return !(t !== "v4" && t || !Qh.test(e)) || !(t !== "v6" && t || !tf.test(e));
}
class Dt extends ae {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== $.string) {
      const o = this._getOrReturnCtx(t);
      return D(o, { code: L.invalid_type, expected: $.string, received: o.parsedType }), Q;
    }
    const n = new ct();
    let s;
    for (const o of this._def.checks) if (o.kind === "min") t.data.length < o.value && (s = this._getOrReturnCtx(t, s), D(s, { code: L.too_small, minimum: o.value, type: "string", inclusive: !0, exact: !1, message: o.message }), n.dirty());
    else if (o.kind === "max") t.data.length > o.value && (s = this._getOrReturnCtx(t, s), D(s, { code: L.too_big, maximum: o.value, type: "string", inclusive: !0, exact: !1, message: o.message }), n.dirty());
    else if (o.kind === "length") {
      const a = t.data.length > o.value, u = t.data.length < o.value;
      (a || u) && (s = this._getOrReturnCtx(t, s), a ? D(s, { code: L.too_big, maximum: o.value, type: "string", inclusive: !0, exact: !0, message: o.message }) : u && D(s, { code: L.too_small, minimum: o.value, type: "string", inclusive: !0, exact: !0, message: o.message }), n.dirty());
    } else if (o.kind === "email") Yh.test(t.data) || (s = this._getOrReturnCtx(t, s), D(s, { validation: "email", code: L.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "emoji") Ls || (Ls = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u")), Ls.test(t.data) || (s = this._getOrReturnCtx(t, s), D(s, { validation: "emoji", code: L.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "uuid") Gh.test(t.data) || (s = this._getOrReturnCtx(t, s), D(s, { validation: "uuid", code: L.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "nanoid") Wh.test(t.data) || (s = this._getOrReturnCtx(t, s), D(s, { validation: "nanoid", code: L.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "cuid") Hh.test(t.data) || (s = this._getOrReturnCtx(t, s), D(s, { validation: "cuid", code: L.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "cuid2") Jh.test(t.data) || (s = this._getOrReturnCtx(t, s), D(s, { validation: "cuid2", code: L.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "ulid") Vh.test(t.data) || (s = this._getOrReturnCtx(t, s), D(s, { validation: "ulid", code: L.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "url") try {
      new URL(t.data);
    } catch {
      s = this._getOrReturnCtx(t, s), D(s, { validation: "url", code: L.invalid_string, message: o.message }), n.dirty();
    }
    else o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(t.data) || (s = this._getOrReturnCtx(t, s), D(s, { validation: "regex", code: L.invalid_string, message: o.message }), n.dirty())) : o.kind === "trim" ? t.data = t.data.trim() : o.kind === "includes" ? t.data.includes(o.value, o.position) || (s = this._getOrReturnCtx(t, s), D(s, { code: L.invalid_string, validation: { includes: o.value, position: o.position }, message: o.message }), n.dirty()) : o.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : o.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : o.kind === "startsWith" ? t.data.startsWith(o.value) || (s = this._getOrReturnCtx(t, s), D(s, { code: L.invalid_string, validation: { startsWith: o.value }, message: o.message }), n.dirty()) : o.kind === "endsWith" ? t.data.endsWith(o.value) || (s = this._getOrReturnCtx(t, s), D(s, { code: L.invalid_string, validation: { endsWith: o.value }, message: o.message }), n.dirty()) : o.kind === "datetime" ? of(o).test(t.data) || (s = this._getOrReturnCtx(t, s), D(s, { code: L.invalid_string, validation: "datetime", message: o.message }), n.dirty()) : o.kind === "date" ? sf.test(t.data) || (s = this._getOrReturnCtx(t, s), D(s, { code: L.invalid_string, validation: "date", message: o.message }), n.dirty()) : o.kind === "time" ? new RegExp(`^${Au(o)}$`).test(t.data) || (s = this._getOrReturnCtx(t, s), D(s, { code: L.invalid_string, validation: "time", message: o.message }), n.dirty()) : o.kind === "duration" ? Kh.test(t.data) || (s = this._getOrReturnCtx(t, s), D(s, { validation: "duration", code: L.invalid_string, message: o.message }), n.dirty()) : o.kind === "ip" ? (r = t.data, ((i = o.version) !== "v4" && i || !Xh.test(r)) && (i !== "v6" && i || !ef.test(r)) && (s = this._getOrReturnCtx(t, s), D(s, { validation: "ip", code: L.invalid_string, message: o.message }), n.dirty())) : o.kind === "jwt" ? af(t.data, o.alg) || (s = this._getOrReturnCtx(t, s), D(s, { validation: "jwt", code: L.invalid_string, message: o.message }), n.dirty()) : o.kind === "cidr" ? uf(t.data, o.version) || (s = this._getOrReturnCtx(t, s), D(s, { validation: "cidr", code: L.invalid_string, message: o.message }), n.dirty()) : o.kind === "base64" ? nf.test(t.data) || (s = this._getOrReturnCtx(t, s), D(s, { validation: "base64", code: L.invalid_string, message: o.message }), n.dirty()) : o.kind === "base64url" ? rf.test(t.data) || (s = this._getOrReturnCtx(t, s), D(s, { validation: "base64url", code: L.invalid_string, message: o.message }), n.dirty()) : he.assertNever(o);
    var r, i;
    return { status: n.value, value: t.data };
  }
  _regex(t, n, s) {
    return this.refinement((r) => t.test(r), { validation: n, code: L.invalid_string, ...q.errToObj(s) });
  }
  _addCheck(t) {
    return new Dt({ ...this._def, checks: [...this._def.checks, t] });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...q.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...q.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...q.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...q.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...q.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...q.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...q.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...q.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...q.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({ kind: "base64url", ...q.errToObj(t) });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...q.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...q.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...q.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({ kind: "datetime", precision: null, offset: !1, local: !1, message: t }) : this._addCheck({ kind: "datetime", precision: (t == null ? void 0 : t.precision) === void 0 ? null : t == null ? void 0 : t.precision, offset: (t == null ? void 0 : t.offset) ?? !1, local: (t == null ? void 0 : t.local) ?? !1, ...q.errToObj(t == null ? void 0 : t.message) });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({ kind: "time", precision: null, message: t }) : this._addCheck({ kind: "time", precision: (t == null ? void 0 : t.precision) === void 0 ? null : t == null ? void 0 : t.precision, ...q.errToObj(t == null ? void 0 : t.message) });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...q.errToObj(t) });
  }
  regex(t, n) {
    return this._addCheck({ kind: "regex", regex: t, ...q.errToObj(n) });
  }
  includes(t, n) {
    return this._addCheck({ kind: "includes", value: t, position: n == null ? void 0 : n.position, ...q.errToObj(n == null ? void 0 : n.message) });
  }
  startsWith(t, n) {
    return this._addCheck({ kind: "startsWith", value: t, ...q.errToObj(n) });
  }
  endsWith(t, n) {
    return this._addCheck({ kind: "endsWith", value: t, ...q.errToObj(n) });
  }
  min(t, n) {
    return this._addCheck({ kind: "min", value: t, ...q.errToObj(n) });
  }
  max(t, n) {
    return this._addCheck({ kind: "max", value: t, ...q.errToObj(n) });
  }
  length(t, n) {
    return this._addCheck({ kind: "length", value: t, ...q.errToObj(n) });
  }
  nonempty(t) {
    return this.min(1, q.errToObj(t));
  }
  trim() {
    return new Dt({ ...this._def, checks: [...this._def.checks, { kind: "trim" }] });
  }
  toLowerCase() {
    return new Dt({ ...this._def, checks: [...this._def.checks, { kind: "toLowerCase" }] });
  }
  toUpperCase() {
    return new Dt({ ...this._def, checks: [...this._def.checks, { kind: "toUpperCase" }] });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks) n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks) n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
function cf(e, t) {
  const n = (e.toString().split(".")[1] || "").length, s = (t.toString().split(".")[1] || "").length, r = n > s ? n : s;
  return Number.parseInt(e.toFixed(r).replace(".", "")) % Number.parseInt(t.toFixed(r).replace(".", "")) / 10 ** r;
}
Dt.create = (e) => new Dt({ checks: [], typeName: X.ZodString, coerce: (e == null ? void 0 : e.coerce) ?? !1, ...ne(e) });
class Sn extends ae {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== $.number) {
      const r = this._getOrReturnCtx(t);
      return D(r, { code: L.invalid_type, expected: $.number, received: r.parsedType }), Q;
    }
    let n;
    const s = new ct();
    for (const r of this._def.checks) r.kind === "int" ? he.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), D(n, { code: L.invalid_type, expected: "integer", received: "float", message: r.message }), s.dirty()) : r.kind === "min" ? (r.inclusive ? t.data < r.value : t.data <= r.value) && (n = this._getOrReturnCtx(t, n), D(n, { code: L.too_small, minimum: r.value, type: "number", inclusive: r.inclusive, exact: !1, message: r.message }), s.dirty()) : r.kind === "max" ? (r.inclusive ? t.data > r.value : t.data >= r.value) && (n = this._getOrReturnCtx(t, n), D(n, { code: L.too_big, maximum: r.value, type: "number", inclusive: r.inclusive, exact: !1, message: r.message }), s.dirty()) : r.kind === "multipleOf" ? cf(t.data, r.value) !== 0 && (n = this._getOrReturnCtx(t, n), D(n, { code: L.not_multiple_of, multipleOf: r.value, message: r.message }), s.dirty()) : r.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), D(n, { code: L.not_finite, message: r.message }), s.dirty()) : he.assertNever(r);
    return { status: s.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, q.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, q.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, q.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, q.toString(n));
  }
  setLimit(t, n, s, r) {
    return new Sn({ ...this._def, checks: [...this._def.checks, { kind: t, value: n, inclusive: s, message: q.toString(r) }] });
  }
  _addCheck(t) {
    return new Sn({ ...this._def, checks: [...this._def.checks, t] });
  }
  int(t) {
    return this._addCheck({ kind: "int", message: q.toString(t) });
  }
  positive(t) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !1, message: q.toString(t) });
  }
  negative(t) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !1, message: q.toString(t) });
  }
  nonpositive(t) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !0, message: q.toString(t) });
  }
  nonnegative(t) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !0, message: q.toString(t) });
  }
  multipleOf(t, n) {
    return this._addCheck({ kind: "multipleOf", value: t, message: q.toString(n) });
  }
  finite(t) {
    return this._addCheck({ kind: "finite", message: q.toString(t) });
  }
  safe(t) {
    return this._addCheck({ kind: "min", inclusive: !0, value: Number.MIN_SAFE_INTEGER, message: q.toString(t) })._addCheck({ kind: "max", inclusive: !0, value: Number.MAX_SAFE_INTEGER, message: q.toString(t) });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks) n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks) n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && he.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const s of this._def.checks) {
      if (s.kind === "finite" || s.kind === "int" || s.kind === "multipleOf") return !0;
      s.kind === "min" ? (n === null || s.value > n) && (n = s.value) : s.kind === "max" && (t === null || s.value < t) && (t = s.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
Sn.create = (e) => new Sn({ checks: [], typeName: X.ZodNumber, coerce: (e == null ? void 0 : e.coerce) || !1, ...ne(e) });
class Xn extends ae {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce) try {
      t.data = BigInt(t.data);
    } catch {
      return this._getInvalidInput(t);
    }
    if (this._getType(t) !== $.bigint) return this._getInvalidInput(t);
    let n;
    const s = new ct();
    for (const r of this._def.checks) r.kind === "min" ? (r.inclusive ? t.data < r.value : t.data <= r.value) && (n = this._getOrReturnCtx(t, n), D(n, { code: L.too_small, type: "bigint", minimum: r.value, inclusive: r.inclusive, message: r.message }), s.dirty()) : r.kind === "max" ? (r.inclusive ? t.data > r.value : t.data >= r.value) && (n = this._getOrReturnCtx(t, n), D(n, { code: L.too_big, type: "bigint", maximum: r.value, inclusive: r.inclusive, message: r.message }), s.dirty()) : r.kind === "multipleOf" ? t.data % r.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), D(n, { code: L.not_multiple_of, multipleOf: r.value, message: r.message }), s.dirty()) : he.assertNever(r);
    return { status: s.value, value: t.data };
  }
  _getInvalidInput(t) {
    const n = this._getOrReturnCtx(t);
    return D(n, { code: L.invalid_type, expected: $.bigint, received: n.parsedType }), Q;
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, q.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, q.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, q.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, q.toString(n));
  }
  setLimit(t, n, s, r) {
    return new Xn({ ...this._def, checks: [...this._def.checks, { kind: t, value: n, inclusive: s, message: q.toString(r) }] });
  }
  _addCheck(t) {
    return new Xn({ ...this._def, checks: [...this._def.checks, t] });
  }
  positive(t) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !1, message: q.toString(t) });
  }
  negative(t) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !1, message: q.toString(t) });
  }
  nonpositive(t) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !0, message: q.toString(t) });
  }
  nonnegative(t) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !0, message: q.toString(t) });
  }
  multipleOf(t, n) {
    return this._addCheck({ kind: "multipleOf", value: t, message: q.toString(n) });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks) n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks) n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Xn.create = (e) => new Xn({ checks: [], typeName: X.ZodBigInt, coerce: (e == null ? void 0 : e.coerce) ?? !1, ...ne(e) });
class ai extends ae {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== $.boolean) {
      const n = this._getOrReturnCtx(t);
      return D(n, { code: L.invalid_type, expected: $.boolean, received: n.parsedType }), Q;
    }
    return yt(t.data);
  }
}
ai.create = (e) => new ai({ typeName: X.ZodBoolean, coerce: (e == null ? void 0 : e.coerce) || !1, ...ne(e) });
class es extends ae {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== $.date) {
      const r = this._getOrReturnCtx(t);
      return D(r, { code: L.invalid_type, expected: $.date, received: r.parsedType }), Q;
    }
    if (Number.isNaN(t.data.getTime())) return D(this._getOrReturnCtx(t), { code: L.invalid_date }), Q;
    const n = new ct();
    let s;
    for (const r of this._def.checks) r.kind === "min" ? t.data.getTime() < r.value && (s = this._getOrReturnCtx(t, s), D(s, { code: L.too_small, message: r.message, inclusive: !0, exact: !1, minimum: r.value, type: "date" }), n.dirty()) : r.kind === "max" ? t.data.getTime() > r.value && (s = this._getOrReturnCtx(t, s), D(s, { code: L.too_big, message: r.message, inclusive: !0, exact: !1, maximum: r.value, type: "date" }), n.dirty()) : he.assertNever(r);
    return { status: n.value, value: new Date(t.data.getTime()) };
  }
  _addCheck(t) {
    return new es({ ...this._def, checks: [...this._def.checks, t] });
  }
  min(t, n) {
    return this._addCheck({ kind: "min", value: t.getTime(), message: q.toString(n) });
  }
  max(t, n) {
    return this._addCheck({ kind: "max", value: t.getTime(), message: q.toString(n) });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks) n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks) n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
es.create = (e) => new es({ checks: [], coerce: (e == null ? void 0 : e.coerce) || !1, typeName: X.ZodDate, ...ne(e) });
class zo extends ae {
  _parse(t) {
    if (this._getType(t) !== $.symbol) {
      const n = this._getOrReturnCtx(t);
      return D(n, { code: L.invalid_type, expected: $.symbol, received: n.parsedType }), Q;
    }
    return yt(t.data);
  }
}
zo.create = (e) => new zo({ typeName: X.ZodSymbol, ...ne(e) });
class qo extends ae {
  _parse(t) {
    if (this._getType(t) !== $.undefined) {
      const n = this._getOrReturnCtx(t);
      return D(n, { code: L.invalid_type, expected: $.undefined, received: n.parsedType }), Q;
    }
    return yt(t.data);
  }
}
qo.create = (e) => new qo({ typeName: X.ZodUndefined, ...ne(e) });
class Ho extends ae {
  _parse(t) {
    if (this._getType(t) !== $.null) {
      const n = this._getOrReturnCtx(t);
      return D(n, { code: L.invalid_type, expected: $.null, received: n.parsedType }), Q;
    }
    return yt(t.data);
  }
}
Ho.create = (e) => new Ho({ typeName: X.ZodNull, ...ne(e) });
class Jo extends ae {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return yt(t.data);
  }
}
Jo.create = (e) => new Jo({ typeName: X.ZodAny, ...ne(e) });
class Vo extends ae {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return yt(t.data);
  }
}
Vo.create = (e) => new Vo({ typeName: X.ZodUnknown, ...ne(e) });
class Ht extends ae {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return D(n, { code: L.invalid_type, expected: $.never, received: n.parsedType }), Q;
  }
}
Ht.create = (e) => new Ht({ typeName: X.ZodNever, ...ne(e) });
class Go extends ae {
  _parse(t) {
    if (this._getType(t) !== $.undefined) {
      const n = this._getOrReturnCtx(t);
      return D(n, { code: L.invalid_type, expected: $.void, received: n.parsedType }), Q;
    }
    return yt(t.data);
  }
}
Go.create = (e) => new Go({ typeName: X.ZodVoid, ...ne(e) });
class It extends ae {
  _parse(t) {
    const { ctx: n, status: s } = this._processInputParams(t), r = this._def;
    if (n.parsedType !== $.array) return D(n, { code: L.invalid_type, expected: $.array, received: n.parsedType }), Q;
    if (r.exactLength !== null) {
      const o = n.data.length > r.exactLength.value, a = n.data.length < r.exactLength.value;
      (o || a) && (D(n, { code: o ? L.too_big : L.too_small, minimum: a ? r.exactLength.value : void 0, maximum: o ? r.exactLength.value : void 0, type: "array", inclusive: !0, exact: !0, message: r.exactLength.message }), s.dirty());
    }
    if (r.minLength !== null && n.data.length < r.minLength.value && (D(n, { code: L.too_small, minimum: r.minLength.value, type: "array", inclusive: !0, exact: !1, message: r.minLength.message }), s.dirty()), r.maxLength !== null && n.data.length > r.maxLength.value && (D(n, { code: L.too_big, maximum: r.maxLength.value, type: "array", inclusive: !0, exact: !1, message: r.maxLength.message }), s.dirty()), n.common.async) return Promise.all([...n.data].map((o, a) => r.type._parseAsync(new Pt(n, o, n.path, a)))).then((o) => ct.mergeArray(s, o));
    const i = [...n.data].map((o, a) => r.type._parseSync(new Pt(n, o, n.path, a)));
    return ct.mergeArray(s, i);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new It({ ...this._def, minLength: { value: t, message: q.toString(n) } });
  }
  max(t, n) {
    return new It({ ...this._def, maxLength: { value: t, message: q.toString(n) } });
  }
  length(t, n) {
    return new It({ ...this._def, exactLength: { value: t, message: q.toString(n) } });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
function an(e) {
  if (e instanceof Be) {
    const t = {};
    for (const n in e.shape) {
      const s = e.shape[n];
      t[n] = Jt.create(an(s));
    }
    return new Be({ ...e._def, shape: () => t });
  }
  return e instanceof It ? new It({ ...e._def, type: an(e.element) }) : e instanceof Jt ? Jt.create(an(e.unwrap())) : e instanceof xn ? xn.create(an(e.unwrap())) : e instanceof en ? en.create(e.items.map((t) => an(t))) : e;
}
It.create = (e, t) => new It({ type: e, minLength: null, maxLength: null, exactLength: null, typeName: X.ZodArray, ...ne(t) });
class Be extends ae {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null) return this._cached;
    const t = this._def.shape(), n = he.objectKeys(t);
    return this._cached = { shape: t, keys: n }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== $.object) {
      const u = this._getOrReturnCtx(t);
      return D(u, { code: L.invalid_type, expected: $.object, received: u.parsedType }), Q;
    }
    const { status: n, ctx: s } = this._processInputParams(t), { shape: r, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Ht && this._def.unknownKeys === "strip")) for (const u in s.data) i.includes(u) || o.push(u);
    const a = [];
    for (const u of i) {
      const c = r[u], l = s.data[u];
      a.push({ key: { status: "valid", value: u }, value: c._parse(new Pt(s, l, s.path, u)), alwaysSet: u in s.data });
    }
    if (this._def.catchall instanceof Ht) {
      const u = this._def.unknownKeys;
      if (u === "passthrough") for (const c of o) a.push({ key: { status: "valid", value: c }, value: { status: "valid", value: s.data[c] } });
      else if (u === "strict") o.length > 0 && (D(s, { code: L.unrecognized_keys, keys: o }), n.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const c of o) {
        const l = s.data[c];
        a.push({ key: { status: "valid", value: c }, value: u._parse(new Pt(s, l, s.path, c)), alwaysSet: c in s.data });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const c of a) {
        const l = await c.key, d = await c.value;
        u.push({ key: l, value: d, alwaysSet: c.alwaysSet });
      }
      return u;
    }).then((u) => ct.mergeObjectSync(n, u)) : ct.mergeObjectSync(n, a);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return q.errToObj, new Be({ ...this._def, unknownKeys: "strict", ...t !== void 0 ? { errorMap: (n, s) => {
      var i, o;
      const r = ((o = (i = this._def).errorMap) == null ? void 0 : o.call(i, n, s).message) ?? s.defaultError;
      return n.code === "unrecognized_keys" ? { message: q.errToObj(t).message ?? r } : { message: r };
    } } : {} });
  }
  strip() {
    return new Be({ ...this._def, unknownKeys: "strip" });
  }
  passthrough() {
    return new Be({ ...this._def, unknownKeys: "passthrough" });
  }
  extend(t) {
    return new Be({ ...this._def, shape: () => ({ ...this._def.shape(), ...t }) });
  }
  merge(t) {
    return new Be({ unknownKeys: t._def.unknownKeys, catchall: t._def.catchall, shape: () => ({ ...this._def.shape(), ...t._def.shape() }), typeName: X.ZodObject });
  }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  catchall(t) {
    return new Be({ ...this._def, catchall: t });
  }
  pick(t) {
    const n = {};
    for (const s of he.objectKeys(t)) t[s] && this.shape[s] && (n[s] = this.shape[s]);
    return new Be({ ...this._def, shape: () => n });
  }
  omit(t) {
    const n = {};
    for (const s of he.objectKeys(this.shape)) t[s] || (n[s] = this.shape[s]);
    return new Be({ ...this._def, shape: () => n });
  }
  deepPartial() {
    return an(this);
  }
  partial(t) {
    const n = {};
    for (const s of he.objectKeys(this.shape)) {
      const r = this.shape[s];
      t && !t[s] ? n[s] = r : n[s] = r.optional();
    }
    return new Be({ ...this._def, shape: () => n });
  }
  required(t) {
    const n = {};
    for (const s of he.objectKeys(this.shape)) if (t && !t[s]) n[s] = this.shape[s];
    else {
      let r = this.shape[s];
      for (; r instanceof Jt; ) r = r._def.innerType;
      n[s] = r;
    }
    return new Be({ ...this._def, shape: () => n });
  }
  keyof() {
    return Uu(he.objectKeys(this.shape));
  }
}
Be.create = (e, t) => new Be({ shape: () => e, unknownKeys: "strip", catchall: Ht.create(), typeName: X.ZodObject, ...ne(t) }), Be.strictCreate = (e, t) => new Be({ shape: () => e, unknownKeys: "strict", catchall: Ht.create(), typeName: X.ZodObject, ...ne(t) }), Be.lazycreate = (e, t) => new Be({ shape: e, unknownKeys: "strip", catchall: Ht.create(), typeName: X.ZodObject, ...ne(t) });
class ts extends ae {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), s = this._def.options;
    if (n.common.async) return Promise.all(s.map(async (r) => {
      const i = { ...n, common: { ...n.common, issues: [] }, parent: null };
      return { result: await r._parseAsync({ data: n.data, path: n.path, parent: i }), ctx: i };
    })).then(function(r) {
      for (const o of r) if (o.result.status === "valid") return o.result;
      for (const o of r) if (o.result.status === "dirty") return n.common.issues.push(...o.ctx.common.issues), o.result;
      const i = r.map((o) => new Mt(o.ctx.common.issues));
      return D(n, { code: L.invalid_union, unionErrors: i }), Q;
    });
    {
      let r;
      const i = [];
      for (const a of s) {
        const u = { ...n, common: { ...n.common, issues: [] }, parent: null }, c = a._parseSync({ data: n.data, path: n.path, parent: u });
        if (c.status === "valid") return c;
        c.status !== "dirty" || r || (r = { result: c, ctx: u }), u.common.issues.length && i.push(u.common.issues);
      }
      if (r) return n.common.issues.push(...r.ctx.common.issues), r.result;
      const o = i.map((a) => new Mt(a));
      return D(n, { code: L.invalid_union, unionErrors: o }), Q;
    }
  }
  get options() {
    return this._def.options;
  }
}
function ui(e, t) {
  const n = zt(e), s = zt(t);
  if (e === t) return { valid: !0, data: e };
  if (n === $.object && s === $.object) {
    const r = he.objectKeys(t), i = he.objectKeys(e).filter((a) => r.indexOf(a) !== -1), o = { ...e, ...t };
    for (const a of i) {
      const u = ui(e[a], t[a]);
      if (!u.valid) return { valid: !1 };
      o[a] = u.data;
    }
    return { valid: !0, data: o };
  }
  if (n === $.array && s === $.array) {
    if (e.length !== t.length) return { valid: !1 };
    const r = [];
    for (let i = 0; i < e.length; i++) {
      const o = ui(e[i], t[i]);
      if (!o.valid) return { valid: !1 };
      r.push(o.data);
    }
    return { valid: !0, data: r };
  }
  return n === $.date && s === $.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
ts.create = (e, t) => new ts({ options: e, typeName: X.ZodUnion, ...ne(t) });
class ns extends ae {
  _parse(t) {
    const { status: n, ctx: s } = this._processInputParams(t), r = (i, o) => {
      if (Mo(i) || Mo(o)) return Q;
      const a = ui(i.value, o.value);
      return a.valid ? ((Bo(i) || Bo(o)) && n.dirty(), { status: n.value, value: a.data }) : (D(s, { code: L.invalid_intersection_types }), Q);
    };
    return s.common.async ? Promise.all([this._def.left._parseAsync({ data: s.data, path: s.path, parent: s }), this._def.right._parseAsync({ data: s.data, path: s.path, parent: s })]).then(([i, o]) => r(i, o)) : r(this._def.left._parseSync({ data: s.data, path: s.path, parent: s }), this._def.right._parseSync({ data: s.data, path: s.path, parent: s }));
  }
}
ns.create = (e, t, n) => new ns({ left: e, right: t, typeName: X.ZodIntersection, ...ne(n) });
class en extends ae {
  _parse(t) {
    const { status: n, ctx: s } = this._processInputParams(t);
    if (s.parsedType !== $.array) return D(s, { code: L.invalid_type, expected: $.array, received: s.parsedType }), Q;
    if (s.data.length < this._def.items.length) return D(s, { code: L.too_small, minimum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), Q;
    !this._def.rest && s.data.length > this._def.items.length && (D(s, { code: L.too_big, maximum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), n.dirty());
    const r = [...s.data].map((i, o) => {
      const a = this._def.items[o] || this._def.rest;
      return a ? a._parse(new Pt(s, i, s.path, o)) : null;
    }).filter((i) => !!i);
    return s.common.async ? Promise.all(r).then((i) => ct.mergeArray(n, i)) : ct.mergeArray(n, r);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new en({ ...this._def, rest: t });
  }
}
en.create = (e, t) => {
  if (!Array.isArray(e)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new en({ items: e, typeName: X.ZodTuple, rest: null, ...ne(t) });
};
class Ti extends ae {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: s } = this._processInputParams(t);
    if (s.parsedType !== $.object) return D(s, { code: L.invalid_type, expected: $.object, received: s.parsedType }), Q;
    const r = [], i = this._def.keyType, o = this._def.valueType;
    for (const a in s.data) r.push({ key: i._parse(new Pt(s, a, s.path, a)), value: o._parse(new Pt(s, s.data[a], s.path, a)), alwaysSet: a in s.data });
    return s.common.async ? ct.mergeObjectAsync(n, r) : ct.mergeObjectSync(n, r);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, s) {
    return new Ti(n instanceof ae ? { keyType: t, valueType: n, typeName: X.ZodRecord, ...ne(s) } : { keyType: Dt.create(), valueType: t, typeName: X.ZodRecord, ...ne(n) });
  }
}
class Wo extends ae {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: s } = this._processInputParams(t);
    if (s.parsedType !== $.map) return D(s, { code: L.invalid_type, expected: $.map, received: s.parsedType }), Q;
    const r = this._def.keyType, i = this._def.valueType, o = [...s.data.entries()].map(([a, u], c) => ({ key: r._parse(new Pt(s, a, s.path, [c, "key"])), value: i._parse(new Pt(s, u, s.path, [c, "value"])) }));
    if (s.common.async) {
      const a = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of o) {
          const c = await u.key, l = await u.value;
          if (c.status === "aborted" || l.status === "aborted") return Q;
          c.status !== "dirty" && l.status !== "dirty" || n.dirty(), a.set(c.value, l.value);
        }
        return { status: n.value, value: a };
      });
    }
    {
      const a = /* @__PURE__ */ new Map();
      for (const u of o) {
        const c = u.key, l = u.value;
        if (c.status === "aborted" || l.status === "aborted") return Q;
        c.status !== "dirty" && l.status !== "dirty" || n.dirty(), a.set(c.value, l.value);
      }
      return { status: n.value, value: a };
    }
  }
}
Wo.create = (e, t, n) => new Wo({ valueType: t, keyType: e, typeName: X.ZodMap, ...ne(n) });
class Qn extends ae {
  _parse(t) {
    const { status: n, ctx: s } = this._processInputParams(t);
    if (s.parsedType !== $.set) return D(s, { code: L.invalid_type, expected: $.set, received: s.parsedType }), Q;
    const r = this._def;
    r.minSize !== null && s.data.size < r.minSize.value && (D(s, { code: L.too_small, minimum: r.minSize.value, type: "set", inclusive: !0, exact: !1, message: r.minSize.message }), n.dirty()), r.maxSize !== null && s.data.size > r.maxSize.value && (D(s, { code: L.too_big, maximum: r.maxSize.value, type: "set", inclusive: !0, exact: !1, message: r.maxSize.message }), n.dirty());
    const i = this._def.valueType;
    function o(u) {
      const c = /* @__PURE__ */ new Set();
      for (const l of u) {
        if (l.status === "aborted") return Q;
        l.status === "dirty" && n.dirty(), c.add(l.value);
      }
      return { status: n.value, value: c };
    }
    const a = [...s.data.values()].map((u, c) => i._parse(new Pt(s, u, s.path, c)));
    return s.common.async ? Promise.all(a).then((u) => o(u)) : o(a);
  }
  min(t, n) {
    return new Qn({ ...this._def, minSize: { value: t, message: q.toString(n) } });
  }
  max(t, n) {
    return new Qn({ ...this._def, maxSize: { value: t, message: q.toString(n) } });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Qn.create = (e, t) => new Qn({ valueType: e, minSize: null, maxSize: null, typeName: X.ZodSet, ...ne(t) });
class Zo extends ae {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
Zo.create = (e, t) => new Zo({ getter: e, typeName: X.ZodLazy, ...ne(t) });
class ci extends ae {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return D(n, { received: n.data, code: L.invalid_literal, expected: this._def.value }), Q;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
function Uu(e, t) {
  return new Rn({ values: e, typeName: X.ZodEnum, ...ne(t) });
}
ci.create = (e, t) => new ci({ value: e, typeName: X.ZodLiteral, ...ne(t) });
class Rn extends ae {
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), s = this._def.values;
      return D(n, { expected: he.joinValues(s), received: n.parsedType, code: L.invalid_type }), Q;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(t.data)) {
      const n = this._getOrReturnCtx(t), s = this._def.values;
      return D(n, { received: n.data, code: L.invalid_enum_value, options: s }), Q;
    }
    return yt(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values) t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values) t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values) t[n] = n;
    return t;
  }
  extract(t, n = this._def) {
    return Rn.create(t, { ...this._def, ...n });
  }
  exclude(t, n = this._def) {
    return Rn.create(this.options.filter((s) => !t.includes(s)), { ...this._def, ...n });
  }
}
Rn.create = Uu;
class Ko extends ae {
  _parse(t) {
    const n = he.getValidEnumValues(this._def.values), s = this._getOrReturnCtx(t);
    if (s.parsedType !== $.string && s.parsedType !== $.number) {
      const r = he.objectValues(n);
      return D(s, { expected: he.joinValues(r), received: s.parsedType, code: L.invalid_type }), Q;
    }
    if (this._cache || (this._cache = new Set(he.getValidEnumValues(this._def.values))), !this._cache.has(t.data)) {
      const r = he.objectValues(n);
      return D(s, { received: s.data, code: L.invalid_enum_value, options: r }), Q;
    }
    return yt(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ko.create = (e, t) => new Ko({ values: e, typeName: X.ZodNativeEnum, ...ne(t) });
class rs extends ae {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== $.promise && n.common.async === !1) return D(n, { code: L.invalid_type, expected: $.promise, received: n.parsedType }), Q;
    const s = n.parsedType === $.promise ? n.data : Promise.resolve(n.data);
    return yt(s.then((r) => this._def.type.parseAsync(r, { path: n.path, errorMap: n.common.contextualErrorMap })));
  }
}
rs.create = (e, t) => new rs({ type: e, typeName: X.ZodPromise, ...ne(t) });
class cn extends ae {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === X.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: s } = this._processInputParams(t), r = this._def.effect || null, i = { addIssue: (o) => {
      D(s, o), o.fatal ? n.abort() : n.dirty();
    }, get path() {
      return s.path;
    } };
    if (i.addIssue = i.addIssue.bind(i), r.type === "preprocess") {
      const o = r.transform(s.data, i);
      if (s.common.async) return Promise.resolve(o).then(async (a) => {
        if (n.value === "aborted") return Q;
        const u = await this._def.schema._parseAsync({ data: a, path: s.path, parent: s });
        return u.status === "aborted" ? Q : u.status === "dirty" || n.value === "dirty" ? oi(u.value) : u;
      });
      {
        if (n.value === "aborted") return Q;
        const a = this._def.schema._parseSync({ data: o, path: s.path, parent: s });
        return a.status === "aborted" ? Q : a.status === "dirty" || n.value === "dirty" ? oi(a.value) : a;
      }
    }
    if (r.type === "refinement") {
      const o = (a) => {
        const u = r.refinement(a, i);
        if (s.common.async) return Promise.resolve(u);
        if (u instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return a;
      };
      if (s.common.async === !1) {
        const a = this._def.schema._parseSync({ data: s.data, path: s.path, parent: s });
        return a.status === "aborted" ? Q : (a.status === "dirty" && n.dirty(), o(a.value), { status: n.value, value: a.value });
      }
      return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((a) => a.status === "aborted" ? Q : (a.status === "dirty" && n.dirty(), o(a.value).then(() => ({ status: n.value, value: a.value }))));
    }
    if (r.type === "transform") {
      if (s.common.async === !1) {
        const o = this._def.schema._parseSync({ data: s.data, path: s.path, parent: s });
        if (!wn(o)) return Q;
        const a = r.transform(o.value, i);
        if (a instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: a };
      }
      return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((o) => wn(o) ? Promise.resolve(r.transform(o.value, i)).then((a) => ({ status: n.value, value: a })) : Q);
    }
    he.assertNever(r);
  }
}
cn.create = (e, t, n) => new cn({ schema: e, typeName: X.ZodEffects, effect: t, ...ne(n) }), cn.createWithPreprocess = (e, t, n) => new cn({ schema: t, effect: { type: "preprocess", transform: e }, typeName: X.ZodEffects, ...ne(n) });
class Jt extends ae {
  _parse(t) {
    return this._getType(t) === $.undefined ? yt(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Jt.create = (e, t) => new Jt({ innerType: e, typeName: X.ZodOptional, ...ne(t) });
class xn extends ae {
  _parse(t) {
    return this._getType(t) === $.null ? yt(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
xn.create = (e, t) => new xn({ innerType: e, typeName: X.ZodNullable, ...ne(t) });
class li extends ae {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let s = n.data;
    return n.parsedType === $.undefined && (s = this._def.defaultValue()), this._def.innerType._parse({ data: s, path: n.path, parent: n });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
li.create = (e, t) => new li({ innerType: e, typeName: X.ZodDefault, defaultValue: typeof t.default == "function" ? t.default : () => t.default, ...ne(t) });
class di extends ae {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), s = { ...n, common: { ...n.common, issues: [] } }, r = this._def.innerType._parse({ data: s.data, path: s.path, parent: { ...s } });
    return Qr(r) ? r.then((i) => ({ status: "valid", value: i.status === "valid" ? i.value : this._def.catchValue({ get error() {
      return new Mt(s.common.issues);
    }, input: s.data }) })) : { status: "valid", value: r.status === "valid" ? r.value : this._def.catchValue({ get error() {
      return new Mt(s.common.issues);
    }, input: s.data }) };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
di.create = (e, t) => new di({ innerType: e, typeName: X.ZodCatch, catchValue: typeof t.catch == "function" ? t.catch : () => t.catch, ...ne(t) });
class Yo extends ae {
  _parse(t) {
    if (this._getType(t) !== $.nan) {
      const n = this._getOrReturnCtx(t);
      return D(n, { code: L.invalid_type, expected: $.nan, received: n.parsedType }), Q;
    }
    return { status: "valid", value: t.data };
  }
}
Yo.create = (e) => new Yo({ typeName: X.ZodNaN, ...ne(e) });
class lf extends ae {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), s = n.data;
    return this._def.type._parse({ data: s, path: n.path, parent: n });
  }
  unwrap() {
    return this._def.type;
  }
}
class _i extends ae {
  _parse(t) {
    const { status: n, ctx: s } = this._processInputParams(t);
    if (s.common.async) return (async () => {
      const r = await this._def.in._parseAsync({ data: s.data, path: s.path, parent: s });
      return r.status === "aborted" ? Q : r.status === "dirty" ? (n.dirty(), oi(r.value)) : this._def.out._parseAsync({ data: r.value, path: s.path, parent: s });
    })();
    {
      const r = this._def.in._parseSync({ data: s.data, path: s.path, parent: s });
      return r.status === "aborted" ? Q : r.status === "dirty" ? (n.dirty(), { status: "dirty", value: r.value }) : this._def.out._parseSync({ data: r.value, path: s.path, parent: s });
    }
  }
  static create(t, n) {
    return new _i({ in: t, out: n, typeName: X.ZodPipeline });
  }
}
class hi extends ae {
  _parse(t) {
    const n = this._def.innerType._parse(t), s = (r) => (wn(r) && (r.value = Object.freeze(r.value)), r);
    return Qr(n) ? n.then((r) => s(r)) : s(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
var X;
hi.create = (e, t) => new hi({ innerType: e, typeName: X.ZodReadonly, ...ne(t) }), function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
}(X || (X = {}));
const x = Dt.create, ee = Sn.create, kt = ai.create, qe = (Ht.create, It.create), oe = Be.create, gr = ts.create, Lu = (ns.create, en.create, Ti.create), Nu = ci.create, Pe = Rn.create;
rs.create, Jt.create, xn.create;
var Du = ee().min(0).max(yn).refine(function(e) {
  return Math.abs(Math.round(10 * e) - 10 * e) < 1e-6;
}, { message: "score must be a multiple of 0.1" }), Fu = Pe(["N", "C"]);
oe({ status: Pe(["confirmed", "inferred", "unmapped"]), confidence: Pe(["high", "medium", "low"]), signals: qe(x()), confirmedBy: x().nullable(), confirmedAt: x().nullable(), source: Pe(["reviewer", "auto"]) });
var Mu = oe({ id: x().optional(), type: Fu.default("N"), movementNumber: ee().int().positive(), description: x(), directive: x().optional(), location: x().optional(), coefficient: ee().min(0.01).max(10), section: Pe(["technical", "artistic", "quality"]).optional() }), df = oe({ id: x().optional(), type: Fu.default("C"), movementNumber: ee().int().positive(), name: x(), directive: x().optional(), coefficient: ee().min(0.01).max(10) }), hf = Mu.extend({ displayOrder: ee() }), ff = oe({ added: qe(hf).default([]), removed: qe(ee().int().positive()).default([]) });
oe({ id: x(), fvdId: gr([ee(), x()]).nullable().optional(), source: Pe(["catalog", "custom"]).optional(), testCode: x(), organization: x().optional(), level: x().optional(), testNumber: ee().int().optional(), movements: qe(Mu), collectives: qe(df), purpose: x().optional(), introduce: x().optional(), errorRule: oe({ unit: Pe(["points", "percent"]).optional(), first: gr([ee(), x()]).nullable().optional(), second: gr([ee(), x()]).nullable().optional(), third: gr([ee(), x()]).nullable().optional() }).nullable().optional(), collectivesLabel: x().default("Collective Marks"), commentMode: Pe(["perMovement", "generalOnly"]).default("perMovement"), hasRideTiming: kt().default(!0), sheetLayout: Pe(["movement-grid", "class-grid"]).default("movement-grid"), observations: qe(oe({ key: x(), group: x(), label: x(), optional: Nu(!0) })).default([]), panel: oe({ minJudges: ee().int().positive(), maxJudges: ee().int().positive(), consensus: kt().default(!1), judgeFloor: ee().int().positive().optional(), judgeFloorRule: x().optional() }).optional(), placing: oe({ source: Pe(["computed", "judge-entered"]).default("computed"), tieBreak: Pe(["standard", "none", "ride-off", "movement-totals"]).default("standard") }).optional(), publication: oe({ scoreSheet: Pe(["public", "suppressed"]).default("public"), rule: x().optional() }).optional() });
var pf = oe({ movementNumber: ee().int().positive(), score: Du.optional().nullable(), remarks: x().max(500).optional(), flagged: kt().default(!1), annotatedDirective: x().optional(), annotatedDescription: x().optional(), deductions: qe(oe({ id: x(), reason: x(), points: ee().positive() })).optional() }), vf = oe({ score: Du.optional(), remarks: x().max(500).optional(), flagged: kt().optional(), annotatedName: x().optional(), annotatedDirective: x().optional() }), mf = Lu(x().regex(/^\d+$/), vf), gf = oe({ id: x(), movementNumber: ee().int().nullable().optional(), text: x().min(1).max(1e3), addedBy: x().nullable(), addedAt: x() });
oe({ id: x().optional(), rideId: x(), judgeId: x(), testId: x(), movementScores: qe(pf).default([]), collectives: mf.default({}), annotations: qe(gf).default([]), annotatedPurpose: x().optional(), annotatedIntroduce: x().optional(), generalRemarks: x().max(2e3).optional(), entryTimeSeconds: ee().nonnegative().optional(), totalPoints: ee().optional(), maxPoints: ee().optional(), percentage: ee().nullable().optional(), observationMarks: Lu(x(), ee()).optional(), place: ee().int().positive().nullable().optional(), technicalPoints: ee().optional(), technicalMaxPoints: ee().optional(), artisticPoints: ee().optional(), artisticMaxPoints: ee().optional(), qualityPoints: ee().optional(), qualityMaxPoints: ee().optional(), judgeSignature: x().optional(), signature: oe({ judgeId: x(), signatureHash: x(), signedAt: x() }).optional(), signatures: qe(oe({ judgeId: x(), signatureHash: x(), signedAt: x() })).optional(), compositeSignatures: qe(oe({ realJudgeId: x(), signatureHash: x(), signedAt: x() })).optional(), eliminations: qe(oe({ id: x(), reason: x(), movementNumber: ee().int().positive().nullable().optional(), fromError: kt().optional() })).optional(), errors: qe(oe({ id: x(), label: x(), points: ee().nonnegative().optional(), percent: ee().nonnegative().optional(), movementNumber: ee().int().positive().nullable().optional(), amountSource: Pe([Do.RULE, Do.MANUAL]).optional() })).optional(), marksConfirmedAt: x().optional(), marksConfirmedBy: x().optional(), timeFault: oe({ exceeded: kt(), elapsedSeconds: ee(), limitSeconds: ee(), recordedAt: x() }).optional(), completedAt: x().optional() });
Pe(Iu);
var Xo = oe(Object.fromEntries(Iu.map(function(e) {
  return [e, qe(x()).optional()];
})));
oe({ id: x(), showId: x(), testId: x().optional(), className: x(), scheduledTime: x(), ring: x().optional(), judgeAssignments: Xo.optional(), judgeIds: qe(x()).optional(), scribeAssignments: Xo.optional(), qualityJudging: oe({ topology: Pe(["two-judge", "technical-only"]), qualityPosition: Pe(["E", "B"]).nullable().optional(), qualityJudge: x().nullable().optional() }).optional(), faultTimeLimitSeconds: ee().int().positive().default(45), errorDeductionScheme: Pe(Object.values(Hn)).default(Hn.POINTS), sectionJudgeAssignments: oe({ technical: x().nullable().optional(), quality: x().nullable().optional() }).optional(), walkTrotOnly: kt().default(!1), order: ee().optional(), testDisagreement: oe({ flagged: Nu(!0), signals: qe(Pe(Object.values(Mh))).min(1) }).nullable().optional() });
var bf = oe({ id: x(), type: Pe(Object.values(Oi)), raisedByScribeId: x().nullable(), raisedAt: x(), acknowledged: oe({ byScribeId: x().nullable(), at: x() }).nullable().optional() });
oe({ type: Pe(Object.values(Oi)) });
var yf = oe({ eventId: x(), type: Pe(Object.values(Oi)), clearedByScribeId: x().nullable(), clearedAt: x() });
oe({ id: x(), classId: x(), testId: x().optional(), horseId: x(), riderId: x(), rideNumber: ee().int().positive(), scheduledTime: x().optional(), status: x().optional(), percentage: ee().optional(), priorScore: ee().nullable().optional(), allSheetsCompletedAt: x().nullable().optional(), adminConfirmedAt: x().nullable().optional(), adminConfirmedBy: x().nullable().optional(), compositePercentage: ee().nullable().optional(), placing: ee().int().positive().nullable().optional(), isManual: kt().optional(), needsReview: kt().optional(), judgeIds: qe(x()).optional(), competitorNumber: x().optional(), horseName: x().optional(), riderName: x().optional(), trainerId: x().optional(), resolvedIntoRideId: x().nullable().optional(), filledFromRideId: x().nullable().optional(), utilityEvents: qe(bf).optional(), utilityEventClears: qe(yf).optional(), movementOverride: ff.optional(), placingStaleAt: x().nullable().optional(), fvdWriteBackBlockedByOverride: kt().nullable().optional(), terminationReason: oe({ reason: Pe(Object.values(Nh)), setAt: x(), setBy: x().nullable().optional(), source: x() }).nullable().optional() });
oe({ classId: x(), showId: x().optional(), scheduledTime: x().optional(), testId: x().optional(), competitorNumber: x().optional(), horseName: x().optional(), riderName: x().optional() });
oe({ id: x(), personType: Pe(["RIDER", "JUDGE", "SCRIBE"]), firstName: x(), lastName: x(), usefId: x().optional(), usdfId: x().optional(), email: x().optional(), unlockCode: x().regex(/^\d{4,6}$/, "unlockCode must be 4–6 digits").optional(), userId: x().optional() });
oe({ id: x(), name: x(), breed: x().optional(), foalYear: ee().int().optional(), usefId: x().optional(), usdfId: x().optional() });
function Bu(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: wf } = Object.prototype, { getPrototypeOf: Ii } = Object, { iterator: jr, toStringTag: $u } = Symbol, ss = (Ns = /* @__PURE__ */ Object.create(null), (e) => {
  const t = wf.call(e);
  return Ns[t] || (Ns[t] = t.slice(8, -1).toLowerCase());
});
var Ns;
const Ot = (e) => (e = e.toLowerCase(), (t) => ss(t) === e), hs = (e) => (t) => typeof t === e, { isArray: un } = Array, vn = hs("undefined");
function Jn(e) {
  return e !== null && !vn(e) && e.constructor !== null && !vn(e.constructor) && ft(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Qo = Ot("ArrayBuffer"), Sf = hs("string"), ft = hs("function"), ea = hs("number"), Nn = (e) => e !== null && typeof e == "object", br = (e) => {
  if (ss(e) !== "object") return !1;
  const t = Ii(e);
  return !(t !== null && t !== Object.prototype && Object.getPrototypeOf(t) !== null || $u in e || jr in e);
}, Rf = Ot("Date"), xf = Ot("File"), Cf = Ot("Blob"), Ef = Ot("FileList"), Of = Ot("URLSearchParams"), [Tf, _f, If, kf] = ["ReadableStream", "Request", "Response", "Headers"].map(Ot);
function zn(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e == null) return;
  let s, r;
  if (typeof e != "object" && (e = [e]), un(e)) for (s = 0, r = e.length; s < r; s++) t.call(null, e[s], s, e);
  else {
    if (Jn(e)) return;
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let a;
    for (s = 0; s < o; s++) a = i[s], t.call(null, e[a], a, e);
  }
}
function ta(e, t) {
  if (Jn(e)) return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let s, r = n.length;
  for (; r-- > 0; ) if (s = n[r], t === s.toLowerCase()) return s;
  return null;
}
const Xt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, na = (e) => !vn(e) && e !== Xt, Pf = (Ds = typeof Uint8Array < "u" && Ii(Uint8Array), (e) => Ds && e instanceof Ds);
var Ds;
const jf = Ot("HTMLFormElement"), ra = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Af = Ot("RegExp"), sa = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), s = {};
  zn(n, (r, i) => {
    let o;
    (o = t(r, i, e)) !== !1 && (s[i] = o || r);
  }), Object.defineProperties(e, s);
}, Uf = Ot("AsyncFunction"), zu = (ia = typeof setImmediate == "function", oa = ft(Xt.postMessage), ia ? setImmediate : oa ? (Fs = `axios@${Math.random()}`, yr = [], Xt.addEventListener("message", ({ source: e, data: t }) => {
  e === Xt && t === Fs && yr.length && yr.shift()();
}, !1), (e) => {
  yr.push(e), Xt.postMessage(Fs, "*");
}) : (e) => setTimeout(e));
var ia, oa, Fs, yr;
const Lf = typeof queueMicrotask < "u" ? queueMicrotask.bind(Xt) : typeof process < "u" && process.nextTick || zu, R = { isArray: un, isArrayBuffer: Qo, isBuffer: Jn, isFormData: (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || ft(e.append) && ((t = ss(e)) === "formdata" || t === "object" && ft(e.toString) && e.toString() === "[object FormData]"));
}, isArrayBufferView: function(e) {
  let t;
  return t = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && Qo(e.buffer), t;
}, isString: Sf, isNumber: ea, isBoolean: (e) => e === !0 || e === !1, isObject: Nn, isPlainObject: br, isEmptyObject: (e) => {
  if (!Nn(e) || Jn(e)) return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, isReadableStream: Tf, isRequest: _f, isResponse: If, isHeaders: kf, isUndefined: vn, isDate: Rf, isFile: xf, isBlob: Cf, isRegExp: Af, isFunction: ft, isStream: (e) => Nn(e) && ft(e.pipe), isURLSearchParams: Of, isTypedArray: Pf, isFileList: Ef, forEach: zn, merge: function e() {
  const { caseless: t, skipUndefined: n } = na(this) && this || {}, s = {}, r = (i, o) => {
    const a = t && ta(s, o) || o;
    br(s[a]) && br(i) ? s[a] = e(s[a], i) : br(i) ? s[a] = e({}, i) : un(i) ? s[a] = i.slice() : n && vn(i) || (s[a] = i);
  };
  for (let i = 0, o = arguments.length; i < o; i++) arguments[i] && zn(arguments[i], r);
  return s;
}, extend: (e, t, n, { allOwnKeys: s } = {}) => (zn(t, (r, i) => {
  n && ft(r) ? e[i] = Bu(r, n) : e[i] = r;
}, { allOwnKeys: s }), e), trim: (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), stripBOM: (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), inherits: (e, t, n, s) => {
  e.prototype = Object.create(t.prototype, s), e.prototype.constructor = e, Object.defineProperty(e, "super", { value: t.prototype }), n && Object.assign(e.prototype, n);
}, toFlatObject: (e, t, n, s) => {
  let r, i, o;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (r = Object.getOwnPropertyNames(e), i = r.length; i-- > 0; ) o = r[i], s && !s(o, e, t) || a[o] || (t[o] = e[o], a[o] = !0);
    e = n !== !1 && Ii(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, kindOf: ss, kindOfTest: Ot, endsWith: (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const s = e.indexOf(t, n);
  return s !== -1 && s === n;
}, toArray: (e) => {
  if (!e) return null;
  if (un(e)) return e;
  let t = e.length;
  if (!ea(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; ) n[t] = e[t];
  return n;
}, forEachEntry: (e, t) => {
  const n = (e && e[jr]).call(e);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const r = s.value;
    t.call(e, r[0], r[1]);
  }
}, matchAll: (e, t) => {
  let n;
  const s = [];
  for (; (n = e.exec(t)) !== null; ) s.push(n);
  return s;
}, isHTMLForm: jf, hasOwnProperty: ra, hasOwnProp: ra, reduceDescriptors: sa, freezeMethods: (e) => {
  sa(e, (t, n) => {
    if (ft(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1) return !1;
    const s = e[n];
    ft(s) && (t.enumerable = !1, "writable" in t ? t.writable = !1 : t.set || (t.set = () => {
      throw Error("Can not rewrite read-only method '" + n + "'");
    }));
  });
}, toObjectSet: (e, t) => {
  const n = {}, s = (r) => {
    r.forEach((i) => {
      n[i] = !0;
    });
  };
  return un(e) ? s(e) : s(String(e).split(t)), n;
}, toCamelCase: (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, n, s) {
  return n.toUpperCase() + s;
}), noop: () => {
}, toFiniteNumber: (e, t) => e != null && Number.isFinite(e = +e) ? e : t, findKey: ta, global: Xt, isContextDefined: na, isSpecCompliantForm: function(e) {
  return !!(e && ft(e.append) && e[$u] === "FormData" && e[jr]);
}, toJSONObject: (e) => {
  const t = new Array(10), n = (s, r) => {
    if (Nn(s)) {
      if (t.indexOf(s) >= 0) return;
      if (Jn(s)) return s;
      if (!("toJSON" in s)) {
        t[r] = s;
        const i = un(s) ? [] : {};
        return zn(s, (o, a) => {
          const u = n(o, r + 1);
          !vn(u) && (i[a] = u);
        }), t[r] = void 0, i;
      }
    }
    return s;
  };
  return n(e, 0);
}, isAsyncFn: Uf, isThenable: (e) => e && (Nn(e) || ft(e)) && ft(e.then) && ft(e.catch), setImmediate: zu, asap: Lf, isIterable: (e) => e != null && ft(e[jr]) };
function mn(e, t, n, s, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), s && (this.request = s), r && (this.response = r, this.status = r.status ? r.status : null);
}
R.inherits(mn, Error, { toJSON: function() {
  return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: R.toJSONObject(this.config), code: this.code, status: this.status };
} });
const aa = mn.prototype, ua = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((e) => {
  ua[e] = { value: e };
}), Object.defineProperties(mn, ua), Object.defineProperty(aa, "isAxiosError", { value: !0 }), mn.from = (e, t, n, s, r, i) => {
  const o = Object.create(aa);
  R.toFlatObject(e, o, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const a = e && e.message ? e.message : "Error", u = t == null && e ? e.code : t;
  return mn.call(o, a, u, n, s, r), e && o.cause == null && Object.defineProperty(o, "cause", { value: e, configurable: !0 }), o.name = e && e.name || "Error", i && Object.assign(o, i), o;
};
const se = mn;
function Ms(e) {
  return R.isPlainObject(e) || R.isArray(e);
}
function qu(e) {
  return R.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function ca(e, t, n) {
  return e ? e.concat(t).map(function(s, r) {
    return s = qu(s), !n && r ? "[" + s + "]" : s;
  }).join(n ? "." : "") : t;
}
const Nf = R.toFlatObject(R, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
}), is = function(e, t, n) {
  if (!R.isObject(e)) throw new TypeError("target must be an object");
  t = t || new FormData();
  const s = (n = R.toFlatObject(n, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(h, f) {
    return !R.isUndefined(f[h]);
  })).metaTokens, r = n.visitor || c, i = n.dots, o = n.indexes, a = (n.Blob || typeof Blob < "u" && Blob) && R.isSpecCompliantForm(t);
  if (!R.isFunction(r)) throw new TypeError("visitor must be a function");
  function u(h) {
    if (h === null) return "";
    if (R.isDate(h)) return h.toISOString();
    if (R.isBoolean(h)) return h.toString();
    if (!a && R.isBlob(h)) throw new se("Blob is not supported. Use a Buffer instead.");
    return R.isArrayBuffer(h) || R.isTypedArray(h) ? a && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function c(h, f, w) {
    let v = h;
    if (h && !w && typeof h == "object") {
      if (R.endsWith(f, "{}")) f = s ? f : f.slice(0, -2), h = JSON.stringify(h);
      else if (R.isArray(h) && function(E) {
        return R.isArray(E) && !E.some(Ms);
      }(h) || (R.isFileList(h) || R.endsWith(f, "[]")) && (v = R.toArray(h))) return f = qu(f), v.forEach(function(E, B) {
        !R.isUndefined(E) && E !== null && t.append(o === !0 ? ca([f], B, i) : o === null ? f : f + "[]", u(E));
      }), !1;
    }
    return !!Ms(h) || (t.append(ca(w, f, i), u(h)), !1);
  }
  const l = [], d = Object.assign(Nf, { defaultVisitor: c, convertValue: u, isVisitable: Ms });
  if (!R.isObject(e)) throw new TypeError("data must be an object");
  return function h(f, w) {
    if (!R.isUndefined(f)) {
      if (l.indexOf(f) !== -1) throw Error("Circular reference detected in " + w.join("."));
      l.push(f), R.forEach(f, function(v, E) {
        (!(R.isUndefined(v) || v === null) && r.call(t, v, R.isString(E) ? E.trim() : E, w, d)) === !0 && h(v, w ? w.concat(E) : [E]);
      }), l.pop();
    }
  }(e), t;
};
function la(e) {
  const t = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Hu(e, t) {
  this._pairs = [], e && is(e, this, t);
}
const da = Hu.prototype;
da.append = function(e, t) {
  this._pairs.push([e, t]);
}, da.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, la);
  } : la;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
const Ju = Hu;
function Df(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Vu(e, t, n) {
  if (!t) return e;
  const s = n && n.encode || Df;
  R.isFunction(n) && (n = { serialize: n });
  const r = n && n.serialize;
  let i;
  if (i = r ? r(t, n) : R.isURLSearchParams(t) ? t.toString() : new Ju(t, n).toString(s), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
const ha = class {
  constructor() {
    this.handlers = [];
  }
  use(e, t, n) {
    return this.handlers.push({ fulfilled: e, rejected: t, synchronous: !!n && n.synchronous, runWhen: n ? n.runWhen : null }), this.handlers.length - 1;
  }
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(e) {
    R.forEach(this.handlers, function(t) {
      t !== null && e(t);
    });
  }
}, Gu = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, Ff = { isBrowser: !0, classes: { URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : Ju, FormData: typeof FormData < "u" ? FormData : null, Blob: typeof Blob < "u" ? Blob : null }, protocols: ["http", "https", "file", "blob", "url", "data"] }, ki = typeof window < "u" && typeof document < "u", fi = typeof navigator == "object" && navigator || void 0, Mf = ki && (!fi || ["ReactNative", "NativeScript", "NS"].indexOf(fi.product) < 0), Bf = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", $f = ki && window.location.href || "http://localhost", it = { ...si, ...Ff }, Wu = function(e) {
  function t(n, s, r, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), u = i >= n.length;
    return o = !o && R.isArray(r) ? r.length : o, u ? (R.hasOwnProp(r, o) ? r[o] = [r[o], s] : r[o] = s, !a) : (r[o] && R.isObject(r[o]) || (r[o] = []), t(n, s, r[o], i) && R.isArray(r[o]) && (r[o] = function(c) {
      const l = {}, d = Object.keys(c);
      let h;
      const f = d.length;
      let w;
      for (h = 0; h < f; h++) w = d[h], l[w] = c[w];
      return l;
    }(r[o])), !a);
  }
  if (R.isFormData(e) && R.isFunction(e.entries)) {
    const n = {};
    return R.forEachEntry(e, (s, r) => {
      t(function(i) {
        return R.matchAll(/\w+|\[(\w*)]/g, i).map((o) => o[0] === "[]" ? "" : o[1] || o[0]);
      }(s), r, n, 0);
    }), n;
  }
  return null;
}, Pi = { transitional: Gu, adapter: ["xhr", "http", "fetch"], transformRequest: [function(e, t) {
  const n = t.getContentType() || "", s = n.indexOf("application/json") > -1, r = R.isObject(e);
  if (r && R.isHTMLForm(e) && (e = new FormData(e)), R.isFormData(e)) return s ? JSON.stringify(Wu(e)) : e;
  if (R.isArrayBuffer(e) || R.isBuffer(e) || R.isStream(e) || R.isFile(e) || R.isBlob(e) || R.isReadableStream(e)) return e;
  if (R.isArrayBufferView(e)) return e.buffer;
  if (R.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
  let i;
  if (r) {
    if (n.indexOf("application/x-www-form-urlencoded") > -1) return function(o, a) {
      return is(o, new it.classes.URLSearchParams(), { visitor: function(u, c, l, d) {
        return it.isNode && R.isBuffer(u) ? (this.append(c, u.toString("base64")), !1) : d.defaultVisitor.apply(this, arguments);
      }, ...a });
    }(e, this.formSerializer).toString();
    if ((i = R.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
      const o = this.env && this.env.FormData;
      return is(i ? { "files[]": e } : e, o && new o(), this.formSerializer);
    }
  }
  return r || s ? (t.setContentType("application/json", !1), function(o) {
    if (R.isString(o)) try {
      return (0, JSON.parse)(o), R.trim(o);
    } catch (a) {
      if (a.name !== "SyntaxError") throw a;
    }
    return (0, JSON.stringify)(o);
  }(e)) : e;
}], transformResponse: [function(e) {
  const t = this.transitional || Pi.transitional, n = t && t.forcedJSONParsing, s = this.responseType === "json";
  if (R.isResponse(e) || R.isReadableStream(e)) return e;
  if (e && R.isString(e) && (n && !this.responseType || s)) {
    const r = !(t && t.silentJSONParsing) && s;
    try {
      return JSON.parse(e, this.parseReviver);
    } catch (i) {
      if (r)
        throw i.name === "SyntaxError" ? se.from(i, se.ERR_BAD_RESPONSE, this, null, this.response) : i;
    }
  }
  return e;
}], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: it.classes.FormData, Blob: it.classes.Blob }, validateStatus: function(e) {
  return e >= 200 && e < 300;
}, headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } } };
R.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Pi.headers[e] = {};
});
const ji = Pi, zf = R.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), fa = Symbol("internals");
function Dn(e) {
  return e && String(e).trim().toLowerCase();
}
function Ar(e) {
  return e === !1 || e == null ? e : R.isArray(e) ? e.map(Ar) : String(e);
}
function Bs(e, t, n, s, r) {
  return R.isFunction(s) ? s.call(this, t, n) : (r && (t = n), R.isString(t) ? R.isString(s) ? t.indexOf(s) !== -1 : R.isRegExp(s) ? s.test(t) : void 0 : void 0);
}
class Ur {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, s) {
    const r = this;
    function i(a, u, c) {
      const l = Dn(u);
      if (!l) throw new Error("header name must be a non-empty string");
      const d = R.findKey(r, l);
      (!d || r[d] === void 0 || c === !0 || c === void 0 && r[d] !== !1) && (r[d || u] = Ar(a));
    }
    const o = (a, u) => R.forEach(a, (c, l) => i(c, l, u));
    if (R.isPlainObject(t) || t instanceof this.constructor) o(t, n);
    else if (R.isString(t) && (t = t.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim())) o(((a) => {
      const u = {};
      let c, l, d;
      return a && a.split(`
`).forEach(function(h) {
        d = h.indexOf(":"), c = h.substring(0, d).trim().toLowerCase(), l = h.substring(d + 1).trim(), !c || u[c] && zf[c] || (c === "set-cookie" ? u[c] ? u[c].push(l) : u[c] = [l] : u[c] = u[c] ? u[c] + ", " + l : l);
      }), u;
    })(t), n);
    else if (R.isObject(t) && R.isIterable(t)) {
      let a, u, c = {};
      for (const l of t) {
        if (!R.isArray(l)) throw TypeError("Object iterator must return a key-value pair");
        c[u = l[0]] = (a = c[u]) ? R.isArray(a) ? [...a, l[1]] : [a, l[1]] : l[1];
      }
      o(c, n);
    } else t != null && i(n, t, s);
    return this;
  }
  get(t, n) {
    if (t = Dn(t)) {
      const s = R.findKey(this, t);
      if (s) {
        const r = this[s];
        if (!n) return r;
        if (n === !0) return function(i) {
          const o = /* @__PURE__ */ Object.create(null), a = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
          let u;
          for (; u = a.exec(i); ) o[u[1]] = u[2];
          return o;
        }(r);
        if (R.isFunction(n)) return n.call(this, r, s);
        if (R.isRegExp(n)) return n.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Dn(t)) {
      const s = R.findKey(this, t);
      return !(!s || this[s] === void 0 || n && !Bs(0, this[s], s, n));
    }
    return !1;
  }
  delete(t, n) {
    const s = this;
    let r = !1;
    function i(o) {
      if (o = Dn(o)) {
        const a = R.findKey(s, o);
        !a || n && !Bs(0, s[a], a, n) || (delete s[a], r = !0);
      }
    }
    return R.isArray(t) ? t.forEach(i) : i(t), r;
  }
  clear(t) {
    const n = Object.keys(this);
    let s = n.length, r = !1;
    for (; s--; ) {
      const i = n[s];
      t && !Bs(0, this[i], i, t, !0) || (delete this[i], r = !0);
    }
    return r;
  }
  normalize(t) {
    const n = this, s = {};
    return R.forEach(this, (r, i) => {
      const o = R.findKey(s, i);
      if (o) return n[o] = Ar(r), void delete n[i];
      const a = t ? function(u) {
        return u.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (c, l, d) => l.toUpperCase() + d);
      }(i) : String(i).trim();
      a !== i && delete n[i], n[a] = Ar(r), s[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return R.forEach(this, (s, r) => {
      s != null && s !== !1 && (n[r] = t && R.isArray(s) ? s.join(", ") : s);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const s = new this(t);
    return n.forEach((r) => s.set(r)), s;
  }
  static accessor(t) {
    const n = (this[fa] = this[fa] = { accessors: {} }).accessors, s = this.prototype;
    function r(i) {
      const o = Dn(i);
      n[o] || (function(a, u) {
        const c = R.toCamelCase(" " + u);
        ["get", "set", "has"].forEach((l) => {
          Object.defineProperty(a, l + c, { value: function(d, h, f) {
            return this[l].call(this, u, d, h, f);
          }, configurable: !0 });
        });
      }(s, i), n[o] = !0);
    }
    return R.isArray(t) ? t.forEach(r) : r(t), this;
  }
}
Ur.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), R.reduceDescriptors(Ur.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return { get: () => e, set(s) {
    this[n] = s;
  } };
}), R.freezeMethods(Ur);
const Ct = Ur;
function $s(e, t) {
  const n = this || ji, s = t || n, r = Ct.from(s.headers);
  let i = s.data;
  return R.forEach(e, function(o) {
    i = o.call(n, i, r.normalize(), t ? t.status : void 0);
  }), r.normalize(), i;
}
function Zu(e) {
  return !(!e || !e.__CANCEL__);
}
function Ku(e, t, n) {
  se.call(this, e ?? "canceled", se.ERR_CANCELED, t, n), this.name = "CanceledError";
}
R.inherits(Ku, se, { __CANCEL__: !0 });
const or = Ku;
function Yu(e, t, n) {
  const s = n.config.validateStatus;
  n.status && s && !s(n.status) ? t(new se("Request failed with status code " + n.status, [se.ERR_BAD_REQUEST, se.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : e(n);
}
const os = (e, t, n = 3) => {
  let s = 0;
  const r = function(i, o) {
    i = i || 10;
    const a = new Array(i), u = new Array(i);
    let c, l = 0, d = 0;
    return o = o !== void 0 ? o : 1e3, function(h) {
      const f = Date.now(), w = u[d];
      c || (c = f), a[l] = h, u[l] = f;
      let v = d, E = 0;
      for (; v !== l; ) E += a[v++], v %= i;
      if (l = (l + 1) % i, l === d && (d = (d + 1) % i), f - c < o) return;
      const B = w && f - w;
      return B ? Math.round(1e3 * E / B) : void 0;
    };
  }(50, 250);
  return function(i, o) {
    let a, u, c = 0, l = 1e3 / o;
    const d = (h, f = Date.now()) => {
      c = f, a = null, u && (clearTimeout(u), u = null), i(...h);
    };
    return [(...h) => {
      const f = Date.now(), w = f - c;
      w >= l ? d(h, f) : (a = h, u || (u = setTimeout(() => {
        u = null, d(a);
      }, l - w)));
    }, () => a && d(a)];
  }((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, u = o - s, c = r(u);
    s = o, e({ loaded: o, total: a, progress: a ? o / a : void 0, bytes: u, rate: c || void 0, estimated: c && a && o <= a ? (a - o) / c : void 0, event: i, lengthComputable: a != null, [t ? "download" : "upload"]: !0 });
  }, n);
}, pa = (e, t) => {
  const n = e != null;
  return [(s) => t[0]({ lengthComputable: n, total: e, loaded: s }), t[1]];
}, va = (e) => (...t) => R.asap(() => e(...t)), qf = it.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, it.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(new URL(it.origin), it.navigator && /(msie|trident)/i.test(it.navigator.userAgent)) : () => !0, Hf = it.hasStandardBrowserEnv ? { write(e, t, n, s, r, i, o) {
  if (typeof document > "u") return;
  const a = [`${e}=${encodeURIComponent(t)}`];
  R.isNumber(n) && a.push(`expires=${new Date(n).toUTCString()}`), R.isString(s) && a.push(`path=${s}`), R.isString(r) && a.push(`domain=${r}`), i === !0 && a.push("secure"), R.isString(o) && a.push(`SameSite=${o}`), document.cookie = a.join("; ");
}, read(e) {
  if (typeof document > "u") return null;
  const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
  return t ? decodeURIComponent(t[1]) : null;
}, remove(e) {
  this.write(e, "", Date.now() - 864e5, "/");
} } : { write() {
}, read: () => null, remove() {
} };
function Xu(e, t, n) {
  let s = !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
  return e && (s || n == 0) ? function(r, i) {
    return i ? r.replace(/\/?\/$/, "") + "/" + i.replace(/^\/+/, "") : r;
  }(e, t) : t;
}
const ma = (e) => e instanceof Ct ? { ...e } : e;
function tn(e, t) {
  t = t || {};
  const n = {};
  function s(c, l, d, h) {
    return R.isPlainObject(c) && R.isPlainObject(l) ? R.merge.call({ caseless: h }, c, l) : R.isPlainObject(l) ? R.merge({}, l) : R.isArray(l) ? l.slice() : l;
  }
  function r(c, l, d, h) {
    return R.isUndefined(l) ? R.isUndefined(c) ? void 0 : s(void 0, c, 0, h) : s(c, l, 0, h);
  }
  function i(c, l) {
    if (!R.isUndefined(l)) return s(void 0, l);
  }
  function o(c, l) {
    return R.isUndefined(l) ? R.isUndefined(c) ? void 0 : s(void 0, c) : s(void 0, l);
  }
  function a(c, l, d) {
    return d in t ? s(c, l) : d in e ? s(void 0, c) : void 0;
  }
  const u = { url: i, method: i, data: i, baseURL: o, transformRequest: o, transformResponse: o, paramsSerializer: o, timeout: o, timeoutMessage: o, withCredentials: o, withXSRFToken: o, adapter: o, responseType: o, xsrfCookieName: o, xsrfHeaderName: o, onUploadProgress: o, onDownloadProgress: o, decompress: o, maxContentLength: o, maxBodyLength: o, beforeRedirect: o, transport: o, httpAgent: o, httpsAgent: o, cancelToken: o, socketPath: o, responseEncoding: o, validateStatus: a, headers: (c, l, d) => r(ma(c), ma(l), 0, !0) };
  return R.forEach(Object.keys({ ...e, ...t }), function(c) {
    const l = u[c] || r, d = l(e[c], t[c], c);
    R.isUndefined(d) && l !== a || (n[c] = d);
  }), n;
}
const Qu = (e) => {
  const t = tn({}, e);
  let { data: n, withXSRFToken: s, xsrfHeaderName: r, xsrfCookieName: i, headers: o, auth: a } = t;
  if (t.headers = o = Ct.from(o), t.url = Vu(Xu(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), a && o.set("Authorization", "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))), R.isFormData(n)) {
    if (it.hasStandardBrowserEnv || it.hasStandardBrowserWebWorkerEnv) o.setContentType(void 0);
    else if (R.isFunction(n.getHeaders)) {
      const u = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(u).forEach(([l, d]) => {
        c.includes(l.toLowerCase()) && o.set(l, d);
      });
    }
  }
  if (it.hasStandardBrowserEnv && (s && R.isFunction(s) && (s = s(t)), s || s !== !1 && qf(t.url))) {
    const u = r && i && Hf.read(i);
    u && o.set(r, u);
  }
  return t;
}, Jf = typeof XMLHttpRequest < "u" && function(e) {
  return new Promise(function(t, n) {
    const s = Qu(e);
    let r = s.data;
    const i = Ct.from(s.headers).normalize();
    let o, a, u, c, l, { responseType: d, onUploadProgress: h, onDownloadProgress: f } = s;
    function w() {
      c && c(), l && l(), s.cancelToken && s.cancelToken.unsubscribe(o), s.signal && s.signal.removeEventListener("abort", o);
    }
    let v = new XMLHttpRequest();
    function E() {
      if (!v) return;
      const N = Ct.from("getAllResponseHeaders" in v && v.getAllResponseHeaders());
      Yu(function(M) {
        t(M), w();
      }, function(M) {
        n(M), w();
      }, { data: d && d !== "text" && d !== "json" ? v.response : v.responseText, status: v.status, statusText: v.statusText, headers: N, config: e, request: v }), v = null;
    }
    v.open(s.method.toUpperCase(), s.url, !0), v.timeout = s.timeout, "onloadend" in v ? v.onloadend = E : v.onreadystatechange = function() {
      v && v.readyState === 4 && (v.status !== 0 || v.responseURL && v.responseURL.indexOf("file:") === 0) && setTimeout(E);
    }, v.onabort = function() {
      v && (n(new se("Request aborted", se.ECONNABORTED, e, v)), v = null);
    }, v.onerror = function(N) {
      const M = N && N.message ? N.message : "Network Error", G = new se(M, se.ERR_NETWORK, e, v);
      G.event = N || null, n(G), v = null;
    }, v.ontimeout = function() {
      let N = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const M = s.transitional || Gu;
      s.timeoutErrorMessage && (N = s.timeoutErrorMessage), n(new se(N, M.clarifyTimeoutError ? se.ETIMEDOUT : se.ECONNABORTED, e, v)), v = null;
    }, r === void 0 && i.setContentType(null), "setRequestHeader" in v && R.forEach(i.toJSON(), function(N, M) {
      v.setRequestHeader(M, N);
    }), R.isUndefined(s.withCredentials) || (v.withCredentials = !!s.withCredentials), d && d !== "json" && (v.responseType = s.responseType), f && ([u, l] = os(f, !0), v.addEventListener("progress", u)), h && v.upload && ([a, c] = os(h), v.upload.addEventListener("progress", a), v.upload.addEventListener("loadend", c)), (s.cancelToken || s.signal) && (o = (N) => {
      v && (n(!N || N.type ? new or(null, e, v) : N), v.abort(), v = null);
    }, s.cancelToken && s.cancelToken.subscribe(o), s.signal && (s.signal.aborted ? o() : s.signal.addEventListener("abort", o)));
    const B = function(N) {
      const M = /^([-+\w]{1,25})(:?\/\/|:)/.exec(N);
      return M && M[1] || "";
    }(s.url);
    B && it.protocols.indexOf(B) === -1 ? n(new se("Unsupported protocol " + B + ":", se.ERR_BAD_REQUEST, e)) : v.send(r || null);
  });
}, Vf = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let s, r = new AbortController();
    const i = function(c) {
      if (!s) {
        s = !0, a();
        const l = c instanceof Error ? c : this.reason;
        r.abort(l instanceof se ? l : new or(l instanceof Error ? l.message : l));
      }
    };
    let o = t && setTimeout(() => {
      o = null, i(new se(`timeout ${t} of ms exceeded`, se.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", i));
    const { signal: u } = r;
    return u.unsubscribe = () => R.asap(a), u;
  }
}, Gf = function* (e, t) {
  let n = e.byteLength;
  if (n < t) return void (yield e);
  let s, r = 0;
  for (; r < n; ) s = r + t, yield e.slice(r, s), r = s;
}, ga = (e, t, n, s) => {
  const r = async function* (u, c) {
    for await (const l of async function* (d) {
      if (d[Symbol.asyncIterator]) return void (yield* d);
      const h = d.getReader();
      try {
        for (; ; ) {
          const { done: f, value: w } = await h.read();
          if (f) break;
          yield w;
        }
      } finally {
        await h.cancel();
      }
    }(u)) yield* Gf(l, c);
  }(e, t);
  let i, o = 0, a = (u) => {
    i || (i = !0, s && s(u));
  };
  return new ReadableStream({ async pull(u) {
    try {
      const { done: c, value: l } = await r.next();
      if (c) return a(), void u.close();
      let d = l.byteLength;
      if (n) {
        let h = o += d;
        n(h);
      }
      u.enqueue(new Uint8Array(l));
    } catch (c) {
      throw a(c), c;
    }
  }, cancel: (u) => (a(u), r.return()) }, { highWaterMark: 2 });
}, { isFunction: wr } = R, Wf = (({ Request: e, Response: t }) => ({ Request: e, Response: t }))(R.global), { ReadableStream: ba, TextEncoder: ya } = R.global, wa = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Zf = (e) => {
  e = R.merge.call({ skipUndefined: !0 }, Wf, e);
  const { fetch: t, Request: n, Response: s } = e, r = t ? wr(t) : typeof fetch == "function", i = wr(n), o = wr(s);
  if (!r) return !1;
  const a = r && wr(ba), u = r && (typeof ya == "function" ? (c = new ya(), (f) => c.encode(f)) : async (f) => new Uint8Array(await new n(f).arrayBuffer()));
  var c;
  const l = i && a && wa(() => {
    let f = !1;
    const w = new n(it.origin, { body: new ba(), method: "POST", get duplex() {
      return f = !0, "half";
    } }).headers.has("Content-Type");
    return f && !w;
  }), d = o && a && wa(() => R.isReadableStream(new s("").body)), h = { stream: d && ((f) => f.body) };
  return r && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((f) => {
    !h[f] && (h[f] = (w, v) => {
      let E = w && w[f];
      if (E) return E.call(w);
      throw new se(`Response type '${f}' is not supported`, se.ERR_NOT_SUPPORT, v);
    });
  }), async (f) => {
    let { url: w, method: v, data: E, signal: B, cancelToken: N, timeout: M, onDownloadProgress: G, onUploadProgress: Ee, responseType: de, headers: Z, withCredentials: ue = "same-origin", fetchOptions: je } = Qu(f), Je = t || fetch;
    de = de ? (de + "").toLowerCase() : "text";
    let $e = Vf([B, N && N.toAbortSignal()], M), Ae = null;
    const pe = $e && $e.unsubscribe && (() => {
      $e.unsubscribe();
    });
    let xe;
    try {
      if (Ee && l && v !== "get" && v !== "head" && (xe = await (async (ke, Oe) => {
        const Ve = R.toFiniteNumber(ke.getContentLength());
        return Ve ?? (async (te) => te == null ? 0 : R.isBlob(te) ? te.size : R.isSpecCompliantForm(te) ? (await new n(it.origin, { method: "POST", body: te }).arrayBuffer()).byteLength : R.isArrayBufferView(te) || R.isArrayBuffer(te) ? te.byteLength : (R.isURLSearchParams(te) && (te += ""), R.isString(te) ? (await u(te)).byteLength : void 0))(Oe);
      })(Z, E)) !== 0) {
        let ke, Oe = new n(w, { method: "POST", body: E, duplex: "half" });
        if (R.isFormData(E) && (ke = Oe.headers.get("content-type")) && Z.setContentType(ke), Oe.body) {
          const [Ve, te] = pa(xe, os(va(Ee)));
          E = ga(Oe.body, 65536, Ve, te);
        }
      }
      R.isString(ue) || (ue = ue ? "include" : "omit");
      const K = i && "credentials" in n.prototype, pt = { ...je, signal: $e, method: v.toUpperCase(), headers: Z.normalize().toJSON(), body: E, duplex: "half", credentials: K ? ue : void 0 };
      Ae = i && new n(w, pt);
      let Ie = await (i ? Je(Ae, je) : Je(w, pt));
      const wt = d && (de === "stream" || de === "response");
      if (d && (G || wt && pe)) {
        const ke = {};
        ["status", "statusText", "headers"].forEach((vt) => {
          ke[vt] = Ie[vt];
        });
        const Oe = R.toFiniteNumber(Ie.headers.get("content-length")), [Ve, te] = G && pa(Oe, os(va(G), !0)) || [];
        Ie = new s(ga(Ie.body, 65536, Ve, () => {
          te && te(), pe && pe();
        }), ke);
      }
      de = de || "text";
      let Bt = await h[R.findKey(h, de) || "text"](Ie, f);
      return !wt && pe && pe(), await new Promise((ke, Oe) => {
        Yu(ke, Oe, { data: Bt, headers: Ct.from(Ie.headers), status: Ie.status, statusText: Ie.statusText, config: f, request: Ae });
      });
    } catch (K) {
      throw pe && pe(), K && K.name === "TypeError" && /Load failed|fetch/i.test(K.message) ? Object.assign(new se("Network Error", se.ERR_NETWORK, f, Ae), { cause: K.cause || K }) : se.from(K, K && K.code, f, Ae);
    }
  };
}, Kf = /* @__PURE__ */ new Map(), Sa = (e) => {
  let t = e && e.env || {};
  const { fetch: n, Request: s, Response: r } = t, i = [s, r, n];
  let o, a, u = i.length, c = Kf;
  for (; u--; ) o = i[u], a = c.get(o), a === void 0 && c.set(o, a = u ? /* @__PURE__ */ new Map() : Zf(t)), c = a;
  return a;
}, ec = (Sa(), { http: null, xhr: Jf, fetch: { get: Sa } });
R.forEach(ec, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Ra = (e) => `- ${e}`, Yf = (e) => R.isFunction(e) || e === null || e === !1, tc = function(e, t) {
  e = R.isArray(e) ? e : [e];
  const { length: n } = e;
  let s, r;
  const i = {};
  for (let o = 0; o < n; o++) {
    let a;
    if (s = e[o], r = s, !Yf(s) && (r = ec[(a = String(s)).toLowerCase()], r === void 0)) throw new se(`Unknown adapter '${a}'`);
    if (r && (R.isFunction(r) || (r = r.get(t)))) break;
    i[a || "#" + o] = r;
  }
  if (!r) {
    const o = Object.entries(i).map(([u, c]) => `adapter ${u} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build"));
    let a = n ? o.length > 1 ? `since :
` + o.map(Ra).join(`
`) : " " + Ra(o[0]) : "as no adapter specified";
    throw new se("There is no suitable adapter to dispatch the request " + a, "ERR_NOT_SUPPORT");
  }
  return r;
};
function zs(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new or(null, e);
}
function xa(e) {
  return zs(e), e.headers = Ct.from(e.headers), e.data = $s.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), tc(e.adapter || ji.adapter, e)(e).then(function(t) {
    return zs(e), t.data = $s.call(e, e.transformResponse, t), t.headers = Ct.from(t.headers), t;
  }, function(t) {
    return Zu(t) || (zs(e), t && t.response && (t.response.data = $s.call(e, e.transformResponse, t.response), t.response.headers = Ct.from(t.response.headers))), Promise.reject(t);
  });
}
const nc = "1.13.2", as = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  as[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Ca = {};
as.transitional = function(e, t, n) {
  function s(r, i) {
    return "[Axios v" + nc + "] Transitional option '" + r + "'" + i + (n ? ". " + n : "");
  }
  return (r, i, o) => {
    if (e === !1) throw new se(s(i, " has been removed" + (t ? " in " + t : "")), se.ERR_DEPRECATED);
    return t && !Ca[i] && (Ca[i] = !0, console.warn(s(i, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(r, i, o);
  };
}, as.spelling = function(e) {
  return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
const Lr = { assertOptions: function(e, t, n) {
  if (typeof e != "object") throw new se("options must be an object", se.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(e);
  let r = s.length;
  for (; r-- > 0; ) {
    const i = s[r], o = t[i];
    if (o) {
      const a = e[i], u = a === void 0 || o(a, i, e);
      if (u !== !0) throw new se("option " + i + " must be " + u, se.ERR_BAD_OPTION_VALUE);
    } else if (n !== !0) throw new se("Unknown option " + i, se.ERR_BAD_OPTION);
  }
}, validators: as }, _t = Lr.validators;
class Nr {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = { request: new ha(), response: new ha() };
  }
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (s) {
      if (s instanceof Error) {
        let r = {};
        Error.captureStackTrace ? Error.captureStackTrace(r) : r = new Error();
        const i = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        try {
          s.stack ? i && !String(s.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + i) : s.stack = i;
        } catch {
        }
      }
      throw s;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}).url = t : n = t || {}, n = tn(this.defaults, n);
    const { transitional: s, paramsSerializer: r, headers: i } = n;
    s !== void 0 && Lr.assertOptions(s, { silentJSONParsing: _t.transitional(_t.boolean), forcedJSONParsing: _t.transitional(_t.boolean), clarifyTimeoutError: _t.transitional(_t.boolean) }, !1), r != null && (R.isFunction(r) ? n.paramsSerializer = { serialize: r } : Lr.assertOptions(r, { encode: _t.function, serialize: _t.function }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Lr.assertOptions(n, { baseUrl: _t.spelling("baseURL"), withXsrfToken: _t.spelling("withXSRFToken") }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && R.merge(i.common, i[n.method]);
    i && R.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (w) => {
      delete i[w];
    }), n.headers = Ct.concat(o, i);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(w) {
      typeof w.runWhen == "function" && w.runWhen(n) === !1 || (u = u && w.synchronous, a.unshift(w.fulfilled, w.rejected));
    });
    const c = [];
    let l;
    this.interceptors.response.forEach(function(w) {
      c.push(w.fulfilled, w.rejected);
    });
    let d, h = 0;
    if (!u) {
      const w = [xa.bind(this), void 0];
      for (w.unshift(...a), w.push(...c), d = w.length, l = Promise.resolve(n); h < d; ) l = l.then(w[h++], w[h++]);
      return l;
    }
    d = a.length;
    let f = n;
    for (; h < d; ) {
      const w = a[h++], v = a[h++];
      try {
        f = w(f);
      } catch (E) {
        v.call(this, E);
        break;
      }
    }
    try {
      l = xa.call(this, f);
    } catch (w) {
      return Promise.reject(w);
    }
    for (h = 0, d = c.length; h < d; ) l = l.then(c[h++], c[h++]);
    return l;
  }
  getUri(t) {
    return Vu(Xu((t = tn(this.defaults, t)).baseURL, t.url, t.allowAbsoluteUrls), t.params, t.paramsSerializer);
  }
}
R.forEach(["delete", "get", "head", "options"], function(e) {
  Nr.prototype[e] = function(t, n) {
    return this.request(tn(n || {}, { method: e, url: t, data: (n || {}).data }));
  };
}), R.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(s, r, i) {
      return this.request(tn(i || {}, { method: e, headers: n ? { "Content-Type": "multipart/form-data" } : {}, url: s, data: r }));
    };
  }
  Nr.prototype[e] = t(), Nr.prototype[e + "Form"] = t(!0);
});
const Dr = Nr;
class Ai {
  constructor(t) {
    if (typeof t != "function") throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(r) {
      n = r;
    });
    const s = this;
    this.promise.then((r) => {
      if (!s._listeners) return;
      let i = s._listeners.length;
      for (; i-- > 0; ) s._listeners[i](r);
      s._listeners = null;
    }), this.promise.then = (r) => {
      let i;
      const o = new Promise((a) => {
        s.subscribe(a), i = a;
      }).then(r);
      return o.cancel = function() {
        s.unsubscribe(i);
      }, o;
    }, t(function(r, i, o) {
      s.reason || (s.reason = new or(r, i, o), n(s.reason));
    });
  }
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  subscribe(t) {
    this.reason ? t(this.reason) : this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  unsubscribe(t) {
    if (!this._listeners) return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (s) => {
      t.abort(s);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  static source() {
    let t;
    return { token: new Ai(function(n) {
      t = n;
    }), cancel: t };
  }
}
const Xf = Ai, pi = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511, WebServerIsDown: 521, ConnectionTimedOut: 522, OriginIsUnreachable: 523, TimeoutOccurred: 524, SslHandshakeFailed: 525, InvalidSslCertificate: 526 };
Object.entries(pi).forEach(([e, t]) => {
  pi[t] = e;
});
const Qf = pi, Me = function e(t) {
  const n = new Dr(t), s = Bu(Dr.prototype.request, n);
  return R.extend(s, Dr.prototype, n, { allOwnKeys: !0 }), R.extend(s, n, null, { allOwnKeys: !0 }), s.create = function(r) {
    return e(tn(t, r));
  }, s;
}(ji);
Me.Axios = Dr, Me.CanceledError = or, Me.CancelToken = Xf, Me.isCancel = Zu, Me.VERSION = nc, Me.toFormData = is, Me.AxiosError = se, Me.Cancel = Me.CanceledError, Me.all = function(e) {
  return Promise.all(e);
}, Me.spread = function(e) {
  return function(t) {
    return e.apply(null, t);
  };
}, Me.isAxiosError = function(e) {
  return R.isObject(e) && e.isAxiosError === !0;
}, Me.mergeConfig = tn, Me.AxiosHeaders = Ct, Me.formToJSON = (e) => Wu(R.isHTMLForm(e) ? new FormData(e) : e), Me.getAdapter = tc, Me.HttpStatusCode = Qf, Me.default = Me;
const O = Me;
function rc(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function vi(e, t, n) {
  return vi = Ui() ? Reflect.construct : function(s, r, i) {
    var o = [null];
    o.push.apply(o, r);
    var a = new (Function.bind.apply(s, o))();
    return i && tr(a, i.prototype), a;
  }, vi.apply(null, arguments);
}
function Fr(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function er(e) {
  return er = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, er(e);
}
function tr(e, t) {
  return tr = Object.setPrototypeOf || function(n, s) {
    return n.__proto__ = s, n;
  }, tr(e, t);
}
function mi(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return mi = function(n) {
    if (n === null || (s = n, Function.toString.call(s).indexOf("[native code]") === -1)) return n;
    var s;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n)) return t.get(n);
      t.set(n, r);
    }
    function r() {
      return vi(n, arguments, er(this).constructor);
    }
    return r.prototype = Object.create(n.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }), tr(r, n);
  }, mi(e);
}
function Ui() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ui = function() {
    return !!e;
  })();
}
var T = "http://localhost".replace(/\/+$/, ""), Ke = function e(t) {
  var n, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : T, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : O;
  rc(this, e), Fr(this, "basePath", void 0), Fr(this, "axios", void 0), Fr(this, "configuration", void 0), this.basePath = s, this.axios = r, t && (this.configuration = t, this.basePath = (n = t.basePath) !== null && n !== void 0 ? n : s);
}, ep = function() {
  function e(t, n) {
    var s;
    return rc(this, e), Fr(s = function(r, i, o) {
      return i = er(i), function(a, u) {
        return !u || ((c = u) && typeof Symbol < "u" && c.constructor === Symbol ? "symbol" : typeof c) != "object" && typeof u != "function" ? function(l) {
          if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return l;
        }(a) : u;
        var c;
      }(r, Ui() ? Reflect.construct(i, o || [], er(r).constructor) : i.apply(r, o));
    }(this, e, [n]), "field", void 0), s.field = t, s.name = "RequiredError", s;
  }
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(n && n.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), n && tr(t, n);
  }(e, mi(Error)), e;
}(), _ = {};
function Ea(e, t, n, s, r, i, o) {
  try {
    var a = e[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? t(u) : Promise.resolve(u).then(s, r);
}
function tp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var I = "https://example.com", C = function(e, t, n) {
  if (n == null) throw new ep(t, "Required parameter ".concat(t, " was null or undefined when calling ").concat(e, "."));
}, A = function(e, t) {
  return (n = function() {
    var s, r;
    return function(i, o) {
      var a, u, c, l = { label: 0, sent: function() {
        if (1 & c[0]) throw c[1];
        return c[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = h(0), d.throw = h(1), d.return = h(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function h(f) {
        return function(w) {
          return function(v) {
            if (a) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, v[0] && (l = 0)), l; ) try {
              if (a = 1, u && (c = 2 & v[0] ? u.return : v[0] ? u.throw || ((c = u.return) && c.call(u), 0) : u.next) && !(c = c.call(u, v[1])).done) return c;
              switch (u = 0, c && (v = [2 & v[0], c.value]), v[0]) {
                case 0:
                case 1:
                  c = v;
                  break;
                case 4:
                  return l.label++, { value: v[1], done: !1 };
                case 5:
                  l.label++, u = v[1], v = [0];
                  continue;
                case 7:
                  v = l.ops.pop(), l.trys.pop();
                  continue;
                default:
                  if (!((c = (c = l.trys).length > 0 && c[c.length - 1]) || v[0] !== 6 && v[0] !== 2)) {
                    l = 0;
                    continue;
                  }
                  if (v[0] === 3 && (!c || v[1] > c[0] && v[1] < c[3])) {
                    l.label = v[1];
                    break;
                  }
                  if (v[0] === 6 && l.label < c[1]) {
                    l.label = c[1], c = v;
                    break;
                  }
                  if (c && l.label < c[2]) {
                    l.label = c[2], l.ops.push(v);
                    break;
                  }
                  c[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }
              v = o.call(i, l);
            } catch (E) {
              v = [6, E], u = 0;
            } finally {
              a = c = 0;
            }
            if (5 & v[0]) throw v[1];
            return { value: v[0] ? v[1] : void 0, done: !0 };
          }([f, w]);
        };
      }
    }(this, function(i) {
      switch (i.label) {
        case 0:
          return t && t.accessToken ? typeof t.accessToken != "function" ? [3, 2] : [4, t.accessToken()] : [3, 5];
        case 1:
          return r = i.sent(), [3, 4];
        case 2:
          return [4, t.accessToken];
        case 3:
          r = i.sent(), i.label = 4;
        case 4:
          s = r, e.Authorization = "Bearer " + s, i.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var s = this, r = arguments;
    return new Promise(function(i, o) {
      var a = n.apply(s, r);
      function u(l) {
        Ea(a, i, o, u, c, "next", l);
      }
      function c(l) {
        Ea(a, i, o, u, c, "throw", l);
      }
      u(void 0);
    });
  })();
  var n;
};
function gi(e, t) {
  var n, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  t != null && ((t === void 0 ? "undefined" : (n = t) && typeof Symbol < "u" && n.constructor === Symbol ? "symbol" : typeof n) == "object" ? Array.isArray(t) ? t.forEach(function(r) {
    return gi(e, r, s);
  }) : Object.keys(t).forEach(function(r) {
    return gi(e, t[r], "".concat(s).concat(s !== "" ? "." : "").concat(r));
  }) : e.has(s) ? e.append(s, t) : e.set(s, t));
}
var k = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) n[s - 1] = arguments[s];
  var r = new URLSearchParams(e.search);
  gi(r, n), e.search = r.toString();
}, W = function(e, t, n) {
  var s = typeof e != "string";
  return (s && n && n.isJsonMime ? n.isJsonMime(t.headers["Content-Type"]) : s) ? JSON.stringify(e !== void 0 ? e : {}) : e || "";
}, P = function(e) {
  return e.pathname + e.search + e.hash;
}, j = function(e, t, n, s) {
  return function() {
    var r, i, o, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : t, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n, c = (i = function(l) {
      for (var d = 1; d < arguments.length; d++) {
        var h = arguments[d] != null ? arguments[d] : {}, f = Object.keys(h);
        typeof Object.getOwnPropertySymbols == "function" && (f = f.concat(Object.getOwnPropertySymbols(h).filter(function(w) {
          return Object.getOwnPropertyDescriptor(h, w).enumerable;
        }))), f.forEach(function(w) {
          tp(l, w, h[w]);
        });
      }
      return l;
    }({}, e.options), o = (o = { url: (a.defaults.baseURL ? "" : (r = s == null ? void 0 : s.basePath) !== null && r !== void 0 ? r : u) + e.url }) != null ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : function(l) {
      var d = Object.keys(l);
      if (Object.getOwnPropertySymbols) {
        var h = Object.getOwnPropertySymbols(l);
        d.push.apply(d, h);
      }
      return d;
    }(Object(o)).forEach(function(l) {
      Object.defineProperty(i, l, Object.getOwnPropertyDescriptor(o, l));
    }), i);
    return a.request(c);
  };
};
function Oa(e, t, n, s, r, i, o) {
  try {
    var a = e[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? t(u) : Promise.resolve(u).then(s, r);
}
function g(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(s, r) {
      var i = e.apply(t, n);
      function o(u) {
        Oa(i, s, r, o, a, "next", u);
      }
      function a(u) {
        Oa(i, s, r, o, a, "throw", u);
      }
      o(void 0);
    });
  };
}
function Ye(e, t, n) {
  return t = us(t), function(s, r) {
    return !r || ((i = r) && typeof Symbol < "u" && i.constructor === Symbol ? "symbol" : typeof i) != "object" && typeof r != "function" ? function(o) {
      if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return o;
    }(s) : r;
    var i;
  }(e, sc() ? Reflect.construct(t, n || [], us(e).constructor) : t.apply(e, n));
}
function Xe(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function np(e, t) {
  for (var n = 0; n < t.length; n++) {
    var s = t[n];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
  }
}
function Qe(e, t, n) {
  return t && np(e.prototype, t), e;
}
function rp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function us(e) {
  return us = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, us(e);
}
function et(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && bi(e, t);
}
function m(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, s = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (s = s.concat(Object.getOwnPropertySymbols(n).filter(function(r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    }))), s.forEach(function(r) {
      rp(e, r, n[r]);
    });
  }
  return e;
}
function bi(e, t) {
  return bi = Object.setPrototypeOf || function(n, s) {
    return n.__proto__ = s, n;
  }, bi(e, t);
}
function sc() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (sc = function() {
    return !!e;
  })();
}
function b(e, t) {
  var n, s, r, i = { label: 0, sent: function() {
    if (1 & r[0]) throw r[1];
    return r[1];
  }, trys: [], ops: [] }, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return function(l) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; o && (o = 0, l[0] && (i = 0)), i; ) try {
          if (n = 1, s && (r = 2 & l[0] ? s.return : l[0] ? s.throw || ((r = s.return) && r.call(s), 0) : s.next) && !(r = r.call(s, l[1])).done) return r;
          switch (s = 0, r && (l = [2 & l[0], r.value]), l[0]) {
            case 0:
            case 1:
              r = l;
              break;
            case 4:
              return i.label++, { value: l[1], done: !1 };
            case 5:
              i.label++, s = l[1], l = [0];
              continue;
            case 7:
              l = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (!((r = (r = i.trys).length > 0 && r[r.length - 1]) || l[0] !== 6 && l[0] !== 2)) {
                i = 0;
                continue;
              }
              if (l[0] === 3 && (!r || l[1] > r[0] && l[1] < r[3])) {
                i.label = l[1];
                break;
              }
              if (l[0] === 6 && i.label < r[1]) {
                i.label = r[1], r = l;
                break;
              }
              if (r && i.label < r[2]) {
                i.label = r[2], i.ops.push(l);
                break;
              }
              r[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          l = t.call(e, i);
        } catch (d) {
          l = [6, d], s = 0;
        } finally {
          n = r = 0;
        }
        if (5 & l[0]) throw l[1];
        return { value: l[0] ? l[1] : void 0, done: !0 };
      }([u, c]);
    };
  }
}
var sp = function(e) {
  return { listBreaks: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("listBreaks", "showId", t), r = new URL("/break", I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, s), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), t !== void 0 && (u.showId = t), n !== void 0 && (u.ring = n), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, s.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  } };
}, ip = function(e) {
  var t = sp(e);
  return { listBreaks: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.listBreaks(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["BreaksApi.listBreaks"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "listBreaks", value: function(n, s, r) {
    var i = this;
    return ip(this.configuration).listBreaks(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Ke);
var op = function(e) {
  return { getCatalogTest: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getCatalogTest", "id", t), s = "/catalog/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, listCatalog: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return g(function() {
      var n, s, r, i, o, a;
      return b(this, function(u) {
        switch (u.label) {
          case 0:
            return n = new URL("/catalog", I), e && (s = e.baseOptions), r = m({ method: "GET" }, s, t), o = {}, [4, A(i = {}, e)];
          case 1:
            return u.sent(), k(n, o), a = s && s.headers ? s.headers : {}, r.headers = m({}, i, a, t.headers), [2, { url: P(n), options: r }];
        }
      });
    })();
  }, patchCatalogTest: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("patchCatalogTest", "id", t), r = "/catalog/{id}".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PATCH" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  } };
}, qs = function(e) {
  var t = op(e);
  return { getCatalogTest: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getCatalogTest(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["CatalogApi.getCatalogTest"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, listCatalog: function(n) {
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, t.listCatalog(n)];
          case 1:
            return i = c.sent(), a = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, u = (r = _["CatalogApi.listCatalog"]) === null || r === void 0 || (s = r[a]) === null || s === void 0 ? void 0 : s.url, [2, function(l, d) {
              return j(i, O, T, e)(l, u || d);
            }];
        }
      });
    })();
  }, patchCatalogTest: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.patchCatalogTest(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["CatalogApi.patchCatalogTest"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "getCatalogTest", value: function(n, s) {
    var r = this;
    return qs(this.configuration).getCatalogTest(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "listCatalog", value: function(n) {
    var s = this;
    return qs(this.configuration).listCatalog(n).then(function(r) {
      return r(s.axios, s.basePath);
    });
  } }, { key: "patchCatalogTest", value: function(n, s, r) {
    var i = this;
    return qs(this.configuration).patchCatalogTest(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Ke);
var ap = function(e) {
  return { getChampionshipFillOptions: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getChampionshipFillOptions", "classId", t), s = "/class/{classId}/championship-fill-options".replace("{classId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, getClass: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getClass", "classId", t), s = "/class/{classId}".replace("{classId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, listClasses: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("listClasses", "showId", t), r = new URL("/class", I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, s), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), t !== void 0 && (u.showId = t), n !== void 0 && (u.mine = n), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, s.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, listClassesForShows: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return C("listClassesForShows", "listClassesForShowsRequest", t), s = new URL("/class/batch", I), e && (r = e.baseOptions), i = m({ method: "POST" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, setClassDshbKindOverride: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setClassDshbKindOverride", "classId", t), C("setClassDshbKindOverride", "setClassDshbKindOverrideRequest", n), r = "/class/{classId}/dshb-kind-override".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setClassErrorDeductionScheme", "classId", t), C("setClassErrorDeductionScheme", "setClassErrorDeductionSchemeRequest", n), r = "/class/{classId}/error-deduction-scheme".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setClassFaultTimeLimit", "classId", t), C("setClassFaultTimeLimit", "setClassFaultTimeLimitRequest", n), r = "/class/{classId}/fault-time-limit".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setClassQualityJudging: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setClassQualityJudging", "classId", t), C("setClassQualityJudging", "setClassQualityJudgingRequest", n), r = "/class/{classId}/quality-judging".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setClassResultLayout: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setClassResultLayout", "classId", t), C("setClassResultLayout", "setClassResultLayoutRequest", n), r = "/class/{classId}/result-layout".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setClassScribeAssignment: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setClassScribeAssignment", "classId", t), C("setClassScribeAssignment", "setClassScribeAssignmentRequest", n), r = "/class/{classId}/scribe-assignments".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setClassSectionJudgeAssignments", "classId", t), r = "/class/{classId}/section-judge-assignments".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setClassSkipUsefUpload: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setClassSkipUsefUpload", "classId", t), C("setClassSkipUsefUpload", "setClassSkipUsefUploadRequest", n), r = "/class/{classId}/skip-usef-upload".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setClassWalkTrotOnly: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setClassWalkTrotOnly", "classId", t), C("setClassWalkTrotOnly", "setClassWalkTrotOnlyRequest", n), r = "/class/{classId}/walk-trot-only".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setRingScribeAssignments: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setRingScribeAssignments", "ring", t), C("setRingScribeAssignments", "setRingScribeAssignmentsRequest", n), r = "/ring/{ring}/scribe-assignments".replace("{ring}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  } };
}, dt = function(e) {
  var t = ap(e);
  return { getChampionshipFillOptions: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getChampionshipFillOptions(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ClassesApi.getChampionshipFillOptions"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, getClass: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getClass(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ClassesApi.getClass"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, listClasses: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.listClasses(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ClassesApi.listClasses"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, listClassesForShows: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listClassesForShows(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ClassesApi.listClassesForShows"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, setClassDshbKindOverride: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassDshbKindOverride(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ClassesApi.setClassDshbKindOverride"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassErrorDeductionScheme(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ClassesApi.setClassErrorDeductionScheme"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassFaultTimeLimit(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ClassesApi.setClassFaultTimeLimit"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setClassQualityJudging: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassQualityJudging(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ClassesApi.setClassQualityJudging"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setClassResultLayout: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassResultLayout(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ClassesApi.setClassResultLayout"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setClassScribeAssignment: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassScribeAssignment(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ClassesApi.setClassScribeAssignment"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassSectionJudgeAssignments(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ClassesApi.setClassSectionJudgeAssignments"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setClassSkipUsefUpload: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassSkipUsefUpload(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ClassesApi.setClassSkipUsefUpload"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setClassWalkTrotOnly: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassWalkTrotOnly(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ClassesApi.setClassWalkTrotOnly"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setRingScribeAssignments: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setRingScribeAssignments(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ClassesApi.setRingScribeAssignments"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "getChampionshipFillOptions", value: function(n, s) {
    var r = this;
    return dt(this.configuration).getChampionshipFillOptions(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getClass", value: function(n, s) {
    var r = this;
    return dt(this.configuration).getClass(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "listClasses", value: function(n, s, r) {
    var i = this;
    return dt(this.configuration).listClasses(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "listClassesForShows", value: function(n, s) {
    var r = this;
    return dt(this.configuration).listClassesForShows(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "setClassDshbKindOverride", value: function(n, s, r) {
    var i = this;
    return dt(this.configuration).setClassDshbKindOverride(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassErrorDeductionScheme", value: function(n, s, r) {
    var i = this;
    return dt(this.configuration).setClassErrorDeductionScheme(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassFaultTimeLimit", value: function(n, s, r) {
    var i = this;
    return dt(this.configuration).setClassFaultTimeLimit(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassQualityJudging", value: function(n, s, r) {
    var i = this;
    return dt(this.configuration).setClassQualityJudging(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassResultLayout", value: function(n, s, r) {
    var i = this;
    return dt(this.configuration).setClassResultLayout(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassScribeAssignment", value: function(n, s, r) {
    var i = this;
    return dt(this.configuration).setClassScribeAssignment(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassSectionJudgeAssignments", value: function(n, s, r) {
    var i = this;
    return dt(this.configuration).setClassSectionJudgeAssignments(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassSkipUsefUpload", value: function(n, s, r) {
    var i = this;
    return dt(this.configuration).setClassSkipUsefUpload(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassWalkTrotOnly", value: function(n, s, r) {
    var i = this;
    return dt(this.configuration).setClassWalkTrotOnly(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setRingScribeAssignments", value: function(n, s, r) {
    var i = this;
    return dt(this.configuration).setRingScribeAssignments(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Ke);
var up = function(e) {
  return { getDaysheetReconcileStatus: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getDaysheetReconcileStatus", "showId", t), s = "/daysheet/{showId}/status".replace("{showId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, reconcileDaysheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("reconcileDaysheet", "showId", t), s = "/daysheet/{showId}/reconcile".replace("{showId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "POST" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  } };
}, Ta = function(e) {
  var t = up(e);
  return { getDaysheetReconcileStatus: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getDaysheetReconcileStatus(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["DaySheetApi.getDaysheetReconcileStatus"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, reconcileDaysheet: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.reconcileDaysheet(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["DaySheetApi.reconcileDaysheet"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "getDaysheetReconcileStatus", value: function(n, s) {
    var r = this;
    return Ta(this.configuration).getDaysheetReconcileStatus(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "reconcileDaysheet", value: function(n, s) {
    var r = this;
    return Ta(this.configuration).reconcileDaysheet(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }]), t;
})(Ke);
var cp = function(e) {
  return { reseedDemo: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return C("reseedDemo", "reseedDemoRequest", t), s = new URL("/demo/reseed", I), e && (r = e.baseOptions), i = m({ method: "POST" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  } };
}, lp = function(e) {
  var t = cp(e);
  return { reseedDemo: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.reseedDemo(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["DemoApi.reseedDemo"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "reseedDemo", value: function(n, s) {
    var r = this;
    return lp(this.configuration).reseedDemo(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }]), t;
})(Ke);
var dp = function(e) {
  return { getHealth: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return g(function() {
      var n, s, r, i, o;
      return b(this, function(a) {
        return n = new URL("/health", I), e && (s = e.baseOptions), r = m({ method: "GET" }, s, t), i = {}, k(n, {}), o = s && s.headers ? s.headers : {}, r.headers = m({}, i, o, t.headers), [2, { url: P(n), options: r }];
      });
    })();
  } };
}, hp = function(e) {
  var t = dp(e);
  return { getHealth: function(n) {
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, t.getHealth(n)];
          case 1:
            return i = c.sent(), a = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, u = (r = _["HealthApi.getHealth"]) === null || r === void 0 || (s = r[a]) === null || s === void 0 ? void 0 : s.url, [2, function(l, d) {
              return j(i, O, T, e)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "getHealth", value: function(n) {
    var s = this;
    return hp(this.configuration).getHealth(n).then(function(r) {
      return r(s.axios, s.basePath);
    });
  } }]), t;
})(Ke);
var fp = function(e) {
  return { getHorse: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getHorse", "id", t), s = "/horse/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, listHorses: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return g(function() {
      var n, s, r, i, o, a;
      return b(this, function(u) {
        switch (u.label) {
          case 0:
            return n = new URL("/horse", I), e && (s = e.baseOptions), r = m({ method: "GET" }, s, t), o = {}, [4, A(i = {}, e)];
          case 1:
            return u.sent(), k(n, o), a = s && s.headers ? s.headers : {}, r.headers = m({}, i, a, t.headers), [2, { url: P(n), options: r }];
        }
      });
    })();
  } };
}, _a = function(e) {
  var t = fp(e);
  return { getHorse: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getHorse(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["HorsesApi.getHorse"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, listHorses: function(n) {
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, t.listHorses(n)];
          case 1:
            return i = c.sent(), a = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, u = (r = _["HorsesApi.listHorses"]) === null || r === void 0 || (s = r[a]) === null || s === void 0 ? void 0 : s.url, [2, function(l, d) {
              return j(i, O, T, e)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "getHorse", value: function(n, s) {
    var r = this;
    return _a(this.configuration).getHorse(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "listHorses", value: function(n) {
    var s = this;
    return _a(this.configuration).listHorses(n).then(function(r) {
      return r(s.axios, s.basePath);
    });
  } }]), t;
})(Ke);
var pp = function(e) {
  return { getInstanceConfig: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getInstanceConfig", "instanceId", t), s = "/instance/{instanceId}/config".replace("{instanceId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  } };
}, vp = function(e) {
  var t = pp(e);
  return { getInstanceConfig: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getInstanceConfig(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["InstanceApi.getInstanceConfig"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "getInstanceConfig", value: function(n, s) {
    var r = this;
    return vp(this.configuration).getInstanceConfig(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }]), t;
})(Ke);
var mp = function(e) {
  return { createCompositeJudgeMap: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return C("createCompositeJudgeMap", "createCompositeJudgeMapRequest", t), s = new URL("/composite-judge-map", I), e && (r = e.baseOptions), i = m({ method: "POST" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, deleteCompositeJudgeMap: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("deleteCompositeJudgeMap", "id", t), s = "/composite-judge-map/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "DELETE" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, deleteJudgeSignature: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("deleteJudgeSignature", "id", t), s = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "DELETE" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, getCompositeJudgeMap: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getCompositeJudgeMap", "id", t), s = "/composite-judge-map/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, listCompositeJudgeMaps: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return C("listCompositeJudgeMaps", "showId", t), s = new URL("/composite-judge-map", I), e && (r = e.baseOptions), i = m({ method: "GET" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.showId = t), k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, listJudges: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return C("listJudges", "showId", t), s = new URL("/judge", I), e && (r = e.baseOptions), i = m({ method: "GET" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.showId = t), k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, putJudgeSignature: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("putJudgeSignature", "id", t), C("putJudgeSignature", "putJudgeSignatureRequest", n), r = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "POST" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, resolveJudgeComposite: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("resolveJudgeComposite", "id", t), s = "/judge/{id}/resolve".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, updateCompositeJudgeMap: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("updateCompositeJudgeMap", "id", t), r = "/composite-judge-map/{id}".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  } };
}, Ut = function(e) {
  var t = mp(e);
  return { createCompositeJudgeMap: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.createCompositeJudgeMap(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["JudgesApi.createCompositeJudgeMap"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, deleteCompositeJudgeMap: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.deleteCompositeJudgeMap(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["JudgesApi.deleteCompositeJudgeMap"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, deleteJudgeSignature: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.deleteJudgeSignature(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["JudgesApi.deleteJudgeSignature"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, getCompositeJudgeMap: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getCompositeJudgeMap(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["JudgesApi.getCompositeJudgeMap"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, listCompositeJudgeMaps: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listCompositeJudgeMaps(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["JudgesApi.listCompositeJudgeMaps"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, listJudges: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listJudges(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["JudgesApi.listJudges"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, putJudgeSignature: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.putJudgeSignature(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["JudgesApi.putJudgeSignature"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, resolveJudgeComposite: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.resolveJudgeComposite(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["JudgesApi.resolveJudgeComposite"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, updateCompositeJudgeMap: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.updateCompositeJudgeMap(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["JudgesApi.updateCompositeJudgeMap"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "createCompositeJudgeMap", value: function(n, s) {
    var r = this;
    return Ut(this.configuration).createCompositeJudgeMap(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "deleteCompositeJudgeMap", value: function(n, s) {
    var r = this;
    return Ut(this.configuration).deleteCompositeJudgeMap(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "deleteJudgeSignature", value: function(n, s) {
    var r = this;
    return Ut(this.configuration).deleteJudgeSignature(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getCompositeJudgeMap", value: function(n, s) {
    var r = this;
    return Ut(this.configuration).getCompositeJudgeMap(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "listCompositeJudgeMaps", value: function(n, s) {
    var r = this;
    return Ut(this.configuration).listCompositeJudgeMaps(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "listJudges", value: function(n, s) {
    var r = this;
    return Ut(this.configuration).listJudges(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "putJudgeSignature", value: function(n, s, r) {
    var i = this;
    return Ut(this.configuration).putJudgeSignature(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "resolveJudgeComposite", value: function(n, s) {
    var r = this;
    return Ut(this.configuration).resolveJudgeComposite(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "updateCompositeJudgeMap", value: function(n, s, r) {
    var i = this;
    return Ut(this.configuration).updateCompositeJudgeMap(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Ke);
var gp = function(e) {
  return { createPerson: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return s = new URL("/people", I), e && (r = e.baseOptions), i = m({ method: "POST" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, deletePerson: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("deletePerson", "id", t), s = "/people/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "DELETE" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, getPerson: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getPerson", "id", t), s = "/people/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, listPeople: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return s = new URL("/people", I), e && (r = e.baseOptions), i = m({ method: "GET" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.personType = t), k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, updatePerson: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("updatePerson", "id", t), r = "/people/{id}".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  } };
}, Fn = function(e) {
  var t = gp(e);
  return { createPerson: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.createPerson(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["PeopleApi.createPerson"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, deletePerson: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.deletePerson(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["PeopleApi.deletePerson"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, getPerson: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getPerson(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["PeopleApi.getPerson"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, listPeople: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listPeople(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["PeopleApi.listPeople"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, updatePerson: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.updatePerson(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["PeopleApi.updatePerson"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "createPerson", value: function(n, s) {
    var r = this;
    return Fn(this.configuration).createPerson(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "deletePerson", value: function(n, s) {
    var r = this;
    return Fn(this.configuration).deletePerson(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getPerson", value: function(n, s) {
    var r = this;
    return Fn(this.configuration).getPerson(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "listPeople", value: function(n, s) {
    var r = this;
    return Fn(this.configuration).listPeople(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "updatePerson", value: function(n, s, r) {
    var i = this;
    return Fn(this.configuration).updatePerson(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Ke);
var bp = function(e) {
  return { getClassResults: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getClassResults", "classId", t), s = "/class/{classId}/results".replace("{classId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, getRideResult: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getRideResult", "rideId", t), s = "/ride/{rideId}/results".replace("{rideId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, setClassPlacings: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setClassPlacings", "classId", t), C("setClassPlacings", "setClassPlacingsRequest", n), r = "/class/{classId}/placings".replace("{classId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setRidePlacing: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setRidePlacing", "rideId", t), r = "/ride/{rideId}/placing".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  } };
}, Sr = function(e) {
  var t = bp(e);
  return { getClassResults: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getClassResults(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ResultsApi.getClassResults"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, getRideResult: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getRideResult(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ResultsApi.getRideResult"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, setClassPlacings: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setClassPlacings(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ResultsApi.setClassPlacings"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setRidePlacing: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setRidePlacing(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ResultsApi.setRidePlacing"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "getClassResults", value: function(n, s) {
    var r = this;
    return Sr(this.configuration).getClassResults(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getRideResult", value: function(n, s) {
    var r = this;
    return Sr(this.configuration).getRideResult(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "setClassPlacings", value: function(n, s, r) {
    var i = this;
    return Sr(this.configuration).setClassPlacings(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setRidePlacing", value: function(n, s, r) {
    var i = this;
    return Sr(this.configuration).setRidePlacing(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Ke);
var yp = function(e) {
  return { addRideMovement: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("addRideMovement", "rideId", t), r = "/ride/{rideId}/movements".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "POST" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, batchRideStatus: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return C("batchRideStatus", "batchRideStatusRequest", t), s = new URL("/rides/status", I), e && (r = e.baseOptions), i = m({ method: "POST" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, createRide: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return s = new URL("/ride", I), e && (r = e.baseOptions), i = m({ method: "POST" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, createRideUtilityEvent: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("createRideUtilityEvent", "rideId", t), C("createRideUtilityEvent", "createRideUtilityEventRequest", n), r = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "POST" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("deleteRideUtilityEvent", "rideId", t), C("deleteRideUtilityEvent", "eventId", n), r = "/ride/{rideId}/utility-events/{eventId}".replace("{rideId}", encodeURIComponent(String(t))).replace("{eventId}", encodeURIComponent(String(n))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "DELETE" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, fillChampionshipSlot: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("fillChampionshipSlot", "rideId", t), C("fillChampionshipSlot", "fillChampionshipSlotRequest", n), r = "/ride/{rideId}/championship-slot".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, getRide: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getRide", "rideId", t), s = "/ride/{rideId}".replace("{rideId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, getRideExcused: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getRideExcused", "rideId", t), s = "/ride/{rideId}/excused".replace("{rideId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, getRideNoShow: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getRideNoShow", "rideId", t), s = "/ride/{rideId}/no-show".replace("{rideId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, listRideUtilityEvents: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("listRideUtilityEvents", "rideId", t), s = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, listRides: function(t, n, s, r, i, o, a, u, c) {
    var l = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : {};
    return g(function() {
      var d, h, f, w, v, E;
      return b(this, function(B) {
        switch (B.label) {
          case 0:
            return d = new URL("/ride", I), e && (h = e.baseOptions), f = m({ method: "GET" }, h, l), v = {}, [4, A(w = {}, e)];
          case 1:
            return B.sent(), t !== void 0 && (v.classId = t), n !== void 0 && (v.showId = n), s !== void 0 && (v.day = s), r !== void 0 && (v.ring = r), i !== void 0 && (v.needsReview = i), o !== void 0 && (v.riderId = o), a !== void 0 && (v.horseId = a), u !== void 0 && (v.fvdPushStatus = u), c !== void 0 && (v.unscheduled = c), k(d, v), E = h && h.headers ? h.headers : {}, f.headers = m({}, w, E, l.headers), [2, { url: P(d), options: f }];
        }
      });
    })();
  }, markRideExcused: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("markRideExcused", "rideId", t), s = "/ride/{rideId}/excused".replace("{rideId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "POST" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, markRideNoShow: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("markRideNoShow", "rideId", t), s = "/ride/{rideId}/no-show".replace("{rideId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "POST" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, removeRideMovement: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("removeRideMovement", "rideId", t), C("removeRideMovement", "movementNumber", n), r = "/ride/{rideId}/movements/{movementNumber}".replace("{rideId}", encodeURIComponent(String(t))).replace("{movementNumber}", encodeURIComponent(String(n))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "DELETE" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, repointRide: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("repointRide", "rideId", t), C("repointRide", "repointRideRequest", n), r = "/ride/{rideId}/repoint".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "POST" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, reportFvdPushStatus: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return C("reportFvdPushStatus", "reportFvdPushStatusRequest", t), s = new URL("/rides/fvd-push-status", I), e && (r = e.baseOptions), i = m({ method: "POST" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, resolveManualRide: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("resolveManualRide", "rideId", t), C("resolveManualRide", "resolveManualRideRequest", n), r = "/ride/{rideId}/resolve".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "POST" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setRideStatus: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setRideStatus", "rideId", t), C("setRideStatus", "setRideStatusRequest", n), r = "/ride/{rideId}/status".replace("{rideId}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, undoRideExcused: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("undoRideExcused", "rideId", t), s = "/ride/{rideId}/excused".replace("{rideId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "DELETE" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, undoRideNoShow: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("undoRideNoShow", "rideId", t), s = "/ride/{rideId}/no-show".replace("{rideId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "DELETE" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  } };
}, De = function(e) {
  var t = yp(e);
  return { addRideMovement: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.addRideMovement(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["RidesApi.addRideMovement"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, batchRideStatus: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.batchRideStatus(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["RidesApi.batchRideStatus"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, createRide: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.createRide(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["RidesApi.createRide"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, createRideUtilityEvent: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.createRideUtilityEvent(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["RidesApi.createRideUtilityEvent"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.deleteRideUtilityEvent(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["RidesApi.deleteRideUtilityEvent"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, fillChampionshipSlot: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.fillChampionshipSlot(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["RidesApi.fillChampionshipSlot"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, getRide: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getRide(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["RidesApi.getRide"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, getRideExcused: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getRideExcused(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["RidesApi.getRideExcused"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, getRideNoShow: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getRideNoShow(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["RidesApi.getRideNoShow"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, listRideUtilityEvents: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listRideUtilityEvents(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["RidesApi.listRideUtilityEvents"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, listRides: function(n, s, r, i, o, a, u, c, l, d) {
    return g(function() {
      var h, f, w, v, E, B;
      return b(this, function(N) {
        switch (N.label) {
          case 0:
            return [4, t.listRides(n, s, r, i, o, a, u, c, l, d)];
          case 1:
            return w = N.sent(), E = (v = e == null ? void 0 : e.serverIndex) !== null && v !== void 0 ? v : 0, B = (f = _["RidesApi.listRides"]) === null || f === void 0 || (h = f[E]) === null || h === void 0 ? void 0 : h.url, [2, function(M, G) {
              return j(w, O, T, e)(M, B || G);
            }];
        }
      });
    })();
  }, markRideExcused: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.markRideExcused(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["RidesApi.markRideExcused"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, markRideNoShow: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.markRideNoShow(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["RidesApi.markRideNoShow"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, removeRideMovement: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.removeRideMovement(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["RidesApi.removeRideMovement"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, repointRide: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.repointRide(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["RidesApi.repointRide"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, reportFvdPushStatus: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.reportFvdPushStatus(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["RidesApi.reportFvdPushStatus"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, resolveManualRide: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.resolveManualRide(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["RidesApi.resolveManualRide"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setRideStatus: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setRideStatus(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["RidesApi.setRideStatus"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, undoRideExcused: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.undoRideExcused(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["RidesApi.undoRideExcused"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, undoRideNoShow: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.undoRideNoShow(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["RidesApi.undoRideNoShow"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "addRideMovement", value: function(n, s, r) {
    var i = this;
    return De(this.configuration).addRideMovement(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "batchRideStatus", value: function(n, s) {
    var r = this;
    return De(this.configuration).batchRideStatus(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "createRide", value: function(n, s) {
    var r = this;
    return De(this.configuration).createRide(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "createRideUtilityEvent", value: function(n, s, r) {
    var i = this;
    return De(this.configuration).createRideUtilityEvent(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "deleteRideUtilityEvent", value: function(n, s, r) {
    var i = this;
    return De(this.configuration).deleteRideUtilityEvent(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "fillChampionshipSlot", value: function(n, s, r) {
    var i = this;
    return De(this.configuration).fillChampionshipSlot(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "getRide", value: function(n, s) {
    var r = this;
    return De(this.configuration).getRide(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getRideExcused", value: function(n, s) {
    var r = this;
    return De(this.configuration).getRideExcused(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getRideNoShow", value: function(n, s) {
    var r = this;
    return De(this.configuration).getRideNoShow(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "listRideUtilityEvents", value: function(n, s) {
    var r = this;
    return De(this.configuration).listRideUtilityEvents(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "listRides", value: function(n, s, r, i, o, a, u, c, l, d) {
    var h = this;
    return De(this.configuration).listRides(n, s, r, i, o, a, u, c, l, d).then(function(f) {
      return f(h.axios, h.basePath);
    });
  } }, { key: "markRideExcused", value: function(n, s) {
    var r = this;
    return De(this.configuration).markRideExcused(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "markRideNoShow", value: function(n, s) {
    var r = this;
    return De(this.configuration).markRideNoShow(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "removeRideMovement", value: function(n, s, r) {
    var i = this;
    return De(this.configuration).removeRideMovement(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "repointRide", value: function(n, s, r) {
    var i = this;
    return De(this.configuration).repointRide(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "reportFvdPushStatus", value: function(n, s) {
    var r = this;
    return De(this.configuration).reportFvdPushStatus(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "resolveManualRide", value: function(n, s, r) {
    var i = this;
    return De(this.configuration).resolveManualRide(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setRideStatus", value: function(n, s, r) {
    var i = this;
    return De(this.configuration).setRideStatus(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "undoRideExcused", value: function(n, s) {
    var r = this;
    return De(this.configuration).undoRideExcused(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "undoRideNoShow", value: function(n, s) {
    var r = this;
    return De(this.configuration).undoRideNoShow(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }]), t;
})(Ke);
var wp = function(e) {
  return { clearRingState: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("clearRingState", "showId", t), C("clearRingState", "ring", n), r = "/ring-state/{ring}".replace("{ring}", encodeURIComponent(String(n))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "DELETE" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), t !== void 0 && (c.showId = t), k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, getRingState: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("getRingState", "showId", t), C("getRingState", "ring", n), r = "/ring-state/{ring}".replace("{ring}", encodeURIComponent(String(n))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "GET" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), t !== void 0 && (c.showId = t), k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, listRingStates: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return C("listRingStates", "showId", t), s = new URL("/ring-state", I), e && (r = e.baseOptions), i = m({ method: "GET" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.showId = t), k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, setRingState: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return C("setRingState", "setRingStateRequest", t), s = new URL("/ring-state", I), e && (r = e.baseOptions), i = m({ method: "PUT" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  } };
}, Rr = function(e) {
  var t = wp(e);
  return { clearRingState: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.clearRingState(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["RingStateApi.clearRingState"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, getRingState: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.getRingState(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["RingStateApi.getRingState"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, listRingStates: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listRingStates(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["RingStateApi.listRingStates"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, setRingState: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.setRingState(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["RingStateApi.setRingState"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "clearRingState", value: function(n, s, r) {
    var i = this;
    return Rr(this.configuration).clearRingState(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "getRingState", value: function(n, s, r) {
    var i = this;
    return Rr(this.configuration).getRingState(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "listRingStates", value: function(n, s) {
    var r = this;
    return Rr(this.configuration).listRingStates(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "setRingState", value: function(n, s) {
    var r = this;
    return Rr(this.configuration).setRingState(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }]), t;
})(Ke);
var Sp = function(e) {
  return { addScoreSheetAnnotation: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("addScoreSheetAnnotation", "id", t), C("addScoreSheetAnnotation", "addScoreSheetAnnotationRequest", n), r = "/scoresheet/{id}/annotations".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "POST" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, commitScoreSheetEdit: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("commitScoreSheetEdit", "id", t), C("commitScoreSheetEdit", "commitScoreSheetEditRequest", n), r = "/scoresheet/{id}/commit".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "POST" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, completeScoreSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("completeScoreSheet", "id", t), s = "/scoresheet/{id}/complete".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "POST" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("confirmScoreSheetMarks", "id", t), s = "/scoresheet/{id}/confirm-marks".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "POST" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, createScoreSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return s = new URL("/scoresheet", I), e && (r = e.baseOptions), i = m({ method: "POST" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, discardScoreSheetDraft: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("discardScoreSheetDraft", "id", t), s = "/scoresheet/{id}/draft".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "DELETE" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, getRideAuditTrail: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getRideAuditTrail", "rideId", t), s = "/ride/{rideId}/audit".replace("{rideId}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, getScoreSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getScoreSheet", "id", t), s = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getScoreSheetAuditTrail", "id", t), s = "/scoresheet/{id}/audit".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, getScoreSheetDraft: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getScoreSheetDraft", "id", t), s = "/scoresheet/{id}/draft".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, getScoreSheetSignature: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getScoreSheetSignature", "id", t), s = "/scoresheet/{id}/signature".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, listScoreSheets: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return r = new URL("/scoresheet", I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, s), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), t !== void 0 && (u.rideId = t), n !== void 0 && (u.judgeId = n), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, s.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, listScoreSheetsForRides: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return C("listScoreSheetsForRides", "listScoreSheetsForRidesRequest", t), s = new URL("/scoresheet/batch", I), e && (r = e.baseOptions), i = m({ method: "POST" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, putScoreSheetDraft: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("putScoreSheetDraft", "id", t), r = "/scoresheet/{id}/draft".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, signScoreSheetPanel: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("signScoreSheetPanel", "id", t), C("signScoreSheetPanel", "signScoreSheetPanelRequest", n), r = "/scoresheet/{id}/panel-signature".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "POST" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, unlockScoreSheet: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("unlockScoreSheet", "id", t), C("unlockScoreSheet", "unlockScoreSheetRequest", n), r = "/scoresheet/{id}/unlock".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "POST" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, updateScoreSheet: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("updateScoreSheet", "id", t), r = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  } };
}, Ge = function(e) {
  var t = Sp(e);
  return { addScoreSheetAnnotation: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.addScoreSheetAnnotation(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ScoreSheetsApi.addScoreSheetAnnotation"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, commitScoreSheetEdit: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.commitScoreSheetEdit(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ScoreSheetsApi.commitScoreSheetEdit"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, completeScoreSheet: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.completeScoreSheet(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreSheetsApi.completeScoreSheet"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.confirmScoreSheetMarks(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreSheetsApi.confirmScoreSheetMarks"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, createScoreSheet: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.createScoreSheet(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreSheetsApi.createScoreSheet"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, discardScoreSheetDraft: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.discardScoreSheetDraft(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreSheetsApi.discardScoreSheetDraft"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, getRideAuditTrail: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getRideAuditTrail(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreSheetsApi.getRideAuditTrail"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, getScoreSheet: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getScoreSheet(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreSheetsApi.getScoreSheet"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getScoreSheetAuditTrail(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreSheetsApi.getScoreSheetAuditTrail"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, getScoreSheetDraft: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getScoreSheetDraft(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreSheetsApi.getScoreSheetDraft"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, getScoreSheetSignature: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getScoreSheetSignature(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreSheetsApi.getScoreSheetSignature"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, listScoreSheets: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.listScoreSheets(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ScoreSheetsApi.listScoreSheets"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, listScoreSheetsForRides: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listScoreSheetsForRides(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreSheetsApi.listScoreSheetsForRides"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, putScoreSheetDraft: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.putScoreSheetDraft(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ScoreSheetsApi.putScoreSheetDraft"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, signScoreSheetPanel: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.signScoreSheetPanel(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ScoreSheetsApi.signScoreSheetPanel"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, unlockScoreSheet: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.unlockScoreSheet(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ScoreSheetsApi.unlockScoreSheet"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, updateScoreSheet: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.updateScoreSheet(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ScoreSheetsApi.updateScoreSheet"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "addScoreSheetAnnotation", value: function(n, s, r) {
    var i = this;
    return Ge(this.configuration).addScoreSheetAnnotation(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "commitScoreSheetEdit", value: function(n, s, r) {
    var i = this;
    return Ge(this.configuration).commitScoreSheetEdit(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "completeScoreSheet", value: function(n, s) {
    var r = this;
    return Ge(this.configuration).completeScoreSheet(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "confirmScoreSheetMarks", value: function(n, s) {
    var r = this;
    return Ge(this.configuration).confirmScoreSheetMarks(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "createScoreSheet", value: function(n, s) {
    var r = this;
    return Ge(this.configuration).createScoreSheet(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "discardScoreSheetDraft", value: function(n, s) {
    var r = this;
    return Ge(this.configuration).discardScoreSheetDraft(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getRideAuditTrail", value: function(n, s) {
    var r = this;
    return Ge(this.configuration).getRideAuditTrail(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getScoreSheet", value: function(n, s) {
    var r = this;
    return Ge(this.configuration).getScoreSheet(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getScoreSheetAuditTrail", value: function(n, s) {
    var r = this;
    return Ge(this.configuration).getScoreSheetAuditTrail(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getScoreSheetDraft", value: function(n, s) {
    var r = this;
    return Ge(this.configuration).getScoreSheetDraft(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getScoreSheetSignature", value: function(n, s) {
    var r = this;
    return Ge(this.configuration).getScoreSheetSignature(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "listScoreSheets", value: function(n, s, r) {
    var i = this;
    return Ge(this.configuration).listScoreSheets(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "listScoreSheetsForRides", value: function(n, s) {
    var r = this;
    return Ge(this.configuration).listScoreSheetsForRides(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "putScoreSheetDraft", value: function(n, s, r) {
    var i = this;
    return Ge(this.configuration).putScoreSheetDraft(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "signScoreSheetPanel", value: function(n, s, r) {
    var i = this;
    return Ge(this.configuration).signScoreSheetPanel(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "unlockScoreSheet", value: function(n, s, r) {
    var i = this;
    return Ge(this.configuration).unlockScoreSheet(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "updateScoreSheet", value: function(n, s, r) {
    var i = this;
    return Ge(this.configuration).updateScoreSheet(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Ke);
var Rp = function(e) {
  return { createBrandAsset: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return C("createBrandAsset", "createBrandAssetRequest", t), s = new URL("/scoreboard/asset", I), e && (r = e.baseOptions), i = m({ method: "POST" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, createScoreboardView: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return s = new URL("/scoreboard/view", I), e && (r = e.baseOptions), i = m({ method: "POST" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, deleteBrandAsset: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("deleteBrandAsset", "id", t), s = "/scoreboard/asset/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "DELETE" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, deleteScoreboardTheme: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("deleteScoreboardTheme", "id", t), s = "/scoreboard/theme/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "DELETE" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, deleteScoreboardView: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("deleteScoreboardView", "id", t), s = "/scoreboard/view/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "DELETE" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, deleteSponsor: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("deleteSponsor", "id", t), s = "/scoreboard/sponsor/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "DELETE" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, getPublicClassResults: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        return C("getPublicClassResults", "showId", t), C("getPublicClassResults", "classId", n), r = "/public/scoreboard/{showId}/class/{classId}/results".replace("{showId}", encodeURIComponent(String(t))).replace("{classId}", encodeURIComponent(String(n))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "GET" }, o, s), u = {}, k(i, {}), c = o && o.headers ? o.headers : {}, a.headers = m({}, u, c, s.headers), [2, { url: P(i), options: a }];
      });
    })();
  }, getPublicScoreboard: function(t, n, s) {
    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        return C("getPublicScoreboard", "showId", t), C("getPublicScoreboard", "year", n), C("getPublicScoreboard", "slug", s), i = "/public/scoreboard/{showId}/{year}/{slug}?".replace("{showId}", encodeURIComponent(String(t))).replace("{year}", encodeURIComponent(String(n))).replace("{slug}", encodeURIComponent(String(s))), o = new URL(i, I), e && (a = e.baseOptions), u = m({ method: "GET" }, a, r), c = {}, k(o, {}), l = a && a.headers ? a.headers : {}, u.headers = m({}, c, l, r.headers), [2, { url: P(o), options: u }];
      });
    })();
  }, listBrandAssets: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return g(function() {
      var n, s, r, i, o, a;
      return b(this, function(u) {
        switch (u.label) {
          case 0:
            return n = new URL("/scoreboard/assets", I), e && (s = e.baseOptions), r = m({ method: "GET" }, s, t), o = {}, [4, A(i = {}, e)];
          case 1:
            return u.sent(), k(n, o), a = s && s.headers ? s.headers : {}, r.headers = m({}, i, a, t.headers), [2, { url: P(n), options: r }];
        }
      });
    })();
  }, listScoreboardThemes: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return g(function() {
      var n, s, r, i, o, a;
      return b(this, function(u) {
        switch (u.label) {
          case 0:
            return n = new URL("/scoreboard/themes", I), e && (s = e.baseOptions), r = m({ method: "GET" }, s, t), o = {}, [4, A(i = {}, e)];
          case 1:
            return u.sent(), k(n, o), a = s && s.headers ? s.headers : {}, r.headers = m({}, i, a, t.headers), [2, { url: P(n), options: r }];
        }
      });
    })();
  }, listScoreboardViews: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return C("listScoreboardViews", "showId", t), s = new URL("/scoreboard/views", I), e && (r = e.baseOptions), i = m({ method: "GET" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.showId = t), k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, listSponsors: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return g(function() {
      var n, s, r, i, o, a;
      return b(this, function(u) {
        switch (u.label) {
          case 0:
            return n = new URL("/scoreboard/sponsors", I), e && (s = e.baseOptions), r = m({ method: "GET" }, s, t), o = {}, [4, A(i = {}, e)];
          case 1:
            return u.sent(), k(n, o), a = s && s.headers ? s.headers : {}, r.headers = m({}, i, a, t.headers), [2, { url: P(n), options: r }];
        }
      });
    })();
  }, putScoreboardTheme: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return s = new URL("/scoreboard/theme", I), e && (r = e.baseOptions), i = m({ method: "POST" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, putSponsor: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return s = new URL("/scoreboard/sponsor", I), e && (r = e.baseOptions), i = m({ method: "POST" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, resolveClassByNumber: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        return C("resolveClassByNumber", "showId", t), C("resolveClassByNumber", "classNumber", n), r = "/public/scoreboard/{showId}/class-number/{classNumber}".replace("{showId}", encodeURIComponent(String(t))).replace("{classNumber}", encodeURIComponent(String(n))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "GET" }, o, s), u = {}, k(i, {}), c = o && o.headers ? o.headers : {}, a.headers = m({}, u, c, s.headers), [2, { url: P(i), options: a }];
      });
    })();
  }, setScoreboardViewCurrentMode: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setScoreboardViewCurrentMode", "id", t), r = "/scoreboard/view/{id}/current-mode".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "POST" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, updateScoreboardView: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("updateScoreboardView", "id", t), r = "/scoreboard/view/{id}".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PATCH" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  } };
}, We = function(e) {
  var t = Rp(e);
  return { createBrandAsset: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.createBrandAsset(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreboardApi.createBrandAsset"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, createScoreboardView: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.createScoreboardView(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreboardApi.createScoreboardView"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, deleteBrandAsset: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.deleteBrandAsset(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreboardApi.deleteBrandAsset"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, deleteScoreboardTheme: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.deleteScoreboardTheme(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreboardApi.deleteScoreboardTheme"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, deleteScoreboardView: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.deleteScoreboardView(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreboardApi.deleteScoreboardView"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, deleteSponsor: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.deleteSponsor(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreboardApi.deleteSponsor"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, getPublicClassResults: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.getPublicClassResults(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ScoreboardApi.getPublicClassResults"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, getPublicScoreboard: function(n, s, r, i) {
    return g(function() {
      var o, a, u, c, l, d;
      return b(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, t.getPublicScoreboard(n, s, r, i)];
          case 1:
            return u = h.sent(), l = (c = e == null ? void 0 : e.serverIndex) !== null && c !== void 0 ? c : 0, d = (a = _["ScoreboardApi.getPublicScoreboard"]) === null || a === void 0 || (o = a[l]) === null || o === void 0 ? void 0 : o.url, [2, function(f, w) {
              return j(u, O, T, e)(f, d || w);
            }];
        }
      });
    })();
  }, listBrandAssets: function(n) {
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, t.listBrandAssets(n)];
          case 1:
            return i = c.sent(), a = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, u = (r = _["ScoreboardApi.listBrandAssets"]) === null || r === void 0 || (s = r[a]) === null || s === void 0 ? void 0 : s.url, [2, function(l, d) {
              return j(i, O, T, e)(l, u || d);
            }];
        }
      });
    })();
  }, listScoreboardThemes: function(n) {
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, t.listScoreboardThemes(n)];
          case 1:
            return i = c.sent(), a = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, u = (r = _["ScoreboardApi.listScoreboardThemes"]) === null || r === void 0 || (s = r[a]) === null || s === void 0 ? void 0 : s.url, [2, function(l, d) {
              return j(i, O, T, e)(l, u || d);
            }];
        }
      });
    })();
  }, listScoreboardViews: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listScoreboardViews(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreboardApi.listScoreboardViews"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, listSponsors: function(n) {
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, t.listSponsors(n)];
          case 1:
            return i = c.sent(), a = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, u = (r = _["ScoreboardApi.listSponsors"]) === null || r === void 0 || (s = r[a]) === null || s === void 0 ? void 0 : s.url, [2, function(l, d) {
              return j(i, O, T, e)(l, u || d);
            }];
        }
      });
    })();
  }, putScoreboardTheme: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.putScoreboardTheme(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreboardApi.putScoreboardTheme"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, putSponsor: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.putSponsor(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ScoreboardApi.putSponsor"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, resolveClassByNumber: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.resolveClassByNumber(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ScoreboardApi.resolveClassByNumber"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setScoreboardViewCurrentMode: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setScoreboardViewCurrentMode(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ScoreboardApi.setScoreboardViewCurrentMode"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, updateScoreboardView: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.updateScoreboardView(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ScoreboardApi.updateScoreboardView"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "createBrandAsset", value: function(n, s) {
    var r = this;
    return We(this.configuration).createBrandAsset(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "createScoreboardView", value: function(n, s) {
    var r = this;
    return We(this.configuration).createScoreboardView(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "deleteBrandAsset", value: function(n, s) {
    var r = this;
    return We(this.configuration).deleteBrandAsset(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "deleteScoreboardTheme", value: function(n, s) {
    var r = this;
    return We(this.configuration).deleteScoreboardTheme(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "deleteScoreboardView", value: function(n, s) {
    var r = this;
    return We(this.configuration).deleteScoreboardView(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "deleteSponsor", value: function(n, s) {
    var r = this;
    return We(this.configuration).deleteSponsor(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getPublicClassResults", value: function(n, s, r) {
    var i = this;
    return We(this.configuration).getPublicClassResults(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "getPublicScoreboard", value: function(n, s, r, i) {
    var o = this;
    return We(this.configuration).getPublicScoreboard(n, s, r, i).then(function(a) {
      return a(o.axios, o.basePath);
    });
  } }, { key: "listBrandAssets", value: function(n) {
    var s = this;
    return We(this.configuration).listBrandAssets(n).then(function(r) {
      return r(s.axios, s.basePath);
    });
  } }, { key: "listScoreboardThemes", value: function(n) {
    var s = this;
    return We(this.configuration).listScoreboardThemes(n).then(function(r) {
      return r(s.axios, s.basePath);
    });
  } }, { key: "listScoreboardViews", value: function(n, s) {
    var r = this;
    return We(this.configuration).listScoreboardViews(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "listSponsors", value: function(n) {
    var s = this;
    return We(this.configuration).listSponsors(n).then(function(r) {
      return r(s.axios, s.basePath);
    });
  } }, { key: "putScoreboardTheme", value: function(n, s) {
    var r = this;
    return We(this.configuration).putScoreboardTheme(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "putSponsor", value: function(n, s) {
    var r = this;
    return We(this.configuration).putSponsor(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "resolveClassByNumber", value: function(n, s, r) {
    var i = this;
    return We(this.configuration).resolveClassByNumber(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setScoreboardViewCurrentMode", value: function(n, s, r) {
    var i = this;
    return We(this.configuration).setScoreboardViewCurrentMode(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "updateScoreboardView", value: function(n, s, r) {
    var i = this;
    return We(this.configuration).updateScoreboardView(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Ke);
var xp = function(e) {
  return { getShow: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getShow", "id", t), s = "/show/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, listShows: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return g(function() {
      var n, s, r, i, o, a;
      return b(this, function(u) {
        switch (u.label) {
          case 0:
            return n = new URL("/show", I), e && (s = e.baseOptions), r = m({ method: "GET" }, s, t), o = {}, [4, A(i = {}, e)];
          case 1:
            return u.sent(), k(n, o), a = s && s.headers ? s.headers : {}, r.headers = m({}, i, a, t.headers), [2, { url: P(n), options: r }];
        }
      });
    })();
  }, setShowDefaultPlacingView: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setShowDefaultPlacingView", "id", t), r = "/show/{id}/default-placing-view".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setShowLogo: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setShowLogo", "id", t), r = "/show/{id}/logo".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setShowNoFoxbox: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setShowNoFoxbox", "id", t), C("setShowNoFoxbox", "setShowNoFoxboxRequest", n), r = "/show/{id}/no-foxbox".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setShowScribeUnlockPin: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setShowScribeUnlockPin", "id", t), r = "/show/{id}/scribe-unlock-pin".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  }, setShowVenueTimezone: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("setShowVenueTimezone", "id", t), r = "/show/{id}/venue-timezone".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  } };
}, Kt = function(e) {
  var t = xp(e);
  return { getShow: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getShow(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["ShowsApi.getShow"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, listShows: function(n) {
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, t.listShows(n)];
          case 1:
            return i = c.sent(), a = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, u = (r = _["ShowsApi.listShows"]) === null || r === void 0 || (s = r[a]) === null || s === void 0 ? void 0 : s.url, [2, function(l, d) {
              return j(i, O, T, e)(l, u || d);
            }];
        }
      });
    })();
  }, setShowDefaultPlacingView: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setShowDefaultPlacingView(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ShowsApi.setShowDefaultPlacingView"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setShowLogo: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setShowLogo(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ShowsApi.setShowLogo"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setShowNoFoxbox: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setShowNoFoxbox(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ShowsApi.setShowNoFoxbox"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setShowScribeUnlockPin: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setShowScribeUnlockPin(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ShowsApi.setShowScribeUnlockPin"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  }, setShowVenueTimezone: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.setShowVenueTimezone(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["ShowsApi.setShowVenueTimezone"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "getShow", value: function(n, s) {
    var r = this;
    return Kt(this.configuration).getShow(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "listShows", value: function(n) {
    var s = this;
    return Kt(this.configuration).listShows(n).then(function(r) {
      return r(s.axios, s.basePath);
    });
  } }, { key: "setShowDefaultPlacingView", value: function(n, s, r) {
    var i = this;
    return Kt(this.configuration).setShowDefaultPlacingView(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setShowLogo", value: function(n, s, r) {
    var i = this;
    return Kt(this.configuration).setShowLogo(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setShowNoFoxbox", value: function(n, s, r) {
    var i = this;
    return Kt(this.configuration).setShowNoFoxbox(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setShowScribeUnlockPin", value: function(n, s, r) {
    var i = this;
    return Kt(this.configuration).setShowScribeUnlockPin(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setShowVenueTimezone", value: function(n, s, r) {
    var i = this;
    return Kt(this.configuration).setShowVenueTimezone(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Ke);
var Cp = function(e) {
  return { createTest: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return s = new URL("/test", I), e && (r = e.baseOptions), i = m({ method: "POST" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), i.data = W(t, i, e), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, deleteTest: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("deleteTest", "id", t), s = "/test/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "DELETE" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, getTest: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return C("getTest", "id", t), s = "/test/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(s, I), e && (i = e.baseOptions), o = m({ method: "GET" }, i, n), u = {}, [4, A(a = {}, e)];
          case 1:
            return l.sent(), k(r, u), c = i && i.headers ? i.headers : {}, o.headers = m({}, a, c, n.headers), [2, { url: P(r), options: o }];
        }
      });
    })();
  }, listTests: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g(function() {
      var s, r, i, o, a, u;
      return b(this, function(c) {
        switch (c.label) {
          case 0:
            return s = new URL("/test", I), e && (r = e.baseOptions), i = m({ method: "GET" }, r, n), a = {}, [4, A(o = {}, e)];
          case 1:
            return c.sent(), t !== void 0 && (a.showId = t), k(s, a), u = r && r.headers ? r.headers : {}, i.headers = m({}, o, u, n.headers), [2, { url: P(s), options: i }];
        }
      });
    })();
  }, updateTest: function(t, n) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return g(function() {
      var r, i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return C("updateTest", "id", t), r = "/test/{id}".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, I), e && (o = e.baseOptions), a = m({ method: "PUT" }, o, s), c = {}, [4, A(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", k(i, c), l = o && o.headers ? o.headers : {}, a.headers = m({}, u, l, s.headers), a.data = W(n, a, e), [2, { url: P(i), options: a }];
        }
      });
    })();
  } };
}, Mn = function(e) {
  var t = Cp(e);
  return { createTest: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.createTest(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["TestsApi.createTest"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, deleteTest: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.deleteTest(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["TestsApi.deleteTest"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, getTest: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.getTest(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["TestsApi.getTest"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, listTests: function(n, s) {
    return g(function() {
      var r, i, o, a, u, c;
      return b(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, t.listTests(n, s)];
          case 1:
            return o = l.sent(), u = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = _["TestsApi.listTests"]) === null || i === void 0 || (r = i[u]) === null || r === void 0 ? void 0 : r.url, [2, function(d, h) {
              return j(o, O, T, e)(d, c || h);
            }];
        }
      });
    })();
  }, updateTest: function(n, s, r) {
    return g(function() {
      var i, o, a, u, c, l;
      return b(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, t.updateTest(n, s, r)];
          case 1:
            return a = d.sent(), c = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = _["TestsApi.updateTest"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(h, f) {
              return j(a, O, T, e)(h, l || f);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function t() {
    return Xe(this, t), Ye(this, t, arguments);
  }
  return et(t, e), Qe(t, [{ key: "createTest", value: function(n, s) {
    var r = this;
    return Mn(this.configuration).createTest(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "deleteTest", value: function(n, s) {
    var r = this;
    return Mn(this.configuration).deleteTest(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "getTest", value: function(n, s) {
    var r = this;
    return Mn(this.configuration).getTest(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "listTests", value: function(n, s) {
    var r = this;
    return Mn(this.configuration).listTests(n, s).then(function(i) {
      return i(r.axios, r.basePath);
    });
  } }, { key: "updateTest", value: function(n, s, r) {
    var i = this;
    return Mn(this.configuration).updateTest(n, s, r).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), t;
})(Ke);
function Ep(e, t) {
  for (var n = 0; n < t.length; n++) {
    var s = t[n];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
  }
}
function Nt(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ia(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, s = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (s = s.concat(Object.getOwnPropertySymbols(n).filter(function(r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    }))), s.forEach(function(r) {
      Nt(e, r, n[r]);
    });
  }
  return e;
}
(function() {
  function e() {
    var s, r, i, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(a, u) {
      if (!(a instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, e), Nt(this, "apiKey", void 0), Nt(this, "username", void 0), Nt(this, "password", void 0), Nt(this, "accessToken", void 0), Nt(this, "basePath", void 0), Nt(this, "serverIndex", void 0), Nt(this, "baseOptions", void 0), Nt(this, "formDataCtor", void 0), this.apiKey = o.apiKey, this.username = o.username, this.password = o.password, this.accessToken = o.accessToken, this.basePath = o.basePath, this.serverIndex = o.serverIndex, this.baseOptions = (r = Ia({}, o.baseOptions), i = (i = { headers: Ia({}, (s = o.baseOptions) === null || s === void 0 ? void 0 : s.headers) }) != null ? i : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(i)) : function(a) {
      var u = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(a);
        u.push.apply(u, c);
      }
      return u;
    }(Object(i)).forEach(function(a) {
      Object.defineProperty(r, a, Object.getOwnPropertyDescriptor(i, a));
    }), r), this.formDataCtor = o.formDataCtor;
  }
  var t, n;
  return t = e, (n = [{ key: "isJsonMime", value: function(s) {
    var r = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return s !== null && (r.test(s) || s.toLowerCase() === "application/json-patch+json");
  } }]) && Ep(t.prototype, n), e;
})();
const Op = {
  [Zt.PENDING]: { color: "default", label: "Scheduled" },
  // #768 — stored pre-sheet, C's "Bell" press (#767). Same "info" color
  // family as IN_PROGRESS (both mean "the horse is at the ring"); the label
  // is what tells entering from actually in progress.
  [Zt.ENTERING_RING]: { color: "info", label: "Entering ring" },
  [Zt.IN_PROGRESS]: { color: "info", label: "In ring" },
  // #696 — score confirmed/frozen and released to the announcer + FVD, judge
  // may still be writing comments. Green like FINAL ("score ready"); the label
  // is what tells the two apart.
  [Zt.CONFIRMED]: { color: "success", label: "Confirmed" },
  [Zt.COMPLETED]: { color: "warning", label: "Scored" },
  [Zt.FINAL]: { color: "success", label: "Final" },
  [Zt.SCRATCHED]: { color: "error", label: "Scratched" }
}, Tp = { color: "default", label: "—" };
function Xv({ status: e, labels: t, size: n = "small", ...s }) {
  const r = Op[e] ?? Tp, i = (t == null ? void 0 : t[e]) ?? r.label;
  return /* @__PURE__ */ p.jsx(Vs, { size: n, color: r.color, label: i, ...s });
}
function Qv(e, t, { intervalMs: n, enabled: s = !0 } = {}) {
  const [r, i] = V({}), [o, a] = V(!1), [u, c] = V(null), [l, d] = V(null), h = Array.from(new Set((e ?? []).filter(Boolean))), f = h.join(","), w = bt(t);
  w.current = t;
  const v = bt(h);
  v.current = h;
  const E = bt(f), B = s && h.length > 0 && typeof t == "function", N = Ft(async () => {
    const M = v.current;
    if (!(!M.length || typeof w.current != "function")) {
      a(!0);
      try {
        const G = await w.current(M), Ee = {};
        for (const de of G ?? []) Ee[de.rideId] = de.status;
        i(Ee), c(null), d(/* @__PURE__ */ new Date());
      } catch (G) {
        c(G);
      } finally {
        a(!1);
      }
    }
  }, []);
  return _e(() => {
    if (E.current !== f && (E.current = f, d(null)), !h.length) {
      i({});
      return;
    }
    if (!B)
      return;
    if (!n) {
      N();
      return;
    }
    document.visibilityState !== "hidden" && N();
    let M = null;
    const G = () => {
      document.visibilityState !== "hidden" && M == null && (M = setInterval(N, n));
    }, Ee = () => {
      M != null && (clearInterval(M), M = null);
    }, de = () => {
      document.visibilityState === "hidden" ? Ee() : (N(), G());
    };
    return G(), document.addEventListener("visibilitychange", de), () => {
      Ee(), document.removeEventListener("visibilitychange", de);
    };
  }, [f, B, n, N]), { statuses: r, loading: o, error: u, refresh: N, lastUpdated: l };
}
function em({
  judgeName: e,
  url: t,
  loading: n = !1,
  label: s = "Judge signature",
  ...r
}) {
  return n ? /* @__PURE__ */ p.jsxs(Jr, { spacing: 1, alignItems: "center", sx: { mt: 3 }, ...r, children: [
    /* @__PURE__ */ p.jsx(Hr, { variant: "rounded", width: 240, height: 90 }),
    /* @__PURE__ */ p.jsx(Hr, { variant: "text", width: 140 })
  ] }) : t ? /* @__PURE__ */ p.jsxs(
    Jr,
    {
      spacing: 1,
      alignItems: "center",
      "data-testid": "signature-box",
      sx: { mt: 3, pt: 2, borderTop: 1, borderColor: "divider" },
      ...r,
      children: [
        /* @__PURE__ */ p.jsx(Wn, { variant: "caption", color: "text.secondary", children: s }),
        /* @__PURE__ */ p.jsx(
          He,
          {
            sx: {
              border: 1,
              borderColor: "divider",
              borderRadius: 1,
              bgcolor: "#ffffff",
              p: 1,
              display: "flex",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ p.jsx(
              He,
              {
                component: "img",
                src: t,
                alt: e || s,
                "data-testid": "signature-box-image",
                sx: { maxWidth: 240, maxHeight: 90, objectFit: "contain" }
              }
            )
          }
        ),
        e && /* @__PURE__ */ p.jsx(
          Wn,
          {
            variant: "body2",
            color: "text.primary",
            fontWeight: 600,
            "data-testid": "signature-box-name",
            children: e
          }
        )
      ]
    }
  ) : null;
}
function tm(e, t, { enabled: n = !0 } = {}) {
  const [s, r] = V(null), [i, o] = V(!1), [a, u] = V(null), c = bt(t);
  c.current = t;
  const l = n && !!e && typeof t == "function";
  return _e(() => {
    if (!l) {
      r(null);
      return;
    }
    let d = !1;
    return o(!0), u(null), (async () => {
      try {
        const h = await c.current(e);
        d || r(h ?? null);
      } catch (h) {
        d || u(h);
      } finally {
        d || o(!1);
      }
    })(), () => {
      d = !0;
    };
  }, [l, e]), { signature: s, loading: i, error: a };
}
const yi = 64, _p = 50;
function ka({
  value: e,
  onChange: t,
  disabled: n,
  width: s = yi,
  borderless: r = !1,
  inputRef: i,
  onKeyDown: o,
  // #698 — true once this sheet's marks are confirmed (server-side, one-
  // way freeze). Renders the SAME success/green token RideStatusBadge uses
  // for its CONFIRMED status, so a locked-in mark reads as "confirmed", not
  // "broken/disabled".
  locked: a = !1,
  // #712 — granularity this field snaps to on blur (score-common
  // SCORE_STEP/ARTISTIC_SCORE_STEP/TENTH_SCORE_STEP, resolved per mark via
  // scoreStepFor). Defaults to the standard half-point step.
  step: u = ds,
  // #1755 — see the strict-mode doc above.
  strict: c = !1,
  // #1755 — static, already-translated tooltip text shown when `strict`
  // rejects the typed value. Required for `strict` to have
  // any visible effect; harmless (unused) otherwise.
  invalidLabel: l,
  // #1755 — fires with the current invalid boolean whenever it changes.
  // ScoreEntry's coefficient box uses this to turn its OWN border red too,
  // since the box's border replaces this field's outline (borderless) and
  // wouldn't otherwise reflect a rejected value.
  onValidityChange: d
}) {
  const [h, f] = V(!1), [w, v] = V(""), [E, B] = V(!1);
  _e(() => {
    d == null || d(E);
  }, [E]);
  const N = h || E ? w : typeof e == "number" ? e.toFixed(1) : "", M = /* @__PURE__ */ p.jsx(
    bn,
    {
      size: "small",
      value: N,
      type: "text",
      inputRef: i,
      error: E,
      onKeyDown: o,
      inputProps: {
        inputMode: "decimal",
        pattern: "[0-9.]*",
        maxLength: 4,
        // #221 — all number entry uses the same monospace typography as
        // the coefficient box (700, 0.875rem, centered) so every score
        // field reads consistently. The borderless in-box variant just
        // tightens its padding.
        style: {
          textAlign: "center",
          fontFamily: "monospace",
          fontWeight: 700,
          fontSize: "0.875rem",
          ...r && { padding: "4px 2px" }
        }
      },
      sx: (G) => ({
        width: s,
        // #221 — borderless variant sits inside the coefficient box, so
        // it drops its own outline (the box provides the border).
        ...r && {
          "& .MuiOutlinedInput-notchedOutline": { border: "none" }
        },
        // #698 — locked (confirmed) numeric entry renders green, not the
        // washed-out default disabled grey.
        ...a && {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: G.palette.success.main
          },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: G.palette.success.main,
            color: G.palette.success.main
          }
        }
      }),
      disabled: n,
      onFocus: (G) => {
        v(typeof e == "number" ? String(e) : ""), B(!1), f(!0), G.target.select();
      },
      onBlur: () => {
        if (c) {
          if (w === "") {
            B(!1), t(void 0), f(!1);
            return;
          }
          const Ee = Pu(w);
          if (Ee === null || Ee < Dh || Ee > yn) {
            B(!0), f(!1);
            return;
          }
          B(!1);
          const Z = ku(Ee, u);
          Z !== e && t(Z), f(!1);
          return;
        }
        const G = Bh(w, u);
        G === null ? w === "" && t(void 0) : G !== e && t(G), f(!1);
      },
      onChange: (G) => {
        v(G.target.value), E && B(!1);
      }
    }
  );
  return /* @__PURE__ */ p.jsx(
    Vc,
    {
      title: E ? l ?? "" : "",
      open: !!(E && l),
      arrow: !0,
      placement: "top",
      children: M
    }
  );
}
function nm({
  value: e,
  onChange: t,
  disabled: n,
  coefficient: s = 1,
  inputRef: r,
  onKeyDown: i,
  // #698 — see ScoreInput's `locked` doc above; threaded through unchanged.
  locked: o = !1,
  // #712 — see ScoreInput's `step` doc above; threaded through unchanged.
  step: a = ds,
  // #1755 — see ScoreInput's `strict`/`invalidLabel` doc above; threaded
  // through unchanged.
  strict: u = !1,
  invalidLabel: c,
  // #1755 continuation — save-gating (driver decision, card comment):
  // fires with the current invalid boolean whenever it changes, so
  // RideEditor can disable Save/Commit while any score cell is in error
  // instead of silently committing the last-known-good value under a
  // visibly-errored field.
  onValidityChange: l
}) {
  const [d, h] = V(!1), f = (w) => {
    h(w), l == null || l(w);
  };
  return s && s !== 1 ? /* @__PURE__ */ p.jsxs(
    fe,
    {
      "data-testid": "coefficient-entry",
      onClick: n ? void 0 : (w) => {
        var v;
        return (v = w.currentTarget.querySelector("input")) == null ? void 0 : v.focus();
      },
      sx: (w) => ({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: yi,
        height: 40,
        px: 0.75,
        borderRadius: 1,
        border: 1,
        cursor: n ? "default" : "text",
        // Match MUI's outlined-input border in both themes. #1755 — a
        // strict-mode rejected value wins over everything (the borderless
        // inner field's own red outline is suppressed, so this box is the
        // only place a coefficient row can show the error visibly). #698 —
        // locked (confirmed) otherwise wins over the plain-disabled divider
        // color so a coefficient row visibly freezes green too.
        borderColor: d ? w.palette.error.main : o ? w.palette.success.main : n ? w.palette.divider : w.palette.mode === "dark" ? "rgba(255, 255, 255, 0.23)" : "rgba(0, 0, 0, 0.23)"
      }),
      children: [
        /* @__PURE__ */ p.jsx(
          ka,
          {
            value: e,
            onChange: t,
            disabled: n,
            width: _p,
            borderless: !0,
            inputRef: r,
            onKeyDown: i,
            locked: o,
            step: a,
            strict: u,
            invalidLabel: c,
            onValidityChange: f
          }
        ),
        /* @__PURE__ */ p.jsxs(
          Ze,
          {
            component: "span",
            "data-testid": "coefficient-segment",
            "aria-label": `Coefficient ×${s}`,
            sx: {
              position: "absolute",
              right: 4,
              bottom: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              fontSize: "0.7rem",
              lineHeight: 1,
              color: "warning.main"
            },
            children: [
              "×",
              s
            ]
          }
        )
      ]
    }
  ) : /* @__PURE__ */ p.jsx(
    ka,
    {
      value: e,
      onChange: t,
      disabled: n,
      width: yi,
      inputRef: r,
      onKeyDown: i,
      locked: o,
      step: a,
      strict: u,
      invalidLabel: c,
      onValidityChange: l
    }
  );
}
function rm({ buildId: e, testId: t = "build-badge" }) {
  const n = Ka(e);
  return n ? /* @__PURE__ */ p.jsx(
    fe,
    {
      "data-testid": t,
      "aria-hidden": "true",
      sx: {
        position: "fixed",
        bottom: 2,
        left: 86,
        // Above AppBar/NavRail (both 1300/1200 in common-fe) so it's never
        // hidden by app chrome, but below modals/dialogs so it doesn't cover
        // interactive overlays. It's pointer-events:none anyway.
        zIndex: 1250,
        pointerEvents: "none",
        userSelect: "none",
        // A subtle themed pill so the text reads on top of any content —
        // proven legible in both light and dark (mirrors PinLock's approach).
        px: 0.5,
        py: "1px",
        borderRadius: 0.5,
        bgcolor: "background.paper",
        opacity: 0.75,
        // text.secondary reads on both light and dark backgrounds; never MUI
        // `primary` (dark-grey, vanishes on dark).
        color: "text.secondary",
        fontFamily: "monospace",
        fontSize: "9px",
        lineHeight: 1.2,
        letterSpacing: 0,
        whiteSpace: "nowrap"
      },
      children: n
    }
  ) : null;
}
function Ip({ testId: e = "usa-badge", variant: t = "fixed" }) {
  const n = t === "static";
  return /* @__PURE__ */ p.jsxs(
    fe,
    {
      "data-testid": e,
      "aria-hidden": "true",
      sx: {
        position: n ? "static" : "fixed",
        ...n ? {} : { bottom: 2, left: 2, zIndex: 1250 },
        width: 80,
        pointerEvents: "none",
        userSelect: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        opacity: 0.75
      },
      children: [
        /* @__PURE__ */ p.jsx(
          fe,
          {
            component: "svg",
            viewBox: "0 0 1200 1200",
            "aria-label": "Made in the USA",
            sx: {
              width: 28,
              height: 28,
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark) — same rule as
              // BuildBadge.
              color: "text.secondary",
              fill: "currentColor"
            },
            children: /* @__PURE__ */ p.jsx("path", { d: "m60.84 823.92h1078.4v-49.801h-1078.4zm0-99.48h1078.4v-49.801h-1078.4zm1078.3-398.16v-49.801h-1078.3v348.61h1078.4v-49.801l-647.16-0.003906v-49.801h647.04v-49.801h-647.04v-49.801h647.04v-49.801h-647.04v-49.801zm-718.92 0.95703 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.238 6.3633 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm12.363 107.52-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.719-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.883-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.8398-9.7227 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-32.16-93.121 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68zm283.8-11.398-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.598-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-28.32-58.199-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.562 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2773-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-26.043 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.3984-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-25.922 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.4023-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm199.56-81.48 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.8359 13.801-2.0391zm-42.117-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.363-6.4766-12.359 6.4805 2.3984-13.68-9.957-9.8398zm0 69.602 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9648 9.7227 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7227zm18.477 95.16-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.957-9.8398 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.637-41.281-12.238 6.3594 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2812-83.398 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.598 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-405.36 606.96h1078.4v-49.801h-1078.4z" })
          }
        ),
        /* @__PURE__ */ p.jsx(
          fe,
          {
            sx: {
              mt: "1px",
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: 1.15,
              letterSpacing: "0.2px",
              textAlign: "center",
              textTransform: "uppercase",
              whiteSpace: "normal",
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark).
              color: "text.secondary"
            },
            children: "Made in the USA"
          }
        )
      ]
    }
  );
}
function sm({ testId: e = "badge-footer" }) {
  return /* @__PURE__ */ p.jsx(
    fe,
    {
      component: "footer",
      "data-testid": e,
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: 2
      },
      children: /* @__PURE__ */ p.jsx(Ip, { variant: "static" })
    }
  );
}
const kp = "5432";
function im({
  pin: e = kp,
  onUnlock: t,
  testId: n = "pin-lock",
  ariaLabel: s = "Unlock"
}) {
  const [r, i] = V(!1), [o, a] = V(""), [u, c] = V(!1), l = bt(null);
  return _e(() => {
    r || (a(""), c(!1));
  }, [r]), _e(() => {
    if (!r || o.length !== e.length) return;
    const d = setTimeout(() => {
      o === e ? (i(!1), t == null || t()) : (c(!0), setTimeout(() => {
        var h;
        a(""), c(!1), (h = l.current) == null || h.focus();
      }, 600));
    }, 80);
    return () => clearTimeout(d);
  }, [o, r, e, t]), /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      zr,
      {
        onClick: () => i(!0),
        "aria-label": s,
        "data-testid": n,
        sx: {
          position: "fixed",
          bottom: 12,
          right: 12,
          zIndex: 1300,
          // #628 — discreet, but actually findable and tappable: a scribe has to
          // hit it on a tablet when an admin walks over, so it can't be a 16px
          // ghost. Themed text color reads on both light and dark backgrounds.
          color: "text.secondary",
          bgcolor: "background.paper",
          border: 1,
          borderColor: "divider",
          width: 40,
          height: 40,
          "&:hover": { bgcolor: "action.hover" }
        },
        children: /* @__PURE__ */ p.jsx(pl, { sx: { fontSize: 20 } })
      }
    ),
    /* @__PURE__ */ p.jsxs(
      xr,
      {
        open: r,
        onClose: () => i(!1),
        maxWidth: "xs",
        fullWidth: !0,
        children: [
          /* @__PURE__ */ p.jsx(Cr, { children: /* @__PURE__ */ p.jsx(fe, { sx: { pt: 1 }, children: /* @__PURE__ */ p.jsx(
            bn,
            {
              inputRef: l,
              autoFocus: !0,
              fullWidth: !0,
              type: "password",
              value: o,
              onChange: (d) => (
                // Strip non-digits + cap to PIN length so paste-overflow
                // doesn't sneak past the auto-submit threshold.
                a(
                  d.target.value.replace(/\D/g, "").slice(0, e.length)
                )
              ),
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: e.length,
                style: {
                  textAlign: "center",
                  fontFamily: "monospace",
                  fontSize: 24,
                  letterSpacing: 8
                }
              },
              error: u,
              helperText: u ? "Wrong PIN" : " "
            }
          ) }) }),
          /* @__PURE__ */ p.jsx(Js, { children: /* @__PURE__ */ p.jsx(rt, { color: "inherit", onClick: () => i(!1), children: "Cancel" }) })
        ]
      }
    )
  ] });
}
function om(e, t, n = [], s = !0) {
  const [r, i] = V({ data: null, loading: !0, error: null }), [o, a] = V(!1), [u, c] = V(0);
  _e(() => {
    let d = !1;
    return (async () => {
      let h;
      try {
        h = await e();
      } catch {
        h = void 0;
      }
      const f = h != null;
      if (!d && f && i({ data: h, loading: !1, error: null }), s)
        try {
          const w = await t();
          d || i({ data: w, loading: !1, error: null });
        } catch (w) {
          !d && !f && i({ data: null, loading: !1, error: w });
        } finally {
          d || a(!1);
        }
      else
        !d && !f && i({ data: null, loading: !1, error: null }), d || a(!1);
    })(), () => {
      d = !0;
    };
  }, [...n, s, u]);
  const l = Ft(() => {
    a(!0), c((d) => d + 1);
  }, []);
  return { ...r, refetch: l, refreshing: o };
}
function am(e, t = []) {
  const [n, s] = V({ data: null, loading: !0, error: null });
  return _e(() => {
    let r = !1;
    return s({ data: null, loading: !0, error: null }), e().then((i) => {
      r || s({ data: i, loading: !1, error: null });
    }).catch((i) => {
      r || s({ data: null, loading: !1, error: i });
    }), () => {
      r = !0;
    };
  }, t), n;
}
function Pp({ clientId: e, cognitoDomain: t, logoutUri: n }) {
  if (e && t && n) {
    const s = `https://${t}/logout?client_id=${e}&logout_uri=${encodeURIComponent(n)}`;
    window.location.replace(s);
  }
}
function um() {
  const { mode: e, setMode: t } = Na();
  return { mode: e, toggleTheme: () => {
    t(e === "dark" ? "light" : "dark");
  } };
}
function cm({ t: e, mode: t, toggleTheme: n, navigate: s, cognitoConfig: r, settingsLink: i = "/settings" }) {
  return [
    {
      icon: /* @__PURE__ */ p.jsx(Da, {}),
      text: e("navigation.homeLink"),
      onClick: () => s("/")
    },
    {
      icon: /* @__PURE__ */ p.jsx(Fa, {}),
      text: e("navigation.settingsLink"),
      onClick: () => window.location.href = i
    },
    {
      icon: t === "dark" ? /* @__PURE__ */ p.jsx(za, { fontSize: "small" }) : /* @__PURE__ */ p.jsx($a, { fontSize: "small" }),
      text: e(t === "dark" ? "navigation.theme.switchToLightMode" : "navigation.theme.switchToDarkMode"),
      onClick: n
    },
    {
      icon: /* @__PURE__ */ p.jsx(qa, {}),
      text: e("navigation.logoutLink"),
      onClick: () => Pp(r)
    }
  ];
}
const jp = "Server Error";
let Pa = !1;
function lm(e = vl) {
  Pa || (Pa = !0, e.interceptors.response.use(
    (t) => t,
    (t) => {
      var r, i, o;
      const n = (r = t == null ? void 0 : t.response) == null ? void 0 : r.data, s = ((i = n == null ? void 0 : n.data) == null ? void 0 : i.message) || (n == null ? void 0 : n.message) || (n == null ? void 0 : n.error) || (n == null ? void 0 : n.code) || (t == null ? void 0 : t.message);
      return console.error("[api error]", (o = t == null ? void 0 : t.response) == null ? void 0 : o.status, s, n), t && (t.serverErrorDetail = s, t.message = jp), Promise.reject(t);
    }
  ));
}
export {
  bl as AccountMenu,
  Mv as ActiveOrgProvider,
  $v as ActiveShowProvider,
  wl as AppBar,
  Rv as AppFooter,
  xv as AppLayout,
  sm as BadgeFooter,
  rm as BuildBadge,
  Ev as CallbackPage,
  Tv as CognitoAuthProvider,
  _v as ConfirmButton,
  qt as DEFAULT_VENUE_TIMEZONE,
  Ws as FullScreenLoader,
  Vv as GateHeader,
  Fv as ItemCard,
  kv as LoggedOutPage,
  Pv as LogoutPage,
  Rl as MainContent,
  Gv as MockAuthProvider,
  Zv as MockLoginPage,
  Wv as MockProtectedRoute,
  jv as MuiThemeProvider,
  Av as NavRail,
  Dv as NewItemCard,
  fd as OrgSwitcher,
  Lv as PageLayout,
  qv as PermissionProvider,
  im as PinLock,
  Uv as ProtectedRoute,
  Op as RIDE_STATUS_DISPLAY,
  wh as ReportList,
  Ch as ReportParamsForm,
  jh as ReportViewer,
  Yv as Reports,
  Xv as RideStatusBadge,
  kh as RunHistory,
  yi as SCORE_ENTRY_WIDTH,
  _p as SCORE_FIELD_WIDTH,
  jp as SERVER_ERROR_MESSAGE,
  nm as ScoreEntry,
  ka as ScoreInput,
  zv as ShowSwitcher,
  em as SignatureBox,
  Nv as StyledBreadcrumb,
  Iv as TableSkeleton,
  kp as UNLOCK_PIN,
  Ip as UsaBadge,
  hd as UserDisplayName,
  Cv as basenameFromRedirectUri,
  Ov as beginSignOut,
  Bv as formatVenueTime,
  cm as getDefaultAccountMenuItems,
  lm as installServerErrorInterceptor,
  jl as isCypressTestMode,
  nd as isShowInActiveWindow,
  eo as isSigningOut,
  Pp as logoutCognito,
  Ka as resolveBuildId,
  Qa as resolveVenueTimeZone,
  pn as unwrapReport,
  wi as useActiveOrg,
  od as useActiveShow,
  mh as useApiConfig,
  am as useApiResource,
  om as useCachedResource,
  uu as useMockAuth,
  Hv as usePermission,
  gh as useReportApi,
  Qv as useRideStatuses,
  tm as useSheetSignature,
  um as useThemeSwitcher,
  ld as userDisplayName,
  Jv as userFirstName,
  ed as venueDayKey
};
//# sourceMappingURL=common-fe.js.map
